export default {
    bioDataTable: {
        showing: "Showing",//"展示第",
        to: "to",//"条到第",
        of: "of",//"条的数据 ，共",
        entries: "Entries",//"条数据",
        search: "Search",//"请输入查询的信息",
        operate: "Operate",//"操作",
        noData: "No data",//"暂无数据",
        add: "Create",//"新建",
        addItem: "Add Record",//"添加明细",
        export: "Export",//"导出",
        searchInfo: "Please enter the query information",//"请输入查询的信息",
        uploadFile: "Load Attachment",//"上传附件",
        downloadFile: "Download file",//"下载报告",
        viewReport: "View report",//"查看报告",


    },
    login: {
        login: 'Login',
        forget_password: "忘记密码",
        reset_password: "重置密码",
        bio: "Bio-LIMS",
        bio_serve: "Serving the global precision medicine and innovative bio-pharmaceutical industry",
        bio_scheme: "Full digital solution",
        bio_number: "Digital empowerment · drive change",
        bio_copyright: "The copyright of this system belongs to Beijing Bio-LIMS Software Technology Co., Ltd",
        bio_system: "Predicine Sample Storage Portal",
        in_userName: "Enter one user name",
        in_password: "Please input a password",
        in_oldPassword: "请输入原密码",
        in_newPassword: "请输入新密码",
        in_oldPassword2: "请输入原始密码",
        confirmPassword: "确认新密码",
        confirm: "Confirm",
        cancel: "Cancel",
        in_email: "请输入邮箱",
        in_verificationCode: "请输入验证码",
        verificationCode: "获取验证码",
        userName_null: "账号不能为空",
        password_null: "密码不能为空",
        password_format: "密码格式不正确",
        email_null: "邮箱不存在",
        verificationCode_expire: "验证码已过期",
        password_success: "密码修改成功",
        again: "秒后重新发送",
        verificationCode_success: "验证码发送成功",
        password_same: "密码一致",
        password_noSame: "密码不一致",
        error: "用户名或密码错误请重新输入",

        success: "Login successful",
        oldPasswordError: "原始密码不正确",
        verificationCodeNull: "验证码不能为空",
    },
    //主页
    dashboard: {
        bioChat:"AI智能助手",
        //流程执行待办
        processExecutionToDoList: {
            title: "流程执行待办",
            orderNumber: "订单编号",
            stepName: "步骤名称",
            traceabilityCode: "追溯码",
            operator: "操作人",
            stepNumberumber: "步骤编号",
            operate: "操作",
        }
    },
    //电子病历
    crmPatient: {
        caseHistory: "电子病历",
    },

    BarCodeData: {
        name1: "条码模块",
        homepage: "主页",
        num: "展示第 {first} 条到第 {last} 条的数据 ，共 {totalRecords} 条数据 ",
        num1: "展示第",
        num2: "条到第",
        num3: "条的数据 ，共",
        num4: "条数据",
        newlyBuild: "新建",
        derive: "导出",
        information: "请输入查询的信息",
        id: "编码",
        name: "描述",
        code: "打印指令",
        ip: "IP地址",
        state: "状态",
        operation: "操作",
        effective: "有效",
        invalid: "无效",
        del: "删除选中",
        add: "添加明细",
        roleConfiguration: "权限配置",
        worktableConfiguration: "工作台配置",
        // code:"编码",
        yes: "有效",
        no: "无效",
        updateInfo: "更新成功",
        updateInfo1: "更新失败",
        saveInfo: "保存成功",
        saveInfo1: "保存失败",
        ymnrybg: "页面内容有变更，是否需要保存？",
        pleaseSelect: "请选择",
    },

    //医院管理 原客户管理更名
    // crmCustomer: {
    //     cName: "医院管理"
    // },
    crmCustomerList: {
        homepage: "主页",
        num: "展示第 {first} 条到第 {last} 条的数据 ，共 {totalRecords} 条数据 ",
        num1: "展示第",
        num2: "条到第",
        num3: "条的数据 ，共",
        num4: "条数据",
        newlyBuild: "新建",
        derive: "导出",
        information: "请输入查询的信息",
        id: "客户编号",
        name: "客户名称",
        district: "地区",
        type: "分类",
        street: "地址",
        postcode: "邮编",
        email: "邮箱",
        researchField: "研究领域",
        dutyMan: "负责人",
        phone: "联系电话",
        state: "状态",
        createUser: "创建人",
        createDate: "创建时间",
        downloadTemplate: "下载模板",
        batchImport: "批量导入",
    },
    crmCustomerEdit: {
        cName: "医院管理",
        id: "编号",
        name: "名称",
        district: "地区",
        type: "分类",
        street: "地址",
        postcode: "邮编",
        email: "邮箱",
        researchField: "研究领域",
        dutyMan: "负责人",
        phone: "电话",
        state: "状态",
        createUser: "创建人",
        createDate: "创建时间",
        choose: "请选择分类",
        saveSuccess: "保存成功",
        updateSuccess: "修改成功",
        file: "附件",
        upload: "上传附件",
        view: "查看附件",
        addSuccess: "添加成功",
        uploadSuccess: "上传成功",
        uploadFail: "上传失败",
        download: "下载",
        delete: "删除",
        tips: "请选择一条数据",
        batchAdd: "批量添加",
        nameRequired: "名称不能为空",
        dutyManRequired: "负责人不能为空",
        stateRequired: "状态不能为空",

        downloadTemplate: "下载模板",
        batchImport: "批量导入",

        department: "科室",
        depName: "科室名称",

        pleaseSelect: "请选择数据",
        ifDelete: "是否确认删除？",
        cancel: "您已取消！",
        deleteSuccess: "删除成功",

        searchInfo: "请输入查询的信息",

        fileName: "文件名",
        uploadTime: "上传时间",
        uploadUser: "上传人",

        postCodeError: "请输入正确的邮编",
        emailError: "请输入正确的邮箱",
        phoneError: "请输入正确的电话",

        saveFirst:"请先保存数据",
        departmentNameRequired:"科室名称不能为空",
        hospitalName: "医院",
        //送检医院
        hospital: "送检医院",
    },
    crmCustomerPublic: {
        dictionary: "字典表管理",
        operation: "操作",
    },
    crmCustomerDic: {
        chooseAddr: "请选择地区",
        chooseType: "请选择分类",
        chooseState: "请选择状态",
        chooseUser: "请选择用户",
        chooseDutyMan: "请选择负责人",
        id: "编号",
        name: "描述",
        cycle: "转换系数",
        post: "岗位",
    },
    crmCustomerTips: {
        message: "确认",
        confirm: "您确定要继续吗？",
        cancel: "您已取消！",
        deleteSuccess: "删除成功",
    },

    //医生管理
    // customerDoctor: {
    //     cName: "医生管理"
    // },
    // customerDoctorList: {
    //     id: "编号",
    //     name: "姓名",
    //     crmCustomer: "所属医院/机构",
    //     crmCustomerDepartment: "所属科室",
    //     phone: "联系电话",
    //     email: "邮箱",
    //     lookType: "就诊特点",
    //     goodAt: "擅长疾病/科研领域",
    //     doctorDesc: "医生简介",
    //     state: "状态",
    // },
    customerDoctorEdit: {
        cName: "医生管理",
        id: "编号",
        name: "姓名",
        crmCustomer: "所属医院/机构",
        crmCustomerDepartment: "所属科室",
        phone: "联系电话",
        email: "邮箱",
        lookType: "就诊特点",
        goodAt: "擅长疾病/科研领域",
        doctorDesc: "医生简介",
        state: "状态",

        customerName: "医院名称",
        district: "地区",
        address: "地址",
        researchField: "研究领域",

        departmentName: "科室名称",

        saveSuccess: "保存成功",
        updateSuccess: "修改成功",
        choose: "请选择一条数据！",
        choose2: "请选择所属科室",
        phoneError: "请输入正确的联系电话",
        emailError:"请输入正确的邮箱",
        nameRequired: "姓名不能为空",
        crmCustomerRequired: "所属医院或机构不能为空",
        stateRequired: "状态不能为空",
    },

    //培训计划


    trainingRecordList: {
        id: "培训编号",
        trainingPlan: "培训计划",
        description: "描述",
        trainTyte: "培训类型",
        applicant: "申请人",
        stateName: "状态",
        createDate: "创建时间",

    },
    //培训记录基本信息
    trainingRecordEdit: {
        id: "培训编号",
        trainingId: "培训计划编号",
        trainingName: "描述",
        trainingType: "培训类型",
        trainingModus: "培训方式",
        trainingEffectiveness: "培训时效",
        trainingRemind: "提醒天数（天）",
        trainingDuration: "培训时长（小时）",
        createUser: "申请人",
        createDate: "创建时间",
        confirmUser: "批准人",
        trainingTeacher: "培训讲师",
        note: "备注",
        stateName: "状态",
        startTrain: "是否开始培训",
        startTrainYes: "开始培训",
        KnowledgeCenter: "知识中心",
        File: "文档",
        attachment: "附件",
        trainingGroup: "培训组",
        trainingEndDate: "培训完成日期",
        assess: "是否考核",
        assessResult: "考核结果",
        department: "所属部门",
        trainingMaterials: "培训资料",
        chooseData: "请选择资料",
        chooseConfirmUser: "请选择批准人",
        chooseTrainingGroup: "请选择培训组",
        chooseTrainer: "请选择培训人",
        chooseFileType: "请选择添加文件的类型",
        confirmDate: "批准日期",
        chooseFile: "请选择文档",
        trainingDate: "培训日期",
    },
    //培训明细
    trainingRecordDetail: {
        fileId: "资料编号",
        fileDetail: "资料明细",
        participant: "姓名",
        createDate: "培训时间",
        trainingEndDate: "培训结束时间",
        assess: "是否考核",
        assessResult: "考核结果",
        department: "所属部门",
        delDetails: "删除明细",
        dataBinding: "资料绑定",
        viewDate: "查看资料",
        trainingRecordDetail: "培训明细",
    },
    //考题
    trainingRecordQuestion: {
        questionCode: "考题编号",
        questionData: "考题归属资料",
        fileId: "资料编号",
        fileName: "资料名称",
        options: "选项",
        questionType: "考题类型",
        trainingEffectiveness: "标准答案",
        questionContent: "题目内容",
        answerOptions: "答案选项",
        addOption: "添加选项",
        trainingRecordQuestion: "考题",
        viewQuestion: "查看考题",
    },
    //考核
    trainingRecordAnswer: {
        trainingRecordAnswer: "考核",
        questionCode: "考题编号",
        fileId: "资料编号",
        fileName: "资料名称",
        questionContent: "题目",
        subQuestionContent: "提交题目",
        questionType: "考题类型",
        options: "选项",
        participant: "姓名",
        assessmentAnswer: "答案",
        achievement: "成绩",
        answer: "回答",
    },

    order: {
        selectProduct: "可选择产品",
        selectedProduct: "已选择产品"
    },
    appBreadcrumb: {
        welcome2: "Welcome",
    },
    documentation: {
        workbench: "工作台",
        homepage: "主页",
    },
    SampleCenterAbnormalItemList: {
        sampleCode: "原始样本编号",
        code: "样本编号",
        patientName: "姓名/名称",
        dicSampleType: "样本类型",
        orderId: "任务单ID",
        productName: "产品名称",
        sourceTable: "来源表",
        method: "结果",
        note: "备注",
        state: "状态",
        createUser: "创建人",
        createDate: "创建时间",
        handleUser: "处理人",
        handleDate: "处理时间",
        newlyBuild: "新建",
        derive: "导出",
        SaveAndExecute: "保存并执行",
        information: "请输入查询的信息",
        CommunicationResult: "沟通结果",
        ContinueTheExperiment: "继续实验",
        AbortTheExperiment: "终止实验"
    },
    SampleCenterAbnormalItemPublic: {
        AbnormalSampleManagement: "异常反馈",
    },
    SampleCenterSampleAbnormalList: {
        id: "原始样本编号",
        patientName: "姓名/名称",
        dicSampleType: "样本类型",
        itemId: "任务单ID",
        productId: "产品编号",
        nextFlow: "下一步流向",
        method: "结果",
        state: "状态名称",
        note: "备注",
        createUser: "创建人",
        createDate: "创建时间",
        handleUser: "处理人",
        handleDate: "处理时间",
        operation: "操作",
        save: "保存",
        derive: "导出",
        SaveAndExecute: "保存并执行",
        NextFlowDirection: "下一步流向",
        SampleCode: "原始样本编号",
        Code: "样本编号",
        OrderId: "样本接收编号",
        CommunicationResult: "沟通结果",
        ContinueTheExperiment: "项目组已处理（继续实验）",
        AbortTheExperiment: "项目组已处理（终止实验）"
    },
    SampleCenterSampleAbnormalPublic: {
        ReceiveSampleManagement: "接收样本异常",
    },
    SampleCenterSampleStatePublic: {
        SampleProgress: "样本进度",
    },
    SampleCenterSampleMasterDataPublic: {
        SampleMasterData: "样本主数据",
    },
    SampleCenterSampleMasterDataList: {
        derive: "导出",
        information: "请输入查询的信息",
        operation: "操作",
        code: "样本编号",
        sampleType2: "样本类型",
        stateName: "状态名称",
        sampleOrder: "订单号",
        idCard: "外部样本编号",
        patientName: "姓名/名称",
        productName: "产品名称",
        sequenceFun: "科研项目名称",
        hospital: "医疗机构",
        crmDoctor: "医生名称",
        sellPerson: "销售",
        dicType: "采样部位",
        patientId: "电子病历编号",
        samplingDate: "采样时间",
        unit: "单位",
        sendReportDate: "发送报告时间",
        receiveDate: "接收时间",
        createDate: "创建时间",
        createUser: "创建人",
        noData: "没有数据",
        Dataing: "加载数据中",
        sampleNum: "接收样本数量",
        productId: "产品编号",
        reportDate: "应出报告时间",
        note: "备注",
        SampleSituation: "样本情况",
        InventoryInformation: "库存信息",
        SampleTracking: "样本追踪",
    },
    SampleCenterSampleMasterListRight: {
        id: "样本编号",
        code: "原始样本编号",
        sampleCode: "样本编号",
        productName: "产品名称",
        startDate: "开始时间",
        endDate: "结束时间",
        stageName: "阶段名称",
        acceptUser: "操作人",
        taskMethod: "执行处理方式",
        taskResult: "执行结果",
        taskId: "执行单ID",
        note: "备注",

        code2: "样本编号",
        sampleType2: "原始样本编号",
        stateName: "样本类型",
        productId: "入库量",
        sampleOrder: "样本位置",
        idCard: "备注",
    },
    SampleCenterSampleMasterDataEdit: {
        noData: "没有数据",
        Dataing: "加载数据中",
        save: "保存",
        列表: "列表",
        code: "原始样本编号",
        sampleType2: "样本类型",
        patientName: "姓名",
        dicType: "采样部位",
        idCard: "外部样本编号",
    },
    SampleCenterClinicalReceiveList: {
        add: "新增",
        derive: "导出",
        information: "请输入查询的信息",
        operation: "操作",
        id: "接收编号",
        acceptDate: "接收时间",
        itemCodes: "样本编号",
        name: "描述",
        stateName: "状态名称",
        itemBarCodes: "条形码",
        createDate: "创建时间",
        createUser: "创建人",
        List: "临床样本接收"
    },
    SampleCenterResearchReceiveList: {
        add: "新增",
        derive: "导出",
        information: "请输入查询的信息",
        operation: "操作",
        id: "接收编号",
        acceptDate: "接收时间",
        itemCodes: "样本编号",
        name: "描述",
        stateName: "状态名称",
        itemBarCodes: "条形码",
        createDate: "创建时间",
        createUser: "创建人",
        List: "科研样本接收",
        ProjectId: "项目编号",
        ProjectName: "项目名称",
    },
    SampleCenterClinicalReceivePublic: {
        ClinicalSampleReception: "临床样本接收",
        ClinicalSampleReceiveTemplate: "临床样本接收模板"
    },
    SampleCenterResearchReceivePublic: {
        ResearchSampleReception: "科研样本接收",
        ResearchSampleReceiveTemplate: "科研样本接收模板"
    },
    SampleCenterClinicalReceiveEdit: {
        saveOrUpdate: "保存",
        back: "列表",
        state: "状态",

        id: "接收单编号",
        acceptUser: "接收人",
        name: "描述",
        expressNum: "快递单号",
        expressCompany: "快递公司",
        taTraffic: "运输方式",
        acceptDate: "接收时间",
        selectedConfirmUser: "审核人",
        choose: "上传附件",
        dowlod: "查看附件",
        saoma: "扫码",
        uolod: "上传文件",
        txm: "条形码",
        editSample: "编辑样本信息",
        deleteSample: "删除选中",
        operation: "操作",
        noData: "没有数据",
        Dataing: "加载数据中",
        qingxuanze: "请选择一条记录！",

        type: "请选择类别",
        queren: "确认",
        yanzheng: "验证",
        username: "用户名",
        password: "密码",
        reason: "原因",

        kdgx: "快递公司",
        phone: "联系电话",
        address: "地址",
        note: "备注",
        printPath: "打印路径",

        user: "姓名",

        sampleCode: "样本编号",
        orderCode: "订单编号",
        barCode: "条形码",
        tagNum: "标签打印份数",
        productName: "产品名称",
        gender: "性别",
        patientName: "姓名",
        dicSampleType: "样本类型",
        source: "数据来源",
        samplingDate: "采样时间",
        periodOfValidity: "有效期（天）",
        expirationDate: "到期时间",
        species: "采样部位",
        sampleNum: "采样量",
        unit: "单位",

        emrid: "电子病历编号",
        familyId: "家系编号",
        isGood: "是否正常",
        method: "结果",
        nextFlow: "下一步流向",
        dataTraffic: "数据通量（GB）",
        posId: "样本位置",
        counts: "板号",
        createUser: "创建人",
        createDate: "创建时间",
        yblx: "样本类型",
        bmbj: "编码标记",
        cyl: "采样量",
        cydw: "采样单位",
        dzid: "电子病历编号",
        xb: "性别",
        csrq: "出生日期",
        nl: "年龄",
        customer: "送检医院",
        ksName: "科室",
        customerDoctor: "医生名称",
        race: "民族",
        telphoneNumber1: "联系电话",
        familyHistoryOfCancertext: "家系编号",
        email: "邮箱",
        placeOfBirth: "籍贯",
        idCard: "身份证号",
        jxid: "家系类型ID",
        hospitalName: "医院",
        ysfs: "运输方式",
        dzbl: "电子病历",
        ChooseProducts: "选择产品",
        ChooseSampleType: "选择样本类型",
        ChooseUnit: "选择单位",
        ChooseNextFlow: "选择下一步流向",
        ChooseTransportType: "选择运输方式"
    },
    SampleCenterResearchReceiveEdit: {
        saveOrUpdate: "保存",
        back: "列表",
        state: "状态",

        id: "接收单编号",
        acceptUser: "接收人",
        name: "描述",
        expressNum: "快递单号",
        expressCompany: "快递公司",
        taTraffic: "运输方式",
        acceptDate: "接收时间",
        selectedConfirmUser: "审核人",
        choose: "上传附件",
        dowlod: "查看附件",
        saoma: "扫码",
        uolod: "上传文件",
        txm: "条形码",
        editSample: "编辑样本信息",
        deleteSample: "删除选中",
        operation: "操作",
        noData: "没有数据",
        Dataing: "加载数据中",
        qingxuanze: "选择快递公司",

        type: "请选择类别",
        queren: "确认",
        yanzheng: "验证",
        username: "用户名",
        password: "密码",
        reason: "原因",

        kdgx: "快递公司",
        phone: "联系电话",
        address: "地址",
        note: "备注",
        printPath: "打印路径",

        user: "姓名",

        sampleCode: "样本编号",
        orderCode: "订单编号",
        barCode: "条形码",
        tagNum: "标签打印份数",
        productName: "产品名称",
        gender: "性别",
        patientName: "姓名",
        dicSampleType: "样本类型",
        source: "数据来源",
        samplingDate: "采样时间",
        periodOfValidity: "有效期（天）",
        expirationDate: "到期时间",
        species: "采样部位",
        sampleNum: "采样量",
        unit: "单位",

        emrid: "电子病历编号",
        familyId: "家系编号",
        isGood: "是否正常",
        method: "结果",
        nextFlow: "下一步流向",
        dataTraffic: "数据通量（GB）",
        posId: "样本位置",
        counts: "板号",
        createUser: "创建人",
        createDate: "创建时间",
        yblx: "样本类型",
        bmbj: "编码标记",
        cyl: "采样量",
        cydw: "采样单位",
        dzid: "电子病历编号",
        xb: "性别",
        csrq: "出生日期",
        nl: "年龄",
        customer: "送检医院",
        ksName: "科室",
        customerDoctor: "医生名称",
        race: "民族",
        telphoneNumber1: "联系电话",
        familyHistoryOfCancertext: "家系编号",
        email: "邮箱",
        placeOfBirth: "籍贯",
        idCard: "身份证号",
        jxid: "家系类型ID",
        hospitalName: "医院",
        ysfs: "运输方式",
        dzbl: "电子病历",
        ChooseProducts: "选择产品",
        ChooseSampleType: "选择样本类型",
        ChooseProject: "选择项目",
        ChooseProjectOrder: "选择项目订单",
        ChooseUnit: "选择单位",
        ChooseNextFlow: "选择下一步流向",
        ChooseTransportType: "选择运输方式",
        BatchFillData: "批量填写"
    },
    SampleCenterSampleStateList: {
        SampleNumber: "样本编号",
        SampleReception: "样本接收",
        SampleProcessing: "样本处理",
        PathologicalExperiments: "病理实验",
        AccountingExtraction: "核酸提取",
        PlatformInCharge: "分管平台",
        libraryConstruction: "文库构建",
        enrichment: "富集",
        LibraryMixing: "文库混合",
        SuperiorSequencing: "上机测序",
        StreamingPreTreatment: "流式预处理",
        FlowOnMachineDetection: "流式上机检测",
        MassSpectrometryExperiment: "质谱实验",
        OfflineQualityControl: "下机质控",
        SangerExperiment: "Sanger实验",
        QPCR: "QPCR",
        COVNucleicAcidAmplification: "COV核酸扩增",
        report: "报告",
        COVReport: "COV报告",
    },
    universalButton: {
        save: "保存",
        back: "列表",
        items: "导航",
        submit: "提交",
        state: "状态",
        saveAnd: "保存并执行",
        List: "列表",
        Cancel: "取消",
        Modify: "修改",

        //订单信息
        orderInfo: "批量操作",

        //附件
        upload: "上传附件",
        view: "查看附件",
        handle:"办理",
        release:"发布",
        // 选择历史版本
        chooseHistoryVersion: "选择历史版本",
    },
    UserData: {
        user: "用户管理",
        homepage: "主页",
        num: "展示第 {first} 条到第 {last} 条的数据 ，共 {totalRecords} 条数据 ",
        num1: "展示第",
        num2: "条到第",
        num3: "条的数据 ，共",
        num4: "条数据",
        newlyBuild: "新建",
        derive: "导出",
        information: "请输入查询的信息",
        username: "用户名",
        name1: "姓名",
        gender: "性别",
        birth: "出生日期",
        phone: "联系电话",
        inDate: "入职日期",
        departmentId: "部门ID",
        departmentId1: "所属部门ID",
        departmentName: "所属部门",
        area: "所属片区",
        city: "所属城市",
        scope: "成本中心",
        state: "状态",
        operation: "操作",
        createTime: "创建日期",
        onJob: "在职",
        lock: "锁定",
        invalid: "无效",
        depart: "离职",
        id1: "组织机构编号",
        levelId: "上级组织机构编号",
        upDepartment: "上级组织机构",
        chooseDept: "请选择数据！",
        briefName: "组织机构简称",
        name: "组织机构名称",
        valid: "有效",
        address: "地址",
        note: "备注",
        password: "密码",
        operatingPassword: "操作密码",
        maturityDate: "失效日期",
        contactMethod: "联系电话",
        email: "电子邮箱",
        cardNo: "身份证号",
        scopeName: "成本中心",
        xgmmDateTime: "记录密码强制修改时间",
        role: "用户权限",
        choose: "选择",
        group: "人员组",
        type: "请选择类别",
        man: "男",
        girl: "女",
        state1: "在职",
        state2: "锁定",
        state3: "无效",
        state4: "离职",
        shanghai: "上海",
        beijing: "北京",
        roleId: "角色编号",
        roleName: "角色名称",
        description: "说明",
        groupId: "人员组编号",
        groupNmae: "人员组名称",
        description2: "描述",
        educationlevel: "教育程度",
        graduationInstitution: "毕业院校",
        emergencyContact: "紧急联系人",
        emergencyContactInformation: "紧急联系方式",
        certificationExperience: "认证经历",
        vaccination: "疫苗接种",
        uploadAttachments: "上传附件",
        viewAttachments: "查看附件",
        trainingExperience: "培训经历",
        addDetail: "添加明细",
        unknown: "未知",
        tip1:"请选择一条数据再查看",
        tip2:"请选择一条数据再上传",
        tip3:"上传成功",
        tip4:"上传失败",
        tip5:"请勿添加重复数据",
        tip6:"请选择一条数据",
        tip7:"请先保存基本信息",
        tip8:"保存成功",
        tip9:"保存失败",
        tip10:"请输入用户名",
        tip11:"请输入姓名",
        tip12:"请输入密码",
        tip13:"请输入性别",
        tip14:"请输入失效日期",
        tip15:"请输入状态",
        tip16:"用户名请输入字母数字组合",
        tip17:"邮箱格式错误",
        tip18:"联系电话格式错误",
        tip19:"紧急联系方式格式错误",
        tip20:"请填写出生日期",
        tip21:"请选择部门",
        tip22:"请选择用户类型",
        tip23:"出生日期应该小于当前日期",
        tip24:"培训开始时间应早于培训结束时间",
        tip25:"培训结束时间应该晚于培训开始时间",
        incumbency: "在职",
        dimission: "离职",
        userNumber: "用户编号:",
        recordPassword: "上次密码修改时间",
        experimentTemplate: "实验模板授权",
        equipment: "设备授权",
        instrumentName: "仪器名称",
        instrumentTypeName: "仪器类型名称",
        creator: "创建人",
        creationTime: "创建时间",
        templateNumber: "模版编号",
        templateName: "模版名称",
        experimentType: "实验类型",
        experimentGroup: "实验组",
        experimentTemplateNumber: "实验模板编号",
        experimentTemplateName: "实验模板名称",
        experimentType1: "实验类型",
        creator1: "创建人",
        creationTime1: "创建时间",
        templateNumber1: "模版编号",
        templateName1: "模版名称",
        experimentType2: "实验类型",
        experimentGroup1: "实验组",
        experimentTemplateNumber1: "实验模板编号",
        experimentTemplateName1: "实验模板名称",
        experimentType3: "实验类型",
        creator2: "创建人",
        creationTime2: "创建时间",
        experiment: "实验模板授权",
        addDetails: "添加明细",
        device: "设备授权",
        selectExperiment: "请选择数据！",
        selectInstrument: "请选择数据！",
        instrumentName1: "设备类型",
        instrumentTypeName1: "设备类型",
        creator3: "创建人",
        creationTime3: "创建时间",
        templateNumber2: "模版编号",
        templateName2: "模版名称",
        experimentType4: "实验类型",
        experimentGroup2: "实验组",
        experimentTemplateNumber2: "实验模板编号",
        experimentTemplateName2: "实验模板名称",
        experimentType5: "实验类型",
        creator4: "创建人",
        creationTime4: "创建时间",
        templateNumber3: "实验模板编号",
        templateName3: "实验模板名称",
        experimentType6: "实验模板类型",
        experimentGroup3: "实验组",
        experimentTemplateNumber3: "实验模板编号",
        experimentTemplateName3: "实验模板名称",
        experimentType7: "实验类型",
        creator5: "创建人",
        creationTime5: "创建时间",
        userManagement: "用户管理权限更改",
        userManagement1: "用户管理",
        pleaseFill: "请填写必填信息:名字",
        addUser: "新增用户",
        createUserName:"创建人用户名",
        typeId:"设备类型ID",
        certificate:"证书名称",
        certificateNo:"证书编号",
        licenceIssuingAuthority:"发证机关",
        dateOfIssuance:"发证时间",
        periodOfValidity:"有效期",
        vaccineName:"疫苗名称",
        vaccineDate:"接种日期",
        describe:"描述",
        trainingName:"培训名称",
        content:"培训内容",
        trainingStartDate:"培训开始日期",
        trainingEndDate:"培训结束日期",
        fileName: "文件名",
        uploadTime: "文件上传时间",
        uploadUser: "上传人",
        ymnrybg: "页面内容有变更，是否需要保存？",
        pleaseSelect: "请选择",
        userExist: "用户已存在",
        userType: "用户类型",
    },
    universal: {
        noData: "没有数据",
        Dataing: "加载数据中",
        saveSuccess: "保存成功",
    },
    RoleData: {
        role: "角色管理",
        name1: "角色名称",
        note: "说明",
        state: "状态",
        effective: "有效",
        invalid: "无效",
        del: "删除选中",
        add: "批量添加",
        roleConfiguration: "权限配置",
        worktableConfiguration: "工作台配置",
        chooseUser: "请选择数据！",
        username: "用户名",
        name: "姓名",
        email: "电子邮箱",
        address: "地址",
        department: "部门",
        // name:"姓名",
        //配置信息
        configurationInformation: "配置信息",
        addDetail: "添加明细",
        tip1: "该用户已添加，请勿重复添加！",
        tip2: "请选择一条数据",
        tip3: "存在用户已添加，请勿重复添加！",
        tip4: "请先输入角色编号后保存",
        tip5: "角色编号不能为空",
        tip6: "角色名称不能为空",
        tip7: "状态不能为空",
        tip8: "角色编号重复",
        save1: "保存成功",
        save2: "保存失败",
        add1: "选择模块",
        user: "用户",
        roleId: "角色编号",
        roleName: "角色名称",
        description: "说明",
        ymnrybg: "页面内容有变更，是否需要保存？",
        pleaseSelect: "请选择",
    },
    UserGroupData: {
        group: "人员组管理",
        effective: "有效",
        invalid: "无效",
        code: "编码",
        modular: "模块",
        modular1: "请选择数据！",
        chooseModular: "请选择模块",
        choosedModular: "已选择模块",
        determine: "确定",
        confirmState: "是否为审核人",
        createUser: "创建人",
        createDate: "创建时间",
        name: "名称",
        note: "说明",
        user: "用户",
        addDetail: "添加明细",
        workflow: "模块名",
        field: "字段",
        tip1: "请填写编码",
        tip2: "请填写人员组名称",
        tip3: "请填写状态",
        tip4: "编码重复",
        tip5: "请先保存",
        tip6: "请勿添加重复数据",
        tip7: "请选择一条数据",
        tip8: "请选择用户",
        save1: "保存成功",
        save2: "保存失败",
        groupName: "人员组名称",
        description: "说明",
        state: "状态",
        add1: "选择模块",
        add: "批量添加",
        username: "用户名",
        name1: "姓名",
        department: "部门",
        email: "电子邮箱",
        address: "地址",
        ymnrybg: "页面内容有变更，是否需要保存？",
        pleaseSelect: "请选择",
        //请先保存
        isSave: "请先保存",
    },
    UnitDictionaryData: {
        dictionary: "单位字典管理",
        seqencing: "排序号",
        pxhbnwk: "排序号必须是正整数",
        save1: "保存成功",
        save2: "保存失败",
        save: "保存",
        name: "名称",
        createUser: "创建人",
        createDate: "创建时间",
        namebnwk: "名称不能为空",
        pxhbnwkNotNUll: "排序号不能为空",
    },
    UnitGroupData: {
        unitGroup: "单位组",
        code: "编号",
        description: "描述",
        coefficient: "转换系数",
        mainUnit: "主单位",
        deputyUnit: "副单位",
        subUnit: "子单位",
        state: "状态",
        effective:"有效",
        invalid:"无效",
        tip1:"转换系数不能为空",
        tip2:"转换系数必须为正整数",
        tip3:"主单位不能为空",
        tip4:"副单位不能为空",
        save1:"保存成功",
        save2:"保存失败",
        tip5:"描述不能为空",
        tip6:"状态不能为空",
        chooseUnit: "请选择数据！",
        id: "编号",
        name: "描述",
        cycle: "转换系数",
        post: "岗位",
        supplier: "供应商",
        name1: "名称",
        note: "说明",
        ymnrybg: "页面内容有变更，是否需要保存？",
        pleaseSelect: "请选择",
    },
    OrganizationData: {
        organization: "组织机构管理",
        id: "组织机构编号",
        briefName: "组织机构简称",
        name: "组织机构名称",
        upDepartment: "上级组织机构",
        state: "状态",
        address: "地址",
        note: "备注",
        choose: "请选择数据！",
        post: "岗位",
        abbreviation: "请填写组织机构简称",
        organizationName: "请填写组织机构名称",
        chooseState: "请选择组织机构状态",
        chooseId: "请填写组织机构编号",
        user: "用户",
        tip:"组织机构编号重复",
        save1:"保存成功",
        save2:"保存失败",
        pleaseChoose:"请选择数据！",
        batchAdd:"批量添加",
        addUser:"添加用户",
        tip1:"请先保存组织机构信息",
        newlyBuild: "新建",
        levelId: "上级组织机构编号",
        operation: "操作",
        valid: "有效",
        invalid: "无效",
        username: "用户名",
        name1: "姓名",
        department: "部门",
        ymnrybg: "页面内容有变更，是否需要保存？",
        pleaseSelect: "请选择",
        //不能选择自己
        notChooseSelf: "不能选择本部门",
        //请选择一条数据
        chooseOneData: "请至少选择一条数据",
    },
    ConfigurationData: {
        configuration: "系统配置",
        functionCode: "配置内容",
        sort: "排序号",
        name: "名称",
        note: "说明",
        state: "状态",
        createUser: "创建人",
        createUserId: "创建人编号",
        createDate: "创建时间",
        save: "保存",
        effective: "有效",
        invalid: "无效",
        successfullySaved: "保存成功",
        saveFailed: "保存失败",
        functionCode1: "功能码",
    },
    DictionaryList: {
        dictionary: "字典管理",
        sort: "排序号",
        tip1:"排序号必须是正整数",
        tip2:"修改成功",
        tip3:"修改失败",
        tip4:"添加成功",
        tip5:"添加失败",
        tip6:"确定要删除该数据吗？",
        tip7:"删除成功",
        tip8:"删除失败",
        search:"请输入查询的名称信息",
        tip9:"功能码不能为空",
        tip10:"名称不能为空",
        tip11:"状态不能为空",
        functionCode1: "功能码",
        name: "名称",
        description: "说明",
        seqencing: "排序号",
        state: "状态",
        valid: "有效",
        invalid: "无效",
        createUser: "创建人",
        createDate: "创建时间",
        operation: "操作",
        confirm: "确定",
        pleaseSelect: "请选择！",
        num1: "展示第",
        num2: "条到第",
        num3: "条的数据 ，共",
        num4: "条数据",
    },
    MasterdataSampletype: {
        sampleType: "样本类型",

        orderNumber: "排序号",
        createUser: "创建人",
        createDate: "创建时间",
        completed: "完成",
        new: "新建",
        note: "说明",
        effective: "有效",
        information: "请输入查询的信息",



        id: "类型编码",
        name: "类型名称",
        state: "状态",
        first: "类型",
        picCode: "图标",
        sampleNum: "采样量",
        unit: "采样单位",
        dataVolume: "数据量",
        choose: "请选择一条记录！",
        batchUnit: "批量单位",
        upload: "上传附件",
        view: "查看附件",
        description: "说明",
        code: "样本标签",
        seqencing: "排序号",
        save: "保存",
        back: "列表",

        nail: "指甲",
        bloodCell: "血细胞",
        sperm: "精斑",
        immunohistochemical: "免疫组化片子",
        oralSwab: "口腔拭子",
        semen: "精液",
        dna: "DNA",
        heart: "心脏",
        bloodPrecipitation: "血沉淀",
        hePathological: "HE病理切片",
        urine: "尿液",
        rna: "RNA",
        paraffin: "石蜡",
        formalinSoaked: "福尔马林浸泡组织",
        boneMarrow: "骨髓",
        saliva: "唾液",
        pleuralEffusion: "胸水",
        edtaAnticoagulant: "EDTA抗凝血",
        ffpeWhite: "FFPE白片",
        ffpeRoll: "FFPE卷片",
        externalPlasma: "外部血浆",
        internalSeparation: "内部分离血浆",
        separationLeukocyte: "分离白细胞",
        ascites: "腹水",
        cerebrospinalFluid: "脑髓液",
        blood: "血液",
        freshTissue: "新鲜组织",
        valid: "有效",
        invalid: "无效",
        name1: "名称",
        saveInfo: "保存成功",
        saveInfo1: "保存失败",
        updateInfo: "更新成功",

        pleaseSelectData: "请选择数据！",
        //类型名称不能为空
        nameNotNull: "类型名称不能为空！",
        //状态不能为空
        stateNotNull: "状态不能为空！",
        //样本标签不能为空
        codeNotNull: "样本标签不能为空！",
        codeLetter: "样本标签只能为字母！",
        // 排序号必须是正整数
        seqencingNotNull: "排序号必须是正整数！",
        //判断采样量是否是正数
        sampleNumNotNull: "采样量必须是正数！",
        pageChangeSave: "页面有变更是否需要保存",
        prompt: "提示",
    },
    experimentTemplatePublic: {
        experimentTemplate: "实验模板",

    }
    , experimentTemplateList: {
        testType: "实验类型",
        stateName: "工作流状态",
        state: "状态",

    }
    , experimentTemplateEdit: {
        code: "编码",
        createDate: "创建时间",
        createUser: "创建人",
        description: "描述",
        information: "基本信息",
        stateName: "工作流状态",
        storageContainer: "容器类型",
        name: "名称",
        days: "实验天数",
        beforeDays: "实验提前预警天数",
        group: "实验组",
        isBlend: "混样",
        state: "状态",
        isSeparate: "是否按位点分样",
        versionNum: "版本号",
        confirmUser: "审核人",
        step: "步骤明细",
        templateFieldsOption: "选择实验明细",
        experimentResultsOption: "选择实验结果",
        selecedSex: "是否生成新样本编号",
        selectedDicSeqencingTypeNameArray: "产物类型",
        chooseReagent: "选择试剂",
        reagent: "试剂",
        templateStepsNum: "单个用量",
        instrument: "仪器",
        choosenIstrument: "选择仪器类型",
        instrumentType: "仪器类型：",
        addSteps: "添加步骤",
        del: "删除",
        step1: "步骤 I",
        table: "表名",
        col: "列名",
        columnComment: "列描述",
        fieldType: "字段类型",
        dataLength: "数据库长度",
        modeltype: "实体名",
        controltype: "控键类型",
        isreadonly: "是否只读",
        colsort: "排序",
        modeltypeclass: "函数名称",
        container: "容器",
        rownum: "行数",
        colnum: "列数",
        formulaConditions: "公式条件",
        templateFieldsResult: "结果字段",
        templateFieldsItem: "结果表字段",
        judge: "判定条件",
        threshold: "阈值",
        logoColor: "组合规格",
        spec: "规格",
        note: "备注",
        experimentalModule: "流程节点",
        tip1:"账号或密码错误",
        itemResultTable: "相关明细结果表",
        saveFirst: "请先保存数据",
        productName: "业务类型",
        // 必填项描述未填写
        descriptionNotNull: "必填项【描述】未填写",

    },
    experimentConfigPublic: {
        experimentConfig: "实验流程配置列表",
        experimentConfigTwo: "实验流程配置"


    },
    experimentConfigEdit: {
        productName: "相关产品",
        start: "开始",
        stepName: "步骤名称",
        judge: "判断",
        end: "结束",

    },
    productMasterList: {
        projectPricing: "项目定价",

    }, ProductMasterData: {
        productMaster: "产品主数据",
        productMaster2: "产品主数据订单内容",
        productMaster3: "产品主数据子产品",

        invalidBtn: "作废",
        effectiveBtn: "生效",
        information: "请输入查询的信息",

        briefName: "简称",
        //描述
        description: "描述",


        id: "编码",
        choose: "请选择隐藏区域",
        chooseFields: "请选择隐藏字段",
        productId: "产品ID",
        productName: "产品名称",
        price: "原价",
        discount: "折扣",
        discountPrice: "折后价格",
        editItem: "编辑明细",
        chooseProduct: "选择产品添加",
        chooseModular: "选择代办数量模块",
        inspectionCycle: "检查周期",
        earlyWarning: "预警周期",
        day: "天",
        identificationCode: "标识码",
        consumption: "用量",
        combinationOptions: "是否组合选项",
        orderContent: "订单内容",
        hiddenArea: "隐藏区域",
        hideFields: "隐藏字段",
        assert: "生效",
        repeal: "作废",
        subproduct: "子产品",
        popupAdd: "弹窗添加",
        popupEditing: "弹窗编辑",
        experimentalConfiguration: "实验配置",
        selectModule: "选择模块",
        selectTemplate: "选择模板",
        yes: "是",
        no: "否",
        hideConfiguration: "自定义隐藏配置",
        templateConfiguration: "模板配置",
        voidTime: "作废时间",
        experimentalTemplate: "实验模板",
        templateName: "模板名称",

        viewFlowChart: "查看流程图",
        selectExperiment: "选择实验",
        selectFlowConfiguration: "选择流程配置",
        //选则成品
        selectProduct: "选择成品",
        flowName: "流程名称",
        name: "名称",
        effective: "有效",
        invalid: "无效",
        subProduct: "子产品",
        experimentConfiguration: "实验配置",
        prompt: "提示",
        pleaseSelectAData: "请选择一条数据",
        tips1: "存在已生效数据，无法生效",
        tips2: "存在作废数据,无法生效",
        tips3: "存在未保存的数据，请先保存",
        tips4: "生效成功",
        tips5: "生效失败",
        tips6: "存在作废状态数据，无法作废",
        tips7: "请先生效",
        tips8: "作废成功",
        tips9: "作废失败",
        tips10: "请先填写基本信息后保存",
        tips11: "保存成功",
        tips12: "保存失败",
        state: "状态",
        createUser: "创建人",
        createDate: "创建时间",
        save: "保存",
        back:"列表",
        items:"导航",
        selectProducts: "选择产品",
        selectTemplates: "选择模板",
        basicInformation: "基本信息",
        code: "编码",
        shortName: "简称",
        experimentalProcess: "实验流程",
        experimentalProcessName: "实验流程名称",
        productionProcessConfiguration: "生产流程配置",
        productionProcessConfigurationName: "生产流程配置名称",
        finishedProduct: "成品",
        yourBrowserDoesNotSupportTheCanvasElement: "如果您的浏览器不支持画布 HTML 元素，则会显示此文本。",
        tableName: "表名",
        columnName: "列名",
        columnDescription: "列描述",
        projectPricing: "项目定价",
        pleaseEnterAPositiveNumber: "请输入一个正数",
        takeEffect: "生效",
        invalid1: "作废",
        identificationCodeCanOnlyBeLetters: "标识码只能为字母",
        //请选择数据！
        pleaseSelectData: "请选择数据！",
        productNameCannotBeEmpty: "名称不能为空",
        productStatusCannotBeEmpty: "状态不能为空",
        workOrderCannotBeEmpty: "实验流程不能为空",
        cooperationProjectCannotBeEmpty: "是否组合选项不能为空",
        warningCycleMustBeAPositiveInteger: "预警周期必须为正整数",
        checkCycleMustBeAPositiveInteger: "检查周期必须为正整数",
        pageChangeSave: "页面有变更是否需要保存",
        //请先选择隐藏字段
        pleaseSelectHiddenFields: "请先选择隐藏字段",


    }, InstrumentData: {
        //校验有效期至
        validDate: "校验有效期至",
        //请输入有效的数字！
        pleaseEnterAValidNumber1: "价格请输入正数数字！",
        //请输入正数！
        pleaseEnterAValidNumber2: "序列号只能由数字和字母组成！",
        //请输入有效的数字！
        pleaseEnterAValidNumber3: "固定资产号只能由数字和字母组成！",
        //安装日期
        installationDate: "安装日期",
        instrument: "仪器数据",
        instrumentNo: "仪器编号",
        instrumentName: "仪器名称",
        type: "类型",
        capitalCode: "型号",
        serialNumber: "序列号",
        supplierNote: "生产商名称",
        supplier: "生产商",
        breed: "类型",
        state1: "状态",
        userCreateUserId: "创建人",
        createDate: "创建时间",
        note: "备注",
        reason: "故障原因",
        effectiveDate: "安装日期",
        pleaseFill: "请输入查询的信息",
        faultReason: "报修原因",
        available: "可用",
        unavailable: "不可用",
        scrap: "报废",
        downloadTemplate: "下载模板",
        batchAdd:"批量导入",
        addSuccess: "添加成功",
        instrumentType: "请选择数据！",
        currency: "币种",
        choose: "请选择数据！",
        accuracy: "级别",
        invoicenumber: "规格型号",
        price: "价格",
        fixedAsset: "固定资产号",
        operationTime: "投用时间",
        manufacturer: "生产商",
        dataVolume: "数据量",
        upload: "上传附件",
        view: "查看附件",
        rmb: "人民币",
        jpy: "日元",
        supplierCode: "供应商编码",
        industry: "行业",
        file: "查看附件",
        fileName: "文件名",
        fuction: "所属模块",
        uploadTime: "文件上传时间",
        uploadUser: "上传人",
        download: "下载",
        previewPicture: "预览(图片)",
        delete: "删除",
        tips: "请选择一条数据",
        dollar: "美元",
        images: "查看图片",
        uploadImages: "上传图片",
        viewImages: "查看图片",
        yytuqsczsc: "已有图片，请先删除后再上传",
        uploadSuccess: "上传成功",
        saveSuccess: "保存成功",
        ymnrybg: "页面内容有变更，是否需要保存？",
        pleaseSelect: "请选择",
        tip1:"价格必须为数字",
        tip2:"仪器名称不能为空",
        tip3:"类型不能为空",
        tip4:"状态不能为空",
        tip5:"部门不能为空",
        tip6:"判断投用时间应大于安装时间",
        state:"状态",
        check:"查看附件",
        organizations:"组织机构编号",
        briefName: "组织机构简称",
        name: "组织机构名称",
        address: "地址",
        operation: "操作",
        departmentName: "部门",
        name1: "名称",
        invalid: "无效",
        valid: "有效",
    },
    storage: {
        storage: "试剂主数据",
    },

    reagentPublic: {
        reagent: "试剂主数据",

    }, reagentList: {
        category: "类别",
        kit: "试剂盒",
        remind: "是否失效提醒",
        amount: "库存数量",
        unit: "单位",

    }
    , reagentEdit: {
        engName: "英文名称",
        inventory: "库存信息",
        inventoryUnit: "库存单位",
        unitGroup: "单位组",
        storageConditions: "存储条件",
        reminder: "提醒提前期",
        quantity: "安全库存数量",
        durabilityDays: "耐用天数",
        deliveryPrice: "出库价格",
        batch: "有批次",
        ul: "瓶-ul",
        batchNo: "批号",
        expirationPeriod: "失效期",
        reminderTime: "提醒时间",
        warehousingTime: "入库时间",
        stock: "本批次存量",
        qc: "qc状态",
        storageLocation: "存储位置",

    }
    , storageInPublic: {
        warehousing: "入库管理",
    }
    , storageInList: {
        information: "入库信息",
        personnel: "入库人员",
        personnel2: "入库人",
    }
    , storageInEdit: {
        masterData: "库存主数据",
        warehousingDetails: "入库明细",
        selectStorage: "选择储位",
        selectUnit: "请选择单位",
        chooseSupplier: "选择供应商",
        printLabel: "打印标签",
        supplier: "供应商",
        expirationTime: "过期时间",
        supplierInformation: "供应商信息",
        verification: "验证",
        reason: "原因",
        ReceiptQuantity: "入库数量",
        number: "副单位数量",
        saveLocation: "保存位置",
        pleaseChoose: "请先选择一条数据!",
    },
    sampleAbmormalPublic: {
        title: "异常样本管理",

    }
    , sampleAbmormalList: {
        chooseNext: "请选择下一步流向",
        next: "下一步流向",
        originalNumber: "原始样本编号",
        name: "姓名/名称",
        sampleType: "样本类型",
        itemId: "任务单ID",
        testItems: "产品名称",
        result: "结果",
        qualified: "合格",
        unqualified: "不合格",
        processed: "已处理",
        untreated: "未处理",
        // 已反馈至项目组
        feedback: "已反馈至项目组",
        processor: "处理人",
        processingTime: "处理时间",
        // 项目组已处理
        processedByProjectTeam: "项目组已处理",

    }
    , orderList: {
        order: "订单",
        orderNo: "订单编号",
        age: "年龄",
        nation: "民族",
        zipCode: "邮编",
        commissioner: "销售",
        nativePlace: "籍贯",
        medicalNumber: "电子病历编号",
        familyCode: "家系编号",
        family: "家属联系人",
        familyPhone: "家属联系人联系方式电话",
        familySite: "家属联系人地址",
        crmCustomer: "医疗机构",
        barcode: "条形码",
        hospitalPatientID: "住院号",
        modifyDate: "修改时间",
        idCard: "身份证号",
        progress: "订单进度",

    },
    orderListEdit: {
        chooseProduct: "选择产品",
        orderInfo: "订单信息",
        baseInfo: "基本信息",
        id: "订单编号",
        createUser: "创建人",
        createDate: "创建时间",
        stateName: "状态",
        name: "姓名",
        gender: "性别",
        age: "年龄",
        birthDate: "出生日期",
        nation: "民族",
        nativePlace: "籍贯",
        medicalNumber: "电子病历编号",
        idCard: "身份证号",
        bedNo: "床号",
        hospitalPatientID: "门诊号/住院号",
        oldId: "原订单编号",
        templateTestType: "家系编号",
        email: "邮箱",
        phone: "手机号",
        note: "备注",
        commissioner: "销售代表",
        confirmUser: "审核人",
        confirmDate: "完成时间",
        productName: "产品信息",
        diagnosis: "临床诊断",
        medicalHistory: "健康状况",
        yongYao: "正在用药情况",
        fspl: "用药频率",
        guomin: "过敏史",
        samplingLocation: "采样部位",
        disease: "疾病",
        familyInfo: "家属信息",
        family: "家属联系人",
        familyPhone: "家属联系电话",
        familySite: "家属住址",
        zipCode: "邮政编码",
        hospitalInfo: "医院信息",
        crmCustomer: "医疗机构",
        inspectionDepartment: "送检科室",
        attendingDoctor: "主治医生",
        attendingDoctorPhone: "主治医生联系方式",
        //代理商协议
        agentAgreement: "代理商协议",
        confirmMoney: "确认收费",
        addItem: "添加明细",
        chooseFinanceUser: "选择财务人员",
        sampleInfo: "样本信息",
        chooseSampleType: "选择样本类型",
        deleteChoose: "删除选中",
        choose: "请选择一条记录！",
        chooseState: "请选择类别",
        confirm: "确认",
        yanzheng: "验证",
        userName: "用户名",
        passward: "密码",
        reason: "原因",
        isFee: "是否收费",
        fee: "付款金额",
        consumptionDate: "付款时间",
        feeWay: "付款方式",
        monthFee: "月结",
        feeNote: "收费说明",
        receipNumber: "收据号",
        posNumber: "POS机号",
        backFeeDate: "退款时间",
        invoiceCode: "发票时号",
        invoiceNumber: "发票抬头",
        invoiceDate: "开票时间",
        alipayNumber: "支付宝号",
        state: "状态",
        financeUser: "财务人员",
        testName: "产品名称",
        commissionerName: "业务员",
        indexa: "家属与患关系",
        sampleCode: "样本编号",
        outSampleCode: "外部样本编号",
        slideCode: "条形码",
        sampleType: "样本类型名称",
        samplingDate: "采样时间",
        receiveUserName: "接收人姓名",
        receiveDate: "接收时间",
        sampleState: "样本状态",
        dateOfBirth: "出生日期",
        customerName: "送检医院",
        doctorDept: "科室",
        customerDoctor: "医生名称",
        race: "民族",
        telphoneNumber1: "联系电话",
        placeOfBirth: "籍贯",
        sampleTypeName: "样本类型",
        code: "编码标记",
        sampleNumber: "采样量",
        unit: "采样单位",
        familyCode: "家系类型ID",
        patientName: "姓名",
        hospitalName: "医院",
        dutyManId: "责任人",
        designation: "名称",
        chooseOneData: "请选择一条数据",
        deleteSuccess: "删除成功",
        mustName: "请填写必填信息:名字",
        updateSuccess: "数据修改成功",
        saveSuccess: "数据保存成功",
        saveFailed: "保存失败",
        apply: "申请",
        delete: "确认删除明细吗?",
        confirmation: "确认",
        cancelOperation: "取消操作",
        SampleReceiveItem: {
            status0: "取消",
            status1: "新建",
            status2: "待接收",
            status3: "已接收",
        }
    }
    , instrumentDataEdit: {
        instrumentData: "仪器使用",
        stageName: "阶段名称(实验名称)",
        operator: "操作人",
        executionId: "执行单id",
        template: "实验模板",
        startTime: "开始时间",
        endTime: "结束时间",
    }
    , chargePlatformEdit: {
        groupNum: "分管号",
        sampleInfoIdCard: "外部样本编号",
        barCode: "条形码",
        chargePlatform: "分管平台",
        splitSample: "拆分样本",
        splitProduct: "拆分产品",
        sumTotal: "总量",
        unit: "单位",
        next: "下一步流向",
        save: "保存",
        submitSample: "提交样本",
        chargeManagement: "分管管理",
        BeforeSplitSampleManagement: "拆分前样本管理",
        AfterSplitSampleManagement: "拆分后样本管理",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        name1: "名称",
        note1: "备注",
        splitCode: "拆分后编号",
        code: "拆分前编号",
        sampleCode: "原始样本编号",
        orderCode: "订单编号",
        productName: "产品名称",
        OriginalSampleType: "原始样本类型",
        dicSampleType: "产物类型",
        contraction: "浓度(ng/ul)",
        volume: "体积(μL)",
        qbContraction: "Qubit浓度(ng/ul)",
        od280: "od260/280",
        od260: "od260/230",
        nextFlow: "下步流向",
        isSplitProduct: "是否已拆产品",
        state: "状态",
        createUser: "创建人",
        createDate: "创建时间",
        labCode: "实验室样本号",
        sampleType: "样本类型",
        sequencePlatform: "测序平台",
        id: "订单编号",
        name: "姓名",
        productId: "产品编号",
        productName1: "产品名称",
        gender: "性别",
        age: "年龄",
        medicalNumber: "电子病例编号",
        state1: "状态",
    }
    , MasterdataStorageContainer: {
        storageContainer: "容器管理",
        id: "编号",
        name: "容器名称",
        colNum: "列数",
        rowNum: "行数",
        location: "级别",
        effect: "是否有效",
        createUser: "创建人",
        createDate: "创建时间",
        effectUser: "生效人",
        effectDate: "生效时间",
        editData: "编辑数据",
        confirm: "确认",
        save: "保存",
        lineEdit: "行编辑",
        isEffect: "是否生效",
        isEffect2: "生效",
        oneLevel: "一级",
        twoLevel: "二级",
        threeLevel: "三级",
        fourLevel: "四级",
        subContainer: "子容器",
        mainContainer: "主容器",
        yes: "是",
        no: "否",
        chooseOneData: "请选择一条数据",
        effectSuccess: "生效成功",
        effectFail: "生效失败",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        tips: "提示",
        nameNotNull: "容器名称不能为空",
        colNumNotNull: "列数不能为空",
        colNumPositiveInteger: "列数必须为正整数",
        rowNumNotNull: "行数不能为空",
        rowNumPositiveInteger: "行数必须为正整数",
        locationNotNull: "级别不能为空",
        //请先保存
        saveFirst: "请先保存",
        //已生效数据，无法生效
        effectFail1: "已生效数据，无法生效",
        //修改成功
        updataSuccess: "修改成功",
    },
    storageContainerEdit: {
        editData: "编辑数据",
    },
    agentPublic: {
        agent: "代理商",
    },
    agentList: {
        id: "编号",
        name: "名称",
        address: "地址",
        principal: "负责人",
        phone: "联系电话",
        marketer_id: "管理销售id",
        marketer: "管理销售",
        money: "预付余额",
        rate_id: "评级id",
        rate: "评级",
        state_id: "状态id",
        state: "状态",
        create_user_id: "创建人id",
        create_user: "创建人",
        create_date: "创建时间",
        saveInfo: "保存成功",
        updateInfo: "修改成功",
        submitInfo: "提交成功",
        agentId: "代理商编号",
    }, agentEdit: {
        batchAdd: "增加",
        chooseUser: "请选择用户",
        chooseDic: "请选择字典",
        chooseState: "请选择状态",
        id: "编号",
        name: "名称",
        address: "地址",
        principal: "负责人",
        phone: "联系电话",
        marketer: "管理销售",
        money: "预付余额",
        rate_id: "评级id",
        rate: "评级",
        state_id: "状态id",
        state: "状态",
        create_user_id: "创建人id",
        create_user: "创建人",
        create_date: "创建时间",
        file: "附件",
        upload: "上传附件",
        view: "查看附件",
        addSuccess: "添加成功",
        fileName: "文件名",
        fuction: "所属模块",
        uploadTime: "文件上传时间",
        uploadUser: "上传人",
        download: "下载",
        delete: "删除",
        tips: "请选择一条数据",
    },
    agentEditTips: {
        message: "确认",
        confirm: "您确定要继续吗？",
        cancel: "您已取消！",
        deleteSuccess: "删除成功",
    },
    supplierPublic: {
        supplier: "供应商",
        SupplierList: "供应商列表",
    }, supplierList: {
        id: "编号",
        name: "名称",
        address: "地址",
        linkMan: "联系人",
        phone: "联系电话",
        email: "邮箱",
        postCode: "邮编",
        stateId: "状态ID",
        state: "状态",
        capitalNum: "注册资本",
        orgCode: "组织机构代码",
        industry: "行业",
        aptitide1: "资质1",
        aptitide2: "资质2",
        aptitide3: "资质3",
        accountBank: "开户行",
        accountBankAddress: "开户行地址",
        account: "账号",
        accountName: "账号名称",
        bankCode: "银行代码",
        bic: "Swift Code(BIC)",
        arn: "ABA Routing Number",
        iban: "IBAN",
        classification: "厂商类型",
        status: "状态",
        manufacturer: "生产商",
        supplier: "供应商",
    }, supplierEdit: {
        chooseState: "选择状态",
        saveInfo: "保存成功",
        updateInfo: "修改成功",
        firm: "企业资质",
        accountInfo: "账户信息",
    },
    InstrumentFaultData: {
        instrumentFault: "仪器报修",
        id: "编号",
        confirmDate: "确认时间",
        cost: "费用",
        createDate: "创建时间",
        handleDate: "报修时间",
        note: "备注",
        state: "状态",
        stateName: "工作流状态",
        confirmUser: "确认人",
        createUser: "创建人",
        handleUser: "报修人",
        type: "类型",
        instrumentId: "仪器编号",
        instrumentName: "仪器名称",
        new: "新建",
        complete: "完成",
        instrument: "仪器",
        instrumentFaultDetail: "报修明细",
        editPop: "弹窗编辑",
        editData: "编辑数据",
        saveInfo: "保存成功",
        available1: "可用",
        available2: "报废",
        unavailable1: "不可用",
        qxxzytsj: "请先选择一条数据!",
        addedSuccessfully: "添加成功",
        faultReason: "报修原因",
        zttjcc: "状态提交成功",
        zttjsh: "状态提交失败",
        pleaseSave: "请先保存",
        pleaseSelectDate: "请先选择一条数据!",
        ymnrybg: "页面内容有变更，是否需要保存？",
        pleaseSelect: "请选择",
        bntjdyqb: "存在仪器在其他未完成的仪器调整单据中，不能添加到明细表",
        bntjdyqb1: "该仪器在其他未完成的仪器调整单据中，不能添加到明细表",
        tip1: "账号或密码错误",
        tip2: "页面内容存在改动，是否需要保存后退出？",
        tip3: "请选择",
        tip4: "当前需调整仪器状态与调整状态一致，请重新选择",
        tip5: "页面数据存在改动，需要保存后提交！",
        add: "批量添加",
        verification: "验证",
        username: "用户名",
        password: "密码",
        reason: "原因",
        confirm: "确认",
        type1: "请选择类别",
        capitalCode: "型号",
        serialNumber: "序列号",
        supplier: "生产商",
        breed: "类型",
        //不能为空
        notNull: "不能为空",
    },
    InstrumentRepairData: {
        instrumentRepair: "仪器维修",
        id: "编号",
        note: "备注",
        factEndDate: "实际结束时间",
        name: "描述",
        createDate: "创建时间",
        createUser: "创建人",
        verify: "维修单位",
        stateName: "工作流状态",
        instrumentId: "仪器编号",
        instrumentName: "仪器名称",
        new: "新建",
        complete: "完成",
        instrumentRepairTask: "维修明细",
        editData: "编辑数据",
        available: "可用",
        unavailable: "不可用",
        zttjcc: "状态提交成功",
        zttjsh: "状态提交失败",
        pleaseSave: "请先保存",
        pleaseSelectState: "请选择状态",
        pleaseSelectDate: "请先选择一条数据!",
        ymnrybg: "页面内容有变更，是否需要保存？",
        pleaseSelect: "请选择",
        czsbjzqtwxdz: "存在设备已在其他维修单中，请重新选择或刷新页面",
        czsbjzqtwxdz1: "该设备已在其他维修单中，请重新选择或刷新页面",
        state:"状态",
        state2:"维修状态",
        instrument: "仪器",
        add: "批量添加",
        verification: "验证",
        username: "用户名",
        password: "密码",
        reason: "原因",
        confirm: "确认",
        type: "请选择类别",
        capitalCode: "型号",
        serialNumber: "序列号",
        supplier: "生产商",
        state1: "状态",
        userCreateUserId: "创建人",
        faultReason: "报修原因",
        reason1: "故障原因",
        effectiveDate: "安装日期",
        valid: "有效",
        invalid: "无效",
        available1: "可用",
        available2: "报废",
        unavailable1: "不可用",
        tip1: "账号或密码错误",
        saveInfo: "保存成功",
        qxxzytsj: "请先选择一条数据!",
        addedSuccessfully: "添加成功",
        //实际结束时间不可小于仪器报修时间
        tip2: "实际结束时间不可小于仪器报修时间",
    },

    AuditTrailPublic: {
        auditTrail: "审计追踪",
        auditTrailDetail: "审计追踪明细",

        //程序名称
        className: "程序名称",
        //记录编号
        fileId: "记录编号",
        //操作人
        userId: "操作人",
        //操作人编号
        userCode: "操作人编号",
        //操作时间
        logDate: "操作时间",
        //记录修改情况
        modifyContent: "记录修改情况",
        //状态
        stateName: "状态",
        //查看明细
        viewDetail: "查看明细",

        codeName: "标识",
        fieldName: "字段名",
        oldData: "旧数据",
        newData: "新数据",
    },

    // auditTrailEdit: {
    //     className: "程序名称",
    //     fileId: "记录ID",
    //     userId: "操作人",
    //     logDate: "操作时间",
    //     modifyContent: "记录修改情况",
    //     stateName: "状态",
    //     codeName: "标识",
    //     fieldName: "字段名",
    //     oldData: "老数据",
    //     newData: "新数据",
    // },

    search: {
        query: "查询",
        reset: "重置",
    },
    ReservationData: {
        reservation1: "仪器预约",
        instrumentNo: "仪器编号",
        instrumentName: "仪器名称",
        type: "类型",
        state1: "状态",
        reservation: "预约",
        available: "可用",
        unavailable: "不可用",
        scrap: "报废",
        instrumentData: "已预约时间列表",
        id: "编码",
        startDate: "开始时间",
        endDate: "结束时间",
        createUserId: "预约人ID",
        createUser: "预约人",
        state: "预约状态",
        reservationOperation: "操作",
        cancelReservation: "取消预约",
        reservationSuccessful: "已预约",
        canceled: "已取消",
        bcsbyyyysjct: "保存失败！原因：预约时间冲突！",
        successfullySaved: "保存成功",
        reservationCancellationSucceed: "取消预约成功!",
        reservationCancellationFailed: "取消预约失败!",
        today: "今天",
        month: "月",
        week: "周",
        day: "天",
        timeCannotBeEmpty: "时间不能为空！",
        language: "zh",
        tips: "您没有权限取消该用户的预约信息",
        tips1: "开始时间应小于结束时间",
        tips2: "开始时间应大于当前时间",
        tips3: "结束时间应大于当前时间",
        ymnrybg: "页面内容有变更，是否需要保存？",
        pleaseSelect: "请选择",
        pleaseFill: "请输入查询的信息",
        tip4: "请选择一条数据",
    }, applyPublic: {
        purchase: "采购申请",
    }, applyList: {
        id: "申请编号",
        applicant: "申请人",
        applicantId: "申请人id",
        note: "描述",
        applyDate: "申请时间",
        expectDate: "期望到货时间",
        state: "状态",
        stateName: "状态名称",
    }, applyEdit: {
        masterData: "库存主数据",
        procureDetails: "物资采购明细",
        id: "申请编号",
        applicant: "申请人",
        applicantId: "申请人id",
        note: "描述",
        applyDate: "申请时间",
        num: "申请数量",
        expectDate: "期望到货时间",
        state: "状态",
        stateName: "状态名称",
        confirmUser: "请选择审核人",
        selectSupplier: "请选择供应商",
        supplierId: "供应商编号",
        name: "名称",
        supplier: "供应商",
        unit: "单位",
        type: "类型",
        createUser: "创建人",
        createDate: "创建时间",
        chooseState: "选择状态",
        saveInfo: "保存成功",
        updateInfo: "修改成功",
        firm: "企业资质",
        accountInfo: "账户信息",
        verification: "验证",
        reason: "原因",
    },

    //房间管理
    RoomManagement: {
        RoomManagement: "房间管理",
        usedRecord: "实验占用记录",
        cleanRecord: "清洁记录",

        Inquire: "查询",
        Add: "新建",
        Edit: "编辑",
        View: "查看",

        id: "房间编号",
        name: "房间名称",
        note: "备注",
        roomState: "房间状态",
        isUsed: "占用状态",
        cleanState: "清洁状态",
        roomDesc: "房间描述",
        area: "区域",
        centiare: "房间面积㎡",
        stere: "房间体积m³",
        createUser: "创建人",
        createDate: "创建时间",
        stateName: "状态",

        canUse: "可以使用",
        canNotUse: "不可以使用",
        yes: "已占用",
        no: "未占用",
        noClean: "未清洁",
        clean: "已清洁",

        fileName: "文件名称",
        belongModule: "所属模块",
        uploadTime: "文件上传时间",
        uploadUser: "文件上传人",
        notNull: "不允许为空",
        chooseData: "请选择数据",

        batch: "批次号",
        usedExperimentStep: "占用实验阶段",
        usedExperimentName: "占用实验阶段名称",
        acceptUser: "操作人",
        startDate: "开始时间",
        endDate: "结束时间",

        cleanType: "清洁类型",
        cleanId: "房间清洁编号",
        disinfectStartTime: "消毒开始日期",
        disinfectValidityTime: "消毒有效期至",
        cleanUser: "清洁人员",
        cleanDate: "清洁日期",
        checkUser: "复核人员",
        checkDate: "复核日期",

        saveSuccess: "保存成功",
        saveFail: "保存失败",
        roomIdRepeat: "房间编号重复",
        mustBePositiveInteger: "无效，请检查后重新输入！",
        roomIdFormat: "房间编号格式不正确",
    },

    materialIn: {
        materialIn: "物料打包",

        id: "编号",
        name: "姓名",
        createUser: "创建人",
        state: "状态",
        createDate: "创建时间",
        note: "描述",
        confirmUser: "审核人",
        type: "请选择库存主数据",
        confirmUserName: "姓名",

        batch: "请选择批次",

        chooseConfirmUser: "请选择审核人",


    }, StorageInApplyPublic: {
        storageInApply: "入库申请",
        storageInApply2: "生物资源库入库申请",
    }, StorageInApplyList: {
        id: "申请编号",
        name: "描述",
        createUser: "创建人",
        createDate: "创建时间",
        state: "状态",
        stateName: "状态名称",
    }, StorageInApplyEdit: {
        id: "样本id",
        code: "样本编号",
        procureDetails: "入库申请明细表",
        productName: "产品名称",
        chooseProductName: "请选择产品名称",
        sampleType: "样本类型",
        chooseSampleType: "请选择样本类型",
        sampleFrom: "样本来源",
        sampleDeteyionName: "检测项",
        chooseSampleDeteyionName: "请选择检测项",
        cellName: "描述",
        note: "备注",
        sampleBatch: "批号",
        pronoun: "细胞代次",
        concentration: "浓度",
        volume: "体积",
        name: "名称",
        spec: "规格",
        sxDate: "失效期",
        state: "状态",
        stateName: "状态名称",
        createUser: "创建人",
        createDate: "创建时间",
        chooseState: "选择状态",
        saveInfo: "保存成功",
        updateInfo: "修改成功",
        confirm: "确认",
        verification: "验证",
        reason: "原因",
    },

    SampleOutApply: {
        //样本库出库申请
        sampleOutApplySample: "样本库出库申请",
        //出库申请
        sampleOutApply: "出库申请",
        //库存样本
        stockSample: "库存样本",
        //申请明细
        applyDetails: "申请明细",
        //申请明细：
        applyDetailsMix: "申请明细：",

        //编号
        id: "编号",
        //描述
        description: "描述",
        //出库类型
        outType: "出库类型",
        //创建人
        createUser: "创建人",
        //创建时间
        createDate: "创建时间",
        //审核人
        confirmUser: "审核人",
        //完成时间
        finishDate: "完成时间",
        //状态
        state: "状态",

        //出库类型不能为空
        outTypeNotNull: "出库类型不能为空",
        //审核人不能为空
        confirmUserNotNull: "审核人不能为空",

        //样本编号
        sampleCode: "样本编号",
        //原始样本编号
        originalSampleCode: "原始样本编号",
        //产品名称
        productName: "产品名称",
        //产品类型
        productType: "产品类型",
        //样本类型
        sampleType: "样本类型",
        //样本位置
        samplePosition: "样本位置",
        //总量
        total: "总量",
        //出库数量
        outNum: "出库数量",
        //单位
        unit: "单位",
        //失效日期
        expiryDate: "失效日期",
        //下一步流向
        nextFlow: "下一步流向",
        //下一步流向名称
        nextFlowName: "下一步流向名称",

        //请选择数据
        chooseData: "请选择数据",
        //出库类型名称
        outTypeName: "出库类型名称",

        //用户名
        userName: "用户名",
        //密码
        password: "密码",
        //姓名
        name: "姓名",
        //原因
        reason: "原因",
        //确认
        confirm: "确认",

        //添加明细
        addDetails: "添加明细",
        //请填写出库数量后保存
        saveOutNum: "请填写出库数量后保存",
        //保存
        save: "保存",
        //样本编号：
        sampleCodeMsg: "样本编号：",
        //的出库数量不能为空
        outNumNotNull: "的出库数量不能为空",
        //的出库数量不能为0
        outNumNotZero: "的出库数量不能为0",
        //的出库数量不能大于库存数量
        outNumNotBig: "的出库数量不能大于库存数量",

        //选择下一步流向
        chooseNextFlow: "下一步流向",
        //请选择样本明细
        chooseSampleDetail: "请选择样本明细",
        //下一步流向为空！
        nextFlowIsNull: "下一步流向为空！",
        //保存成功
        saveSuccess: "保存成功！",
        //保存失败
        saveFail: "保存失败！",
        //申请明细为空！
        applyDetailIsNull: "申请明细为空！",
        //验证
        validate: "验证",
        //请选择类别
        chooseType: "请选择类别",
        //状态提交成功
        stateSuccess: "状态提交成功！",
        //状态提交失败
        stateFail: "状态提交失败！",

        //提交成功
        submitSuccess: "提交成功！",
        //提交失败
        submitFail: "提交失败！",

        saveFirst: "请先保存主表信息",
    },

    //样本出库
    SampleOut: {
        //样本出库
        sampleOut: "样本出库",
        //待出库样本
        waitOutSample: "待出库样本",
        //添加明细
        addDetails: "添加明细",
        //出库明细
        outDetails: "出库明细",

        //编号
        id: "编号",
        //描述
        description: "描述",
        //类型
        type: "类型",
        //选择类型
        chooseType: "选择类型",
        //出库申请单号
        applyId: "出库申请单号",
        //领用人
        receiver: "领用人",
        //创建人
        createUser: "创建人",
        //创建时间
        createDate: "创建时间",
        //审核人
        confirmUser: "审核人",
        //完成时间
        finishDate: "完成时间",
        //状态
        state: "状态",

        //样本编号
        sampleCode: "样本编号",
        //原始样本编号
        originalSampleCode: "原始样本编号",
        //产品名称
        productName: "产品名称",
        //样本位置
        samplePosition: "样本位置",
        //样本类型
        sampleType: "样本类型",
        //总量
        total: "总量",
        //出库数量
        outNum: "出库数量",
        //单位
        unit: "单位",
        //失效日期
        expiryDate: "失效日期",
        //下一步流向
        nextFlow: "下一步流向",
        //下一步流向名称
        nextFlowName: "下一步流向名称",
        //申请人
        applyUser: "申请人",
        //备注
        remark: "备注",
        //用户名
        userName: "用户名",
        //密码
        password: "密码",
        //姓名
        name: "姓名",
        //原因
        reason: "原因",
        //确认
        confirm: "确认",

        //请选择数据！
        chooseData: "请选择数据！",
        //出库申请单号不能为空！
        applyIdNotNull: "出库申请单号不能为空！",
        //领用人不能为空！
        receiverNotNull: "领用人不能为空！",
        //审核人不能为空！
        confirmUserNotNull: "审核人不能为空！",
        //保存成功
        saveSuccess: "保存成功！",
        //修改成功
        updateSuccess: "修改成功！",

        //验证
        validate: "验证",
        //状态提交成功
        stateSuccess: "状态提交成功！",
        //状态提交失败
        stateFail: "状态提交失败！",
        //请选择类别
        chooseTypeForValidate: "请选择类别",
        //请选择样本！
        chooseSample: "请选择样本！",
        //请先保存主表数据
        pleaseSave: "请先保存主表数据",
    },

    SampleStock: {
        //库存样本展示
        sampleStock: "库存样本展示",

        //有效状态
        validState: "有效状态",
        //失效日期
        expiryDate: "失效日期",
        //样本编号
        sampleCode: "样本编号",
        //原始样本编号
        originalSampleCode: "原始样本编号",
        //批号
        batchNumber: "批号",
        //代次
        generation: "代次",
        //样本类型
        sampleType: "样本类型",
        //总量
        total: "总量",
        //单位
        unit: "单位",
        //产品名称
        productName: "产品名称",
        //样本位置
        samplePosition: "样本位置",
        //备注
        remark: "备注",

        //有效
        valid: "有效",
        //失效
        invalid: "失效",
    },

    DetectionsPublic: {
        detections: "检测项",
    }, DetectionsList: {
        id: "检测项编码",
        name: "描述",
        createUser: "创建人",
        createDate: "创建时间",
        state: "状态",
        stateName: "状态名称",
        new: "新建",
        complete: "完成",
    },

    DetectionsEdit: {
        transportType: "运输方式",
        detectionsDetails: "检测项明细表",
        id: "检测项编号",
        name: "检测项名称",
        cellName: "名称",
        yesOrNo: "是否推送生产",
        yesOrNo2: "是否提醒",
        reservedSample: "是否留样",
        deteyionName: "检测项目代码",
        type: "检测项类型",
        nextFlow: "质检类型",
        testingCriteria: "检测标准",
        unit: "单位",
        note: "备注",
        template: "检测模板",
        confirmUser: "请选择审核人",
        state: "状态",
        stateName: "状态名称",
        chooseState: "请选择状态",
        saveInfo: "保存成功",
        saveFail: "保存失败",
        updateInfo: "修改成功",
        confirm: "确认",
        verification: "验证",
        reason: "原因",

        experimentType: "实验类型",
        testStyleNo: "实验类型编号",
        testStyleName: "实验类型名称",
        experimentTypeSuffix: "数据库表后缀",

        createUser: "创建人",
        createDate: "创建时间",

        inValid: "无效",
        valid: "有效",
        save: "保存",

        choose: "请选择一条数据！",

        nameNotNull: "检测项名称不能为空",
        deteyionNameNotNull: "检测项目代码不能为空",
        stateNotNull: "状态不能为空",
        experimentTypeNotNull: "实验类型不能为空",
    },

    //模板流程
    TemplateProcessEdit:{
        title: "模板流程",

        processView: "流程图",
        desc: "描述",
        experimentType: "实验类型",
        createUserNickName: "创建人",
        createDate: "创建时间",
        state: "状态",
        valid: "有效",
        invalid: "无效",
        selectData: "请选择数据!",

        validSuccess: "修改状态成功!",
        validFail: "修改状态失败!",
    },

    //研发样本接收
    SampleCenterRDReceiveEdit: {
        title: "研发样本接收",
        rdSampleReceiveTemplate: "研发样本接收模板",
        downloadTemplate: "下载模板",
        batchUpload: "批量上传",

        receiveId: "接收编号",
        receiveDate: "接收时间",
        sampleId: "样本编号",
        desc: "描述",
        state: "状态",
        projectId: "项目编号",
        projectName: "项目名称",
        createTime: "创建时间",
        createUser: "创建人",
        expressNo: "快递单号",
        expressCompany: "快递公司",
        transportType: "运输方式",
        confirmUser: "审核人",

        save: "保存",
        back: "列表",
        submit: "提交",
        handle: "办理",
        verify: "验证",
        submitSuccess: "提交成功",
        submitFailed: "提交失败",
        exSampleCodeCantRepeat: "外部样本编号不能重复！",
        expressNumError: "快递单号格式错误！",
        sampleNumMustBePositiveInteger: "采样量必须为正整数！",
        periodOfValidityNotLessThanZero: "有效期不能为小于0",

        sampleReceiveDetail: "样本接收明细",
        externalSampleCode: "外部样本编号",
        sampleCode: "样本编号",
        name: "姓名",
        gender: "性别",
        gender0: "女",
        gender1: "男",
        gender2: "未知",
        sampleType: "样本类型",
        samplingDate: "采样时间",
        validity: "有效期（天）",
        expireDate: "到期时间",
        site: "采样部位",
        sampleNum: "采样量",
        unit: "单位",
        result: "结果",
        result1: "合格",
        result2: "不合格",
        nextFlow: "下一步流向",
        plateNo: "板号",
        position: "位置",
        note: "备注",

        saveFirst: "请先保存!",
        saveSuccess: "保存成功!",
        updateSuccess: "修改成功!",
        receiveDateNotFilled: "接收时间不能为空",
        confirmUserNotFilled: "审核人不能为空",
        pleaseSelect: "请选择数据",
        phone: "联系电话",
        address: "地址",
        valid: "有效",
        invalid: "无效",

        uploadFile: "上传附件",
        viewFile: "查看附件",
        uploadSuccess: "上传成功",
        uploadFail: "上传失败",
        fileName: "文件名称",
        editSample: "编辑样本信息",
        mustBePositiveInteger: "必须为正整数!",
        required: "不允许为空!",

        cancel: "取消",
        confirm: "确认",
        analysisSuccess: "解析成功!",
        analysisFail: "解析失败!",

        selectType: "请选择",
        username: "用户名",
        password: "密码",
        reason: "原因",
        inputUserNameAndPassword: "请输入用户名与密码",
        userNameOrPasswordError: "用户名或密码错误",
        operateSuccess: "操作成功",
        operateFail: "操作失败",
    },

    MasterdataFlowPathConfig: {
        FlowPath: "流程",
        FlowPathName: "流程表名称",
        add: '添加',
        module: '模块',
        FlowPathNames: '流程名称',
        addWuliao: '添加物料',
        wuliaoId: '物料编号',
        wuliaoName: '物料名称',
        wuliaoPici: '物料批次',
        operation: "操作",
        addShebei: '添加设备',
        shebeiId: '设备编号',
        shebeiType: '设备类型',
        shebeiName: '设备名称',
        addZhiling: '添加指令',
        zhilingContent: '指令内容',
        zhilingJieguo: '指令结果',
        yes: '是',
        no: '否',
        upload: '上传',
        view: '查看',
        imgTitle: '图片描述',
        date: '日期',
        dateTime: '日期时间',
        peizhi: '配置',
        name: '名称',
        isDuhang: '是否独行',
        morentishi: '默认提示',
        type: '类型',
        zhengtidaxiao: '整体大小',
        zuizhongshenpiren: '最终审批人',
        guize: '规则',
        zidingyibiaotou: '自定义表头',
        delete: '删除',
        addGuize: '添加规则',
        deleteZujian: '删除当前组件',
        //清空规则
        clearGuize: '清空规则',
        //选择字段
        chooseZiduan: '选择字段',
        //自定义值
        zidingyizhi: '自定义值',
        //数字个数
        shuzigeshu: '数字个数',
        //字母个数
        zimugeshu: '字母个数',
        //样本条码号只能选择一次
        ybtmh: '样本条码号只能选择一次',
        //个数字
        geshu: '个数字',
        //个字母
        geshu2: '个字母',
        //请选择一条数据
        pleaseSelectOneData: "请选择一条数据",

    },


    AdjustmentStateType: {
        name: "描述",
        note: "备注",
        userName: "姓名",
    },
    AdjustmentDetail: {
        scopeName: "仪器名称",
        invoicenumber: "型号",
        state1: "仪器状态",
        note: "备注",
        createUser: "创建人",
        createDate: "创建时间",
    },
    InstrumentRepairPlanData: {
        instrumentRepairPlan: "仪器周期检定计划",
        id: "编号",
        tsTime: "预警天数",
        period: "周期",
        unit: "单位",
        unitName: "周期单位",
        note: "描述",
        typeId: "类型",
        typeName: "维护类型",
        createUser: "创建人",
        createDate: "创建时间",
        state: "状态",
        stateName: "状态",
        nextDate: "下次维护日期",
        tsDate: "维护提醒日期",
        prevDate: "上次维护日期",
        instrumentId: "仪器编号",
        instrumentName: "仪器名称",
        maintainer: "维护人",
        new: "新建",
        complete: "完成",
        chooseType: "请选择数据！",
        saveInfo: "保存成功",
        instrument: "仪器",
        instrumentRepairPlanTask: "明细",
        editData: "编辑数据",
        effectiveDate: "安装日期",
        delete: "确认删除明细吗?",
        deleteInfo: "删除成功",
        addInfo: "添加成功",
        cancelOperation: "取消操作",
        confirmation: "确认",
        chooseMaintainer: "请选择数据！",
        batchAdd: "批量添加",
        days: "天",
        weeks: "周",
        month: "月",
        available: "可用",
        unavailable: "不可用",
        tip1: "请选择一条数据",
        tip2: "请输入正整数",
        tip3: "预警天数不能为空",
        tip4: "周期不能为空",
        tip5: "请选择周期单位",
        tip6: "请选择维护类型",
        tip7: "预警天数请输入正整数",
        tip8: "周期请输入正整数",
        tip9: "预警天数不能大于周期天数",
        batchAddMaintainer: "维护人",
        add: "批量添加",
        name: "名称",
        instrumentNo: "仪器编号",
        capitalCode: "型号",
        serialNumber: "序列号",
        supplier: "生产商",
        breed: "类型",
        state1: "状态",
        userCreateUserId: "创建人",
        note1: "备注",
        valid: "有效",
        invalid: "无效",
        chooseOneData: "请选择一条数据",
        ymnrybg: "页面内容有变更，是否需要保存？",
        pleaseSelect: "请选择",
    },
    InstrumentMaintainData: {
        //维护日期应大于或等于当前日期！
        TheMaintenancEdateShouldBeGreaterThanOrEqualToTheCurrentDate: "维护日期应大于或等于当前日期！",
        instrumentMaintain: "仪器维护",
        id: "编号",
        name: "描述",
        note: "备注",
        typeId: "类型",
        typeName: "维护类型",
        createUser: "创建人",
        createDate: "创建时间",
        state: "状态",
        stateName: "状态",
        confirmUser: "确认人",
        confirmDate: "确认时间",
        instrumentId: "仪器编号",
        instrumentName: "仪器名称",
        new: "新建",
        complete: "完成",
        saveInfo:"保存成功",
        saveInfo1:"保存失败",
        planInstrument:"待维护仪器",
        instrumentMaintainItem:"明细",
        useDate:"维护日期",
        nextDate:"下次维护日期",
        tsDate:"维护提醒日期",
        period:"维护周期",
        unitName:"周期单位",
        deleteInfo:"删除成功",
        addInfo:"添加成功",
        completeInfo:"状态提交成功",
        delete:"确认删除明细吗?",
        confirmation:"确认",
        cancelOperation:"取消操作",
        content:"维护检定内容",
        tip1:"账号或密码错误",
        tip2:"维护类型不能为空",
        chooseType: "请选择数据！",
        add: "批量添加",
        verification: "验证",
        username: "用户名",
        password: "密码",
        reason: "原因",
        confirm: "确认",
        type: "请选择类别",
        name1:"名称",
        instrumentNo: "仪器编号",
        period1: "周期",
        valid: "有效",
        invalid: "无效",
        pleaseSave: "请先保存",
        ymnrybg: "页面内容有变更，是否需要保存？",
        pleaseSelect: "请选择",
        chooseOneData: "请选择一条数据",
    },
    orderChangePublic: {
        orderChange: "订单变更",
    },
    orderChangeList: {
        id: "编号",
        acceptDate: "审批时间",
        changeType: "类型",
        createDate: "创建时间",
        name: "姓名",
        note: "备注",
        state: "状态",
        stateName: "状态",
        acceptUser: "审核人",
        createUser: "创建人姓名",
        orderId: "订单编号",
        List: "订单变更列表"

    },
    orderChangeEdit: {
        saveInfo: "保存成功",
        changeType: "追加申请类型",
        choose: "请选择一条记录！",
        cancel: "取消",
        modify: "修改",
        append: "追加",
        chooseAcceptUser: "选择审核人",
        chooserOrder: "选择订单",
        gender: "性别",
        age: "年龄",
        medicalNumber: "电子病历编号",
        orderChangeItem: "追加/修改明细",
        noteState: "状态",
        sampleOrder: "订单编号",
        nation: "民族",
        zipCode: "邮编",
        commissioner: "销售",
        nativePlace: "籍贯",
        familyCode: "家系编号",
        family: "家属联系人",
        familyPhone: "家属联系人联系电话",
        familySite: "家属联系人地址",
        crmCustomer: "医疗机构",
        hospitalPatientId: "住院号",
        birthDate: "出生日期",
        idCard: "身份证号",
        productName: "产品名称",
        confirmAccept: "请确认审核人",
        completeInfo: "完成成功",
        ChangeRecordType: "记录类型",
        ChangeRecordTypeZero: "旧",
        ChangeRecordTypeOne: "新",
    },
    MasterdataQualityProduct: {
        save: "保存",
        back: "列表",
        qualityProduct: "质控品",
        id: "编号",
        name: "质控品名称",
        batch: "批次",
        experimentType: "实验类型",
        chooseExperimentType: "请选择实验类型",
        expectedValue: "预期值",
        createUser: "创建人",
        createDate: "创建时间",
        state: "状态",
        productName: "质控项目名称",
        chooseProductName: "请选择产品",
        productDate: "质控效期",
        identification: "质控品标识",
        saveInfo: "保存成功",
        updateInfo: "修改成功",
        pleaseSelectData: "请选择数据！",
        nameInfo: "质控品名称不能为空",
        identificationInFo: "质控品标识不能为空",
        productDateInFo: "质控效期不能为空",
        stateInFo: "状态不能为空",
        experimentTypeInFo: "实验类型不能为空",
        productNameInFo: "质控项目名称不能为空",
        valid: "有效",
        invalid: "无效",
        productDateInfo: "质控效期应在当前时间之后",
        pageChangeSave: "页面有变更是否需要保存?",
        prompt: "提示",
    },
    MasterdataQualityRule: {
        qualityRule: "质控规则",
        id: "编号",
        name: "名称",
        rule: "规则",
        createUser: "创建人",
        createDate: "创建时间",
        editData: "编辑数据",
        lineEditing: "行编辑",
        confirm: "确认",
        save: "保存",
        holePlateFormat: "孔板格式",
        rackFormat: "架子格式",
        pleaseChoose: "请选择一条数据",
        updateInfo: "更新成功",
        saveInfo: "保存成功",
        //名称不能为空
        nameInfo: "名称不能为空",
        ruleInfo: "规则不能为空",
        saveFirst: "请先保存",
    },
    QualityRuleEdit: {
        editData: "编辑数据",
        lineEditing: "行编辑",
    },
    MasterdataQualityRuleCombination: {
        qualityRuleCombination: "质控规则组合",
        id: "编号",
        rule: "组合名称",
        chooseRule: "选择规则",
        ruleClass: "规则",
        projectName: "产品名称",
        chooseProjectName: "选择产品",
        state: "状态",
        createUser: "创建人",
        createDate: "创建时间",
        confirm: "确认",
        pleaseChoose: "请选择一条数据!",
        editData: "编辑数据",
        save: "保存",
        lineEditing: "行编辑",
        QualityRuleCombinationInfo: "质控规则组合信息",
        valid: "有效",
        invalid: "无效",
        name: "名称",
        rule1: "规则",
        holePlateFormat: "孔板格式",
        rackFormat: "架子格式",
        updateInfo: "更新成功",
        saveInfo: "保存成功",
        ruleInFo: "组合名称不能为空",
        ruleClassInFo: "规则不能为空",
        projectNameInFo: "产品名称不能为空",
        stateInFo: "状态不能为空",
        pleaseSelectData: "请选择数据！",
    },
    QualityRuleCombinationEdit: {
        editData: "编辑数据",
    },
    material: {
        id: "物料包编码",
        name: "物料包名称",
        batch: "批次",
        materialNum: "数量",
        spec: "规格",
        confirmUser: "审核人",
    },
    DocumentEffect: {
        confirm: "您确定要继续吗？",
        fileType: "文件类型",
        fileId: "文件编号",
        fileName: "文件名称",
        issuingDepartmentName: "所属部门",
        createUser: "作者",
        documentPreparRevision: "上级文件",
        stateEffect: "状态",
        effectUser: "生效确认人",
        effectiveDate: "生效日期",
        stateOnlineEffect: "是否已线上分发",
        note: "备注",
        documentEffect: "文档生效",
        documentInvalid: "文档失效",
        fileName2: "文件名称",
        ownerModel: "所属模块",
        uploadUser: "上传人",
        uploadTime: "上传时间",
        tips: "请选择一条数据",
        success: "文件生效成功",
        error: "文件生效失败",
        success1: "文件失效成功",
        error1: "文件失效失败",
        tips1: "已生效文件请勿重复操作",
        tips2: "已失效文件请勿重复操作",
        delete: "删除成功",
        delete1: "删除",
        images: "查看图片",
        viewDocument: "查看文档",
        onlineView: "在线查看文档",
        effect1: "已生效",
        effect2: "未生效",
        yes: "是",
        no: "否",
        attachment: "附件",
        download: "下载",
        images1: "预览图片",
        effect: "生效",
        noEffect: "未生效",
        viewAttachments: "查看附件",
    },
    documentMasterDataPublic: {
        documentMasterData: "文档主数据",
    },
    documentMasterDataList: {
        fileType: "文件类型",
        fileId: "文件编号",
        fileName: "文件名称",
        issuingDepartmentName: "所属部门",
        createUser: "作者",
        documentPreparRevision: "上级文件",
        stateEffect: "状态",
        effectUser: "生效确认人",
        effectiveDate: "生效日期",
        onlineView: "在线查看文档",
        download: "下载受控副本",
        dataNum: "主数据编号",
    },

    DocumentBorrowingApply: {
        borrowingApplication: "文档借阅申请",
        new: "新建",
        complete: "完成",
        newlyBuild: "新建",
        handle: "办理",
        id: "编码",
        name: "描述",
        createUser: "申请人",
        createDate: "申请时间",
        confirmUser: "审核人",
        confirmDate: "完成时间",
        stateName: "状态名称",
        username: "审核人",
        fileName: "文档",
        versionNo: "版本号",
        startDate: "借阅开始时间",
        endDate: "借阅结束时间",
        note: "备注",
        applyCreateUser: "创建人",
        applyCreateDate: "创建时间",
        fileName1: "文件名称",
        select: "选择借阅文档",
        delete: "删除选中",
        selectDocument: "请选择数据！",
        fileName2: "文件名称",
        uploadTime: "上传时间",
        uploadUser: "上传人",
        success: "上传成功",
        warn: "请选择一条数据",
        deleteSuccess: "删除成功",
        deleteError: "删除失败",
        save1: "请先保存",
        saveSuccess: "保存成功",
        saveError: "保存失败",
        stateSubmitError: "状态提交失败",
        addSuccess: "添加成功",
        addError: "添加失败",
        tips: "请选择要删除的数据",
        warning: "请选择审核人",
        file: "查看附件",
        upload: "上传附件",
        view: "查看附件",
        download: "下载",
        delete1: "删除",
        startDateError: "借阅开始时间必须晚于当前时间",
        endDateError: "借阅开始时间必须早于借阅结束时间",
        endDateError1: "借阅结束时间必须晚于借阅开始时间",
        repeat: "不能重复借阅",
        borrowSuccess: "借阅成功",
        verification: "验证",
        username1: "用户名",
        password: "密码",
        reason: "原因",
        confirm: "确认",
        type: "请选择类别",
        viewDocument: "查看文档",
        viewImages: "查看图片",
        onlinePdf: "查看pdf",
        endDateError2: "不在借阅时间内无法查看文档",
        fileTypeError: "当前只支持查看pdf、图片、word",
        documentBorrowingApplyDetail: "文件借阅申请明细",
        save: "保存",
        back: "列表",
        submit: "提交",
        state: "状态",
        pleaseSelectOneData: "请选择一条数据",
        startDateNotNull: "借阅开始时间不能为空",
        endDateNotNull: "借阅结束时间不能为空",
        documentIs: "文档为：",
        versionNoIs: "版本号为：",
        documentInBorrowingTime: "的文档还在借阅时间内",
        cannotAddSameDepartmentDocument: "不能添加相同部门的文档",
        cannotRepeatBorrowDocument: "不能重复借阅该文档",
        //提交成功
        submitSuccess: "提交成功",
        //提交失败
        submitError: "提交失败",
    },
    materialInItem: {
        id: "物料编码",
        materialName: "物料名称",
        spec: "规格",
        batch: "批次",
        num: "数量",
        note: "描述",
        unit: "单位",
        createUser: "入库人员",
        createDate: "入库时间",

        name: "名称",
        save: "保存",
        saveSuccess: "保存成功",
        list: "列表",
        state: "状态",
        validate: "验证",
        username: "用户名",
        password: "密码",
        reason: "原因",
        confirm: "确认",
        chooseType: "请选择类别",
        confirm1: "确认",
        // 库存主数据
        inventorymastedata: "库存主数据",
        selectInventory: "选择库存主数据",
        material: "物料",
        selectMaterial: "选择物料批次",
        name5: "姓名",
        insufficient: "该批次物料库存不足",
        insufficient1: "物料库存不足",
        saveError: "保存失败",
        editSuccess: "保存成功",
        editError: "保存失败",
        deleteError: "删除失败",
        stateFinish: "提交成功",
        stateFinishError: "提交失败",
        // 请选择一条数据
        tips: "请选择一条库存主数据",
        //请选择一条数据
        tips1: "请选择一条物料批次",
    },
    inventorymastedata: {
        id: "批号",
        expireDate: "失效期",
        inDate: "入库时间",
        num: "本批次数量",
        viceUnit: "单位",
        qcState: "qc状态",
        location: "储存位置",
        note: "sn",
        note2: "备注",
        createUser: "创建人",
        createDate: "创建时间",
    },
    materialInList: {
        id: "入库信息",
        createUser: "入库人员",
        createDate: "创建时间",
        note: "描述",
        confirmDate: "入库时间",
        stateName: "状态",
    },
    dptPharmacyPublic: {
        DptPharmacy: "DTP药房",
    },
    dptPharmacyList: {
        id: "编码",
        name: "名称",
        district: "地区",
        type: "分类",
        street: "地址",
        postcode: "邮编",
        email: "邮箱",
        researchField: "研究领域",
        dutyMan: "负责人",
        phone: "电话",
        state: "状态",
        createUser: "创建人",
        createDate: "创建时间",
        // 有效
        effective: "有效",
        // 无效
        invalid: "无效",
    },
    dptPharmacyEdit: {
        chooseType: "请选择分类",
        chooseDistrict: "请选择地区",
        chooseDutyMan: "请选择负责人",
        chooseState: "请选择状态",
        saveInfo: "保存成功",
        updateInfo: "修改成功",
        saveFailedInfo: "保存失败",
    },
    DocumentDraftingPublic: {
        DocumentDrafting: "起草/修订",
    },
    DocumentDraftingList: {
        numbers: "单号",
        fileType: "文件类型",
        documentNumber: "文件编号",
        fileName: "文件名称",
        state: "状态",
        issuingDepartmentName: "所属部门",
        author: "作者",
        createTime: "创建时间",
    },
    DocumentDraftingEdit: {
        chooseDept: "请选择所属部门",
        briefName: "组织机构简称",
        name: "组织机构名称",
        Valid: "有效",
        Invalid: "无效",
        address: "地址",
        note: "备注",
        operation: "操作",
        numbers: "单号",
        // 状态
        state: "状态",
        Version: "选择历史版本",
        Upload: "上传线下已审核文档",
        Viewing: "查看文档",
        ViewOnline: "在线查看文档",
        Generate: "生成文档",
        author: "作者",
        content: "文档内容",
        definition: "定义",
        duty: "职责",
        text: "正文",
        reference: "参考",
        enclosure: "附件",
        RevisionHistory: "修订历史",
        SelectFileType: "选择文件类型",
        SelectProductionType: "选择生产类型",
        ChooseLocation: "选择地点",
        SelectIssuingDepartment: "选择颁发部门",
        SelectReviewer: "选择审核人",
        SelectApprover: "选择批准人",
        SelectSuperiorFile: "选择上级文件",
        SelectHistoryFile: "选择历史文件",
        category: "请选择类别",
        verification: "验证",
        userName: "用户名",
        password: "密码",
        reason: "原因",
        confirm: "确认",
        DocumentName: "文档名称",
        ParentFile: "父级文件",
        uploadOffline: "是否线下上传",
        FileType: "文件类型",
        FileNumber: "文件编号",
        ProductionType: "生产类型",
        DepartmentName: "发行部门",
        Location: "地点",
        IssuingDepartment: "分发部门",
        Approval: "审批人",
        ratify: "批准人",
        AuditCycle: "审计周期",
        ApprovalLeadTime: "审批提前周期",
        BodyEditingStyle: "正文编辑样式",
        DocumentBodyEditingStyle: "文档正文编辑样式",
        Purpose: "目的",
        Scope: "范围",
        word: "word弹窗编辑",
        yes: "是",
        no: "否",
        upload: "上传附件",
        view: "查看附件",
        add: "添加",
        delete: "删除",
    },
    DocumentDraftingColum: {
        encoding: "文件编码",
        FileName: "文件名称",
        UserName: "用户名",
        Name: "名称",
        Parameter: "参数",
        SerialNumber: "序号",
        DepartmentPosition: "部门职位",
        Responsibilities: "职责",
        SerialNumber1: "序号",
        TA: "术语/缩写",
        Definition: "定义",
        SerialNumber2: "序号",
        DocumentNumber: "文件编号",
        FileName1: "文件名称",
        VersionNumber: "版本号",
        Author: "作者",
        EffectiveDate: "生效日期",
        OrderNumber: "单号",
        FileType: "文件类型",
        DocumentNumber1: "文件编号",
        FileName2: "文件名称",
        Department: "所属部门",
        author: "作者",
        CreationTime: "创建时间",
        save: "保存成功",
        info: "请先保存数据",
    },

    //文档模板
    DocumentTemplateList: {
        DocumentTemplate: "文档模板",

        desc: "描述",
        formatType: "格式类型",
        fileType: "文件类型",
        ifValid: "是否有效",
        createUser: "创建人",
        createTime: "创建时间",
        valid: "有效",
        invalid: "无效",
        S: "竖版",
        H: "横版",
        ZW: "正文",
        file: "附件",
        tips: "请选择一条数据",
        tipsNew: "请选择数据！",
        uploadSuccess: "上传成功",

        selectFileType: "选择文件类型",
        upload: "上传附件",
        view: "查看附件",
        editOL: "在线编辑",

        saveFirst: "请先保存!",

        fileName: "文件名称",
        uploadTime: "文件上传时间",
        uploadUser: "上传人",
        save : "保存",
    },

    projectManagementPublic: {
        projectManagement: "项目管理",
        logMsg1: "用户:*1在编号为",
        logMsg2: "的数据中上传了附件,附件名为:",
    },
    projectManagementList: {
        id: "项目编号",
        name: "项目名称",
        type: "类型",
        dutyUserName: "项目负责人",
        templateUpgrade: "项目描述",
        planStartDate: "开始时间",
        planEndDate: "预计交付时间",
        factEndDate: "实际交付时间",
        sumScale: "汇款总比例",
        projectProgress: "完成进度",
        state: "状态",
        start: "开始",
        noStart: "未开始",
        createUserName: "创建人",
        createDate: "创建时间",
        note: "项目描述",
    },
    file: {
        upload: "上传附件",
        check: "查看附件",
        enclosure: "附件",
        checkPicture: "查看图片",
        preview: "预览图片",
        download: "下载",

    },
    coiOrder: {
        coiOrder: "COI订单",

        orderNumber: "订单编号",


        productInfo: "产品信息",
        applicationInfo: "申请单信息",
        applicationNumber: "申请单编号",
        screeningNumber: "筛选号",
        samplingTimes: "取样次数",
        traceabilityCode: "追溯码",
        informedDate: "知情日期",
        estimatedCollectionTime: "预计采集时间",
        estimatedReturnDate: "预计回输日期",
        hepatitisB: "乙肝HBV",
        hepatitisC: "丙肝HCV",
        aids: "艾滋病HIV",
        syphilis: "梅毒TPHA",
        tumorType: "肿瘤类型",
        tumorStage: "肿瘤分期",
        hospital: "医院",
        department: "科室",
        craContact: "CRA联系方式",
        ebv: "EBV结果",
        cmv: "CMV结果",
        transportationTemperatureConditions: "运输温度条件",
        sampler: "取样人",
        phoneNumber: "手机号码",
        sparePhoneNumber: "备用手机号码",
        samplingAddress: "取样地址",
        remarks: "备注",
        createUser: "创建人",
        createTime: "创建时间",
        state: "状态",
        sampleInfo: "样本信息",
        flowState: "流程状态",


        sampleNumber: "编码",
        productName: "产品名称",
        barCode: "条形码",
        gtin: "GTIN号",
        sampleName: "样本名称",
        samplingTime: "采样时间",
        receiverName: "接收人名称",
        receiveTime: "接收时间",
        type: "类型",
        units: "单位",
    },
    ProductionPlan: {
        ProductionPlan: "生产计划",
        save: "保存",
        tomorrow: "查看明天待生产",
        pause: "暂停步骤",
        insert: "步骤插入",
        print: "打印标签",
        recheck: "复检打印条码",
        select: "选择模板类型",
        cancel: "取消",
        confirm: "确定",
        selectProcess: "选择流程类型(必选)",
        processName: "流程表名称",
        createUser: "创建人",
        process: "流程",
        noName: "暂无名称",
        pleaseSelect: "请选择操作人",
        pleaseSelectStep: "请选择步骤",
        // 请选择操作人
        pleaseSelectOperator: "请选择操作人",
        noData: "没有数据",
        loading: "加载数据中",
        operation: "操作",
        deviation: "偏差影响",

        productBatch: "产品批号",
        operationDate: "操作日期",
        process1: "工序",
        stepName: "步骤名称",
        operator: "操作人",
        room: "房间",
        processConfiguration: "流程配置",
        finishedGoodsReceipt: "成品收货",
        transportationPlan: "运输计划",
        transportation: "运输",
        other: "其他",
        sourceSampleTransportation: "来源样本运输",
        sampleReception: "样本接收",
        pleaseSelectOneData: "请选择一条数据",
        cannotSelectProcessOne: "不可以选择工序为一的步骤进行复检！",
        saveSuccess: "保存成功",


        describe: "描述",
        product: "产品",
        remark: "备注",
        number: "编号",
        deviationDescribe: "偏差描述",
        code: "编码",
        name: "名称",
        version: "工序编号",
        userName: "姓名",
        distributionNumber: "分配次数",
        roomNumber: "房间编号",
        roomName: "房间名称",
        area: "所在区域",
        todayArrangementNumber: "今日安排次数",
        occupancyStatus: "占用状态",
        expirationDate: "距效期",


    },
    ProcessExecution: {
        edit: "编辑",
        describe: "描述",
        processConfiguration: "流程配置",
        pleaseSelect: "请选择一条记录！",
        traceabilityCode: "追溯码",
        process: "流程",
        noName: "未命名",
        finished: "已完成",
        unfinished: "未完成",
        addRow: "添加行",
        materialNumber: "物料编号",
        materialName: "物料名称",
        materialBatch: "物料批次",
        operation: "操作",
        warehousing: "入库",
        addFinishedProduct: "添加成品",
        outbound: "出库",
        number: "编号",
        name: "名称",
        batch: "批次",
        state: "状态",
        notWarehousing: "未入库",
        warehousing1: "已入库",
        notOutbound: "未出库",
        waitOutbound: "待出库",
        outbound1: "已出库",
        addRow1: "添加行",
        equipmentNumber: "设备编号",
        equipmentName: "设备名称",
        equipmentType: "设备类型",
        operation1: "操作",
        instructionContent: "指令内容",
        instructionResult: "指令结果",
        yes: "是",
        no: "否",
        time: "时间：",
        upload: "上传",
        check: "查看",
        pictureDescribe: "图片描述",
        upload1: "上传",
        check1: "查看",
        addRow2: "添加行",
        selectTime: "选择时间日期",
        selectDate: "选择日期",
        pleaseSelect1: "请选择一条记录！",
        confirmCompletion: "确认完成该流程",
        expectedArrivalDate: "期望到货日期",
        expectedReturnDate: "期望回输日期",
        transportationTemperatureConditions: "运输温度条件",
        returnApplicationConfirmation: "回输申请确认",
        remark: "备注",
        state1: "状态",
        returnRemark: "退回备注",
        logisticsNumber: "物流单号",
        logisticsPersonnel: "物流人员",
        estimatedArrivalTime: "预计到达时间",
        transportationDate: "运输日期",
        transportationMode: "运输方式",
        confirm: "确认",
        confirm1: "确认",
        confirm2: "确认",
        name1: "名称",
        uploadTime: "上传时间",
        uploadPerson: "上传人",
        operation2: "操作",
        cancel: "取消",
        confirm3: "确定",
        name2: "名称",
        cancel1: "取消",
        confirm4: "确定",
        selectBatchNumber: "选择批号",
        selectMaterial: "选择物料",
        name3: "名称",
        materialBatch1: "物料批次",
        selectMaterial1: "选择物料",
        number1: "编号",
        expirationDate: "过期时间",
        finishedProductNumber: "成品编号",
        productionDate: "生产日期",
        account: "账号",
        password: "密码",
        cancel2: "取消",
        confirm5: "确定",
        estimatedSamplingTime: "预计采样时间",
        logisticsTime: "物流时间",
        logistics: "物流人",
        shippingNumber: "发运单号",
        transportationMode1: "运输方式",
        logisticsCompany: "物流公司",
        thermometerNumber: "温度计编号",
        thermometerStartTime: "温度计开启时间",
        incubatorNumber: "保温箱编号",
        startTemperature: "开始温度",
        new: "新建",
        save: "保存",
        list: "列表",
        confirmed: "已确认",
        noConfirmed: "未确认",
        returned: "已退回",
        new1: "新建",
        toBeConfirmed: "待确认",
        pleaseCompleteThePreviousStepFirst: "请先完成上一步",
        prompt: "提示",
        success: "成功",
        barcodeNumberDoesNotExist: "条码号不存在",
        noSample: "没有该样本",
        dataCannotBeEditedAfterConfirmation: "确认后数据不可编辑",
        confirmCompletionOfCurrentProcess: "确认完成当前流程",
        sumIs: "总和为",
        averageValueIs: "平均值为",
        maximumValueIs: "最大值为",
        minimumValueIs: "最小值为",
        success1: "成功",
        wrongPassword: "密码有误",
        noSuchUser: "没有该用户",
        approverVerification: "审批人校验",
        selectBatchNumber1: "选择批号",
        selectMaterial2: "选择物料",
        selectEquipment: "选择设备",
        selectMaterial3: "选择物料",
        selectBatchNumber2: "选择批号",
        selectEquipmentType: "选择设备类型",
        selectMaterial4: "选择物料",
        selectFinishedProduct: "选择成品",
        uploadSuccess: "上传文件成功",
        saveSuccess: "保存成功",

        ProcessExecution: "流程执行",
        describe1: "描述",
        CreationDate: "创建时间",
        Creator: "创建人",
        traceabilityCode1: "追溯码",
        OrderNumber: "订单编号",
        operation3: "操作",
        deleteSuccess: "删除成功",

        ProcessConfiguration: "流程配置",
        addProcessTable: "添加流程表",
        processTableName: "流程表名称",
        CreationDate1: "创建时间",
        Creator1: "创建人",
        operation4: "操作",
        deleteSuccess1: "删除成功",

        type: "类型",
        addFinishedProduct1: "添加成品",
        number2: "编号",
        name4: "名称",
        selectBatchNumber3: "选择批次",
        pleaseSelect2: "请选择一条记录！",
        inputOptionalItems: "输入可选项 用英文逗号隔开",
        cancel3: "取消",
        confirm6: "确定",
        onlyForFieldsOfTypeNumber: "（仅限于类型为数字输入框的字段）",
        addRowCalculation: "添加行计算",
        pleaseSelectField: "请选择字段",
        pleaseSelectAddSubtractMultiplyAndDivide: "请选择加减乘除",
        pleaseSelectField1: "请选择字段",
        addColumnCalculation: "添加列计算",
        pleaseSelectMethod: "请选择方法",
        selectTemplateType: "选择模板类型",
        selectProcessType: "选择流程类型(必选)",
        blankTemplate: "空白模板",
        existingProcessTemplate: "已有流程模板",
        processTableName1: "流程表名称",
        Creator2: "创建人",
        process1: "流程",
        noName1: "暂无名称",
        viewStyle: "查看样式",
        close: "关闭",
        save1: "保存",
        pleaseSelect3: "请选择一条记录！",
        list1: "列表",
        finishedProductReceipt: "成品收获",
        transportationPlan: "运输计划",
        transportation: "运输",
        other: "其他",
        sourceSampleTransportation: "来源样本运输",
        sampleReception: "样本接收",
        averageValue: "平均值",
        maximumValue: "最大值",
        minimumValue: "最小值",
        sum: "求和",
        add: "加",
        subtract: "减",
        multiply: "乘",
        divide: "除",
        number3: "编号",
        roomNumber: "房间号",
        expressNumber: "快递号",
        phoneNumber: "手机号",
        idNumber: "身份证号",
        specialCode: "特殊码",
        customTable: "自定义表格",
        richText: "富文本",
        scanCodeBox: "扫码框",
        pleaseEnter: "请输入",
        textBox: "文本框",
        pleaseEnter1: "请输入",
        approvalBox: "审批框",
        finishedProductBox: "成品框",
        materialBox: "物料框",
        equipmentBox: "设备框",
        attachment: "附件",
        picture: "图片",
        pleaseEnter2: "请输入",
        operationInstructionBox: "操作指令框",
        textInputBox: "文本输入框",
        timeAndDateSelection: "时间日期选择",
        dateSelection: "日期选择",
        numericInputBox: "数字输入框",
        dropDownSelectionBox: "下拉选择框",
        rule: "规则",
        selectEquipmentType1: "选择设备类型",
        selectMaterial5: "选择物料",
        selectFinishedProduct1: "选择成品",
        tableHeaderName: "表头名",
        saveSuccess1: "保存成功",

        delete: "是否确认删除？",

    },

    BatchInstructions: {
        BatchInstructions: "批指令下达",
        BatchInstructionsCode: "批指令编码",
        Batch: "追溯码",
        Product: "产品",
        Issuer: "指令下达人",
        IssuedDate: "指令下达时间",
        Creator: "创建人",
        CreationDate: "创建时间",
        State: "状态",
        //创建人
        // Creator:"创建人",


        save: "保存",
        list: "列表",
        state: "状态",
        BatchInstructionsCode1: "批指令编码",
        Creator1: "创建人",
        CreationDate1: "创建时间",
        State1: "状态",
        Auditor: "审核人",
        CompletionTime: "完成时间",
        OrderNumber: "订单编号",
        TraceabilityCode: "追溯码",
        ProductName: "产品名称",
        PreparationAmount: "制备量",
        ProductionStartDate: "生产起始日期",
        ProductionEndDate: "生产结束日期",
        BatchInstructionsIssuer: "批指令下达人",
        InstructionsIssuedDate: "指令下达时间",
        MaterialPreparationList: "备料单",
        MaterialPreparationListState: "备料单状态",
        SampleInformation: "样本信息",
        BOMList: "BOM清单",
        GenerateOutboundOrder: "生成备料单",
        ProductionPlanArrangement: "流程计划安排",
        PleaseSelectOrder: "请选择订单",
        PleaseSelectOperator: "请选择操作人",
        PleaseSelectAuditor: "请选择审核人",
        PleaseSelectRoom: "请选择房间",
        PleaseSelectOperator1: "请选择操作人",
        PleaseSelectCategory: "请选择类别",
        confirm: "确认",
        Verification: "验证",
        UserName: "用户名",
        Password: "密码",
        Reason: "原因",
        confirm1: "确认",
        RoomNumber: "房间编号",
        RoomName: "房间名称",
        Area: "所在区域",
        Creator2: "创建人",
        TodayArrangementTimes: "今日安排次数",
        OccupancyStatus: "占用状态",
        ExpirationDate: "距效期",
        Name: "名称",
        OrderNumber1: "订单号",
        ProductName1: "产品名称",
        ProductTraceabilityCode: "产品追溯码",
        ProductBatchNumber: "追溯码",
        OperationDate: "操作日期",
        Procedure: "工序",
        StepName: "步骤名称",
        Operator: "操作人",
        Room: "房间",
        ProcessConfiguration: "流程配置",
        TimeConsuming: "用时（天）",
        RawAndAuxiliaryMaterialNumber: "原辅料编号",
        RawAndAuxiliaryMaterial: "原辅料",
        PreparationAmount1: "准备用量",
        Unit: "单位",
        OutboundBatchNumber: "出库批次",
        OutboundAmount: "出库量",
        OutboundUnit: "出库单位",
        Barcode: "条形码",
        SampleName: "样本名称",
        SamplingDate: "采样时间",
        AlreadyOutbound: "已出库",
        Prompt: "提示",
        AlreadyGeneratedMaterialRequisition: "已生成备料单",
        OutboundSuccess: "出库成功",
        AlreadyOutbound1: "已出库",
        Prompt1: "提示",
        AlreadyGeneratedMaterialRequisition1: "已生成备料单",
        Success: "成功",
        ModifySuccess: "修改成功",
        Success1: "成功",
        SaveSuccess: "保存成功",
        //"新建"
        New: "新建",
        //"完成"
        Complete: "完成",
        //操作人或房间未选择
        OperatorOrRoomNotSelected: "操作人或房间未选择",
        //未生成备料单
        MaterialRequisitionNotGenerated: "未生成备料单",
        //备料单未出库
        MaterialRequisitionNotOutbound: "备料单未出库",
        //'待出库'
        PendingOutbound: "待出库",
        //'已出库'
        AlreadyOutbound2: "已出库",
        //请先保存数据
        PleaseSaveDataFirst: "请先保存数据",
        //筛选号
        FilterNumber: "筛选号",
        //开始时间
        StartTime: "开始时间",
        //结束时间
        EndTime: "结束时间",
        //'确认成功'
        ConfirmSuccess: "确认成功",
        //'作废成功'
        CancellationSuccess: "作废成功",
        //账号或密码错误
        AccountOrPasswordError: "账号或密码错误",
        //请先保存信息
        PleaseSaveInformationFirst: "请先保存信息",
        //已生成出库单，不可更改订单！
        CannotBeChanged: "已生成出库单，不可更改订单！",
    },

    FinishMaster: {
        FinishMaster: "成品主数据",

        Warehouse: "仓库",
        BasicInformation: "基本信息",
        Number: "编号",
        Name: "名称",
        Batch: "有批次",
        Category: "类别",
        State: "状态",
        StorageLocation: "存储位置",
        ItemNumber: "货号",
        Creator: "创建人",
        WhetherToDisableTheReminder: "是否失效提醒",
        CreationDate: "创建日期",
        EnglishName: "英文名称",
        Specifications: "规格",
        Alias: "别名",
        InventoryInformation: "库存信息",
        InventoryQuantity: "库存数量",
        UnitGroup: "单位组",
        Unit: "单位",
        StorageConditions: "存储条件",
        OutboundPrice: "出库价格",
        ReminderLeadTime: "提醒提前期",
        SafetyStockQuantity: "安全库存数量",
        DurableDays: "耐用天数",
        Remarks: "备注",
        OutboundUnitGroup: "出库单位组",
        OutboundUnit: "出库单位",
        ManufacturerInformation: "生产商信息",
        Principal: "负责人",
        StorageDetails: "出库明细",
        NoData: "没有数据",
        LoadingData: "加载数据中",
        Effective: "有效",
        Invalid: "无效",
        Released: "已放行",
        NotReleased: "未放行",
        No: "否",
        Yes: "是",
        BatchNumber: "批号",
        ProductionDate: "生产日期",
        ExpirationDate: "失效期",
        StorageDate: "入库日期",
        BatchStock: "本批次存量",
        MainUnit: "主单位",
        State1: "状态",

        NoData1: "没有数据",
        LoadingData1: "加载数据中",
        New: "新建",
        Export: "导出",
        PleaseEnterTheInformationYouWantToQuery: "请输入查询的信息",
        Operation: "操作",
        MasterDataNumber: "主数据编号：",
        Effective1: "有效",
        Invalid1: "无效",
        Yes1: "是",
        No1: "否",
        Number1: "编号",
        Specifications1: "规格",
        Creator1: "创建人",
        CreationDate1: "创建日期",
        WhetherToDisableTheReminder1: "是否失效提醒",
        InventoryQuantity1: "库存数量",
        Name1: "名称",
        ManufacturerName: "生产商名称",
        StorageLocation1: "存储位置",
        Remarks1: "备注",


        save: "保存",
        list: "列表",
        Warehouse1: "仓库",
        BasicInformation1: "基本信息",
        Number2: "编号",
        Name2: "名称",
        Batch1: "有批次",
        Category1: "类别",
        State2: "状态",
        StorageLocation2: "存储位置",
        ItemNumber1: "货号",
        Creator2: "创建人",
        WhetherToDisableTheReminder2: "是否失效提醒",
        CreationDate2: "创建日期",
        EnglishName1: "英文名称",
        Specifications2: "规格",
        Alias1: "别名",
        InventoryInformation1: "库存信息",
        InventoryQuantity2: "库存数量",
        UnitGroup1: "单位组",
        Unit1: "单位",
        StorageConditions1: "存储条件",
        OutboundPrice1: "出库价格",
        ReminderLeadTime1: "提醒提前期",
        SafetyStockQuantity1: "安全库存数量",
        DurableDays1: "耐用天数",
        Remarks2: "备注",
        OutboundUnitGroup1: "出库单位组",
        OutboundUnit1: "出库单位",
        ManufacturerInformation1: "生产商信息",
        Principal1: "负责人",
        PleaseSelect: "请选择一条记录！",
        NoData2: "没有数据",
        LoadingData2: "加载数据中",
        Operation1: "操作",
        StorageDetails1: "入库明细",
        NoData3: "没有数据",
        LoadingData3: "加载数据中",
        Yes2: "是",
        No2: "否",
        Effective2: "有效",
        Invalid2: "无效",
        Released1: "已放行",
        NotReleased1: "未放行",
        ProjectNameCannotBeEmpty: "项目名称不能为空",
        ProjectBatchCannotBeEmpty: "项目批次不能为空",
        ProjectTypeCannotBeEmpty: "项目类别不能为空",
        ProjectStatusCannotBeEmpty: "项目状态不能为空",
        BatchNumber1: "批号",
        supplierName: "供应商名称",
        ProductionDate1: "生产日期",
        ExpirationDate1: "失效期",
        StorageDate1: "入库日期",
        BatchStock1: "本批次存量",
        MainUnit1: "主单位",
        State3: "状态",
        Code: "编码",
        Describe: "描述",
        ConversionFactor: "转换系数",
        MainUnit2: "主单位",
        SubordinateUnit: "副单位",
        State4: "状态",
        Code1: "编码",
        Describe1: "描述",
        Remarks3: "备注",
        Code2: "编码",
        Name3: "姓名",
        Code3: "编码",
        Name4: "名称",
        SystemCode: "系统编码",
        IdentificationCode: "标识码",
        // 是否qc
        WhetherQC: "是否QC",
        //生产商
        Manufacturer: "生产商",
        //请选择生产商
        PleaseSelectManufacturer: "请选择生产商",
        //生产商编号
        ManufacturerNumber:"生产商编号",
        //生产商名称
        NameOfManufacturer:"生产商名称",
        //生产商联系方式
        ManufacturerContactInformation:"生产商联系方式",




    },
    StorageInProduct: {
        StorageInProduct: "库存入库",

        Number: "编号",
        Creator: "创建人",
        CreationDate: "创建时间",
        Describe: "描述",
        StorageDate: "入库时间",
        State: "状态",


        save: "保存",
        list: "列表",
        State1: "状态",
        edit: "编辑数据",
        ProductNumber: "成品编号",
        Name: "名称",
        ItemNumber: "货号",
        Specifications: "规格",
        ProductionDate: "生产日期",
        ProductBatchNumber: "产品批号",
        ExpirationDate: "失效日期",
        StorageQuantity: "入库数量",
        Unit: "单位",
        StorageLocationID: "储位ID",
        StorageLocation: "存储位置",
        Remarks: "备注",
        save1: "保存",
        validate: "验证",
        UserName: "用户名",
        Password: "密码",
        Reason: "原因",
        confirm: "确认",
        pleaseSelect: "请选择类别",
        confirm1: "确认",
        Number1: "编号",
        Describe1: "描述",
        StorageDate1: "入库时间",
        Department: "部门",
        StorageType: "入库类型",
        StorageDetails: "入库明细",
        NoData: "没有数据",
        LoadingData: "加载数据中",
        PrintLabel: "打印标签",
        Operation: "操作",
        ProductNumber1: "成品编号",
        Name1: "名称",
        Manufacturer: "生产商",
        ItemNumber1: "货号",
        Specifications1: "规格",
        ProductionDate1: "生产日期",
        ProductBatchNumber1: "产品批号",
        ExpirationDate1: "失效日期",
        StorageQuantity1: "入库数量",
        Unit1: "单位",
        StorageLocationID1: "储位ID",
        StorageLocation1: "存储位置",
        Remarks1: "备注",

        saveSuccess: "保存成功",
        saveFailed: "保存失败",

        //追溯码
        TraceCode: "追溯码",
        new: "新建",
        complete: "完成",
        //用户名或密码错误
        UserNameOrPasswordError: "用户名或密码错误",
        //入库状态已完成
        StorageStatusCompleted: "入库状态已完成",
        //入库状态未完成
        StorageStatusUnfinished: "入库状态未完成",

    },
    StorageOutProduct: {
        StorageOutProduct: "库存出库",

        Number: "编号",
        Recipient: "领用人",
        Creator: "创建人",
        CreationDate: "创建日期",
        Describe: "描述",
        State: "状态",

        save: "保存",
        list: "列表",
        State1: "状态",
        pleaseSelect: "请选择批准人",
        NoData: "没有数据",
        LoadingData: "加载数据中",
        Operation: "操作",
        pleaseSelect1: "请选择一条记录！",
        edit: "编辑数据",
        ProductNumber: "成品编号",
        Name: "名称",
        ItemNumber: "货号",
        Specifications: "规格",
        ProductBatchNumber: "批号",
        Stock: "库存量",
        BatchStock: "本批次存量",
        UnitGroup: "单位组",
        OutboundQuantity: "出库数量",
        MainUnit: "主单位",
        OutboundQuantity1: "出库数量",
        SubordinateUnit: "副单位",
        StorageLocationID: "储位ID",
        StorageLocation: "存储位置",
        Remarks: "备注",
        ProductBatchNumber1: "产品批号",
        Department: "部门",
        save1: "保存",
        validate: "验证",
        UserName: "用户名",
        Password: "密码",
        Reason: "原因",
        confirm: "确认",
        pleaseSelect2: "请选择类别",
        confirm1: "确认",
        Number1: "编号",
        Describe1: "描述",
        Recipient1: "领用人",
        LogisticsNumber: "物流单号",
        LogisticsCompany: "物流公司",
        StockSample: "库存样本",
        NoData1: "没有数据",
        LoadingData1: "加载数据中",
        Batch: "批次",
        Operation1: "操作",
        StorageDetails: "出库明细",
        save2: "保存",
        delete: "删除明细",
        PrintLabel: "打印标签",
        Operation2: "操作",
        yes: "是",
        no: "否",
        confirm2: "确定删除吗?",
        prompt: "提示",
        Name1: "姓名",
        ProductNumber1: "成品编号",
        Name2: "名称",
        ItemNumber1: "货号",
        Specifications1: "规格",
        ProductNumber2: "成品编号",
        ProductBatchNumber2: "批号",
        ProductionDate: "生产日期",
        ExpirationDate: "失效日期",
        StorageQuantity: "入库数量",
        StorageDate: "入库日期",
        BatchStock1: "本批次存量",
        ProductNumber3: "成品编号",
        Name3: "名称",
        ItemNumber2: "货号",
        Specifications2: "规格",
        ProductionDate1: "生产日期",
        ProductBatchNumber3: "产品批号",
        ExpirationDate1: "失效日期",
        StorageQuantity1: "出库数量",
        Unit: "单位",
        StorageLocationID1: "储位ID",
        StorageLocation1: "存储位置",
        Remarks1: "备注",
        LogisticsCompanyNumber: "物流公司编号",
        LogisticsCompanyName: "物流公司名称",

        //出库状态已完成
        StorageStatusCompleted: "出库状态已完成!",
        //出库状态未完成
        StorageStatusUnfinished: "出库状态未完成!",
    },
    documentEffectTips: {
        message: "确认",
        confirm: "您确定要继续吗？",
        cancel: "您已取消！",
    },


    processExcutionList: {
        addProcessExcutionList: "添加流程执行表",
        deleteYN: "是否确认删除",
        tips: "提示",
        confirm: "确认",
        cancel: "取消",
    },
    processExecutionEdit: {
        PZLBH: "批指令编号",
        orderID: "订单编号",
        state: "状态",
        creater: "创建人",
        createDate: "创建时间",
        reviewedBy: "审核人",
        reviewedDate: "审核时间",
        room: "操作房间",
        operator: "操作人",
        estimatedDate: "预计用时",
        startTime: "开始时间",
        endTime: "结束时间",
        dongcun: "冻存盒标签",
        chanpin: "产品袋标签",
        ScanCodeRecord: "扫码记录",
        value: "值",
        ScanTime: "扫码时间",
        PleaseSelect: "请选择",
        ReasonForReturn: "退回原因",
        ScanCodeBox: "扫码框",
        code: "编号",
        order: "订单",
        lczx: "流程执行",
        document: "文件",
        close: "关闭",
        yswdtj: "运输温度条件",
        Sampler: "取样人",
        phone: "手机号码",
        SamplingAddress: "取样地址",
        wllxfs: "物流联系方式",
        logisticsCompanies: "物流公司",
        logisticsPerson: "快递员",
        logisticsOrderId: "快递单号",
        transportCondition: "运输方式",
        wendujiguanbi: "温度计关闭时间",
        jieshouren: "接收人",
        jieshoushijian: "接收时间",
        CZRBYZWFBJ: "操作人不一致,无法编辑",
        pleaseSave: "请先保存",
        tips: "提示",
        qxwcsybz: "请完成所有步骤",
        ReceivedSuccessfully: "已生成入库单！",
        WarehousingFailed: "入库失败！",
        QTXPC: "请填写批次！",
        DeliverySuccessful: "出库成功！",
        OutboundFailed: "出库失败！",
        MYPCWFCK: "没有批次，无法出库！",
        ScanCodeSuccessfully: "扫码成功",
        GPCYSM: "该批次已扫码",
        ScanCodeFailed: "扫码失败",
        ZTWQRBNJRXYB: "状态未确认，不能进入下一步",
        confirm: "确认",
        cancel: "取消",
        Completed: "已完成",
        FWQFMQSHZS: "服务器繁忙，请稍后尝试",
        WLLJSBQCS: "网络连接失败，请重试",
        //编号
        Number: "编号",
        //运输
        transport: "运输",


    },
    processVUE: {
        room: "操作房间",
        operator: "操作人",
        estimatedDate: "预计用时",
        startTime: "开始时间",
        endTime: "结束时间",
        dongcun: "冻存盒标签",
        chanpin: "产品袋标签",
        PleaseSelect: "请选择",
        ReasonForReturn: "退回原因",
        ScanCodeBox: "扫码框",
        ScanCodeRecord: "扫码记录",
        code: "编号",
        close: "关闭",
        yswdtj: "运输温度条件",
        Sampler: "取样人",
        phone: "手机号码",
        SamplingAddress: "取样地址",
        wllxfs: "物流联系方式",
        logisticsCompanies: "物流公司",
        logisticsPerson: "快递员",
        logisticsOrderId: "快递单号",
        transportCondition: "运输方式",
        wendujiguanbi: "温度计关闭时间",
        jieshouren: "接收人",
        jieshoushijian: "接收时间",
        state: "状态",
        tips: "提示",
        qxwcsybz: "请完成所有步骤",
        ConfirmedSuccessfully: "确认成功",
        VoidedSuccessfully: "作废成功",
        ReceivedSuccessfully: "入库成功！",
        WarehousingFailed: "入库失败！",
        QTXPC: "请填写批次！",
        DeliverySuccessful: "出库成功！",
        OutboundFailed: "出库失败！",
        MYPCWFCK: "没有批次，无法出库！",
        confirm: "确认",
        cancel: "取消",
        Completed: "已完成",
        FWQFMQSHZS: "服务器繁忙，请稍后尝试",
        WLLJSBQCS: "网络连接失败，请重试",
    },
    masterdataFlowPathConfigVUE: {
        ExpectedTime: "预计用时",
        used: "使用量",
        unit: "单位",
        pzljs: "批指令接收",
        Release: "放行",
        id1: "步骤编号",
        id2: "追朔码",
        id3: "订单编号",
        id4: "批指令单号",
        id5: "样本条码号",
    },
    coiOrderEdit: {
        qxzlb: "请选择类别",
        returnReason: "退回原因",
        confirm: "确认",
        checking: "验证",
        Username: "用户名",
        passward: "密码",
        reason: "原因",
        tabulation: "列表",
        state: "状态",
        Successfully: "成功",
        SuccessfullyReturned: "退回成功",
        ConfirmedSuccessfully: "确认成功",
    },
    ExperimentalTypeConfigurationPublic: {
        ExperimentalTypeConfiguration: "实验类型配置",
    },
    ExperimentalTypeConfigurationList: {
        experimentalTypeName: "实验类型名称",
        state: "是否有效",
        creator: "创建人",
        createTime: "创建时间",
        yes: "是",
        no: "否",
        SuccessfullySaved: "保存成功",
        SaveFailed: "保存失败",
        SuccessfullyDeleted: "删除成功",
        save: "保存",
        effectiveperson: "生效人",
        effectivetime: "生效时间",
        takeEffect: "生效",
        istakeEffect: "是否生效",
        code: "实验编号标识",
        Confirm: "你确认要",
        me: "吗？",
        stateTakeEffect: "是否确认生效",
        SuccesstakeEffect: "成功生效",
        failedtotakeeffect: "生效失败",
        //实验类型名称不能为空
        ExperimentalTypeNameCannotBeEmpty: "实验类型名称不能为空",
        //数据库表后缀不能为空
        DatabaseTableSuffixCannotBeEmpty: "数据库表后缀不能为空",
        //实验编号标识不能为空
        ExperimentalNumberIdentifierCannotBeEmpty: "实验编号标识不能为空",
        ExperimentalNumberIdentifierCannotBeEmpty2: "平台不能为空",
        //请选择一条数据
        PleaseSelectARecord: "请选择一条数据",
    },
    workflowHistoryPublic: {
        workflowHistory: "审批历史",
    },
    workflowHistoryList: {
        //流程实例ID
        processInstanceId: "流程实例ID",
        //发起人ID
        startUserId: "发起人ID",
        //相关表单ID
        businessKey: "相关表单ID",
        //表单名称
        formName: "表单名称",
        //表单对应实体的类路径
        entityPath: "表单对应实体的类路径",
    },
    WorkflowNodePublic: {
        WorkflowNode: "工作流节点",
    },
    WorkflowNodeList: {
        name: "名称",
        cls: "类路径",
        oper: "是否通过",
        orderBlock: "模块名称",
        note: "备注",
        pleaseSelect: "请选择",
        pass: "通过",
        noPass: "不通过",
    },
    WorkflowNodeEdit: {
        save: "保存",
        back: "列表",
        NAME: "名称",
        pleaseSelect: "请选择",
        pass: "通过",
        noPass: "不通过",
        data: "name",
        SuccessfullyAdded: "保存成功",
        SaveFailed: "保存失败",
        SuccessfullyModified: "更新成功",
        UpdateFailed: "更新失败",
        describe: "描述",
        classPath: "类路径",
        SelectBlock: "选择区块",
        ApprovalOptionDefinition: "审批选项定义",
        PassedorNot: "是否通过",
        status: "状态码",
        StatusName: "状态名称",
        Note: "备注",
        founder: "创建人",
        CreationTime: "创建时间",
        SelectBlockPopup: "选择区块弹窗",
    },
    //储存盒子
    storagePositionBox: {
        storagePositionBox: "储存盒子",
        add: "添加明细",
        del: "删除选中",
        save: "保存",
        container: "选择容器",
        sampleType: "选择样本类型",
        id: "编号",
        name: "描述",
        newLocationId: "新储位号",
        locationName: "存储位置",
        storageContainerId: "容器编号",
        storageContainer: "容器",
        state: "状态",
        typeId: "样本类型编号",
        pleaseSelect: "请选择",
        type: "样本类型",
        typeMark: "编码标记",
        containerId: "容器编号",
        containerName: "容器名称",
        containerColNum: "列数",
        containerRowNum: "行数",
        containerType: "类型",
        SavedSuccessfully: "保存成功",
        SaveFailed: "保存失败",
        //迁移记录
        storagePositionBoxMove: {
            storagePositionBoxMove: "迁移记录",
            id: "编号",
            name: "描述",
            locationId: "储位ID",
            locationName: "储位描述",
            changeUser: "修改人",
            changeDate: "修改时间",
            state: "状态",
            note: "备注",
            storagePositionBoxId: "盒子编号",
            storagePositionBoxName: "盒子描述",
        },
        //样本信息
        storagePositionBoxSample: {
            storagePositionBoxSample: "样本信息",
            id: "编号",
            code: "描述",
            sampleCode: "储位编号",
            sampleType: "储位描述",
            storagePositionBoxId: "盒子编号",
            storagePositionBoxName: "盒子描述",
            boxLocation: "盒子位置",
        },
    },

    ApprovalHistory: {
        //流程实例ID
        processInstanceId: "流程实例ID",
        //发起人ID
        startUserId: "发起人ID",
        //发起人
        startUserName: "发起人",
        //相关表单ID
        businessKey: "相关表单ID",
        //表单名称
        formName: "表单名称",
        //表单对应实体的类路径
        entityPath: "表单对应实体的类路径",
        //表单提示
        formTips: "表单提示",
        //开始时间
        startTime: "开始时间",
        //结束时间
        endTime: "结束时间",
        //业务ID
        businessId: "业务ID",
        //版本
        version: "版本",
        //状态
        state: "状态",
        //是否子流程
        isSubProcess: "是否子流程",
        //主流程ID
        parentProcessInstanceId: "主流程ID",
        //任务名称
        taskName: "任务名称",
        //办理人
        assignee: "办理人",
        //办理时间
        claimTime: "办理时间",
        //办理结果
        claimResult: "办理结果",
        //办理意见
        claimOpinion: "办理意见",
        //代办信息
        todoInfo: "代办信息",
        //审批明细
        approvalDetail: "审批明细",
        //查看表单
        viewForm: "查看表单",
        //未查询到相关表单ID对应的路由信息
        noRouterInfo: "未查询到相关表单ID对应的路由信息",
        //请选择一条数据
        PleaseSelectARecord: "请选择一条数据",
    },

    storageOut: {
        outbound: "出库管理",
        orderNo: "出库单号",
        person: "出库人",
        time: "出库时间",
        creator: "创建人",
        createTime: "创建时间",
        batch: "批次",
        state: "状态",
        confirmUser: "审核人",
        choosePerson: "请选择出库人",
        chooseConfirmPerson: "请选择审核人",
        verification: "验证",
        username: "用户名",
        password: "密码",
        reason: "原因",
        confirm: "确认",
        type: "请选择类别",
        saveBtn: "保存",
        listBtn: "列表",
        submitBtn: "提交",
        stateBtn: "状态",
        name: "姓名",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        submitSuccess: "提交成功",
        submitFail: "提交失败",
        note: "描述",
        pleaseSave: "请先保存",

        inventoryMasterData: {
            masterData: "库存主数据",
            batch: "批次",
            reagentNo: "试剂编号",
            batchNum: "批次号",
            supplier: "供应商",
            batchNo: "批号",
            expirationPeriod: "失效期",
            reminderTime: "提醒时间",
            warehousingTime: "入库时间",
            stock: "本批次存量",
            position: "存储位置",
            note: "sn",
            note2: "备注2",
        },
        storageOutItem: {
            reagentNo: "试剂编号",
            batchNum: "批次号",
            deliveryDetails: "出库明细",
            batch: "批次",
            name: "名称",
            supplier: "供应商",
            spec: "规格",
            batchId: "批次编号",
            batchNo: "批号",
            Inventory: "库存量",
            batchStock: "本批次存量",
            expirationPeriod: "失效期",
            qc: "qc状态",
            deliveryQuantity: "出库数量",
            unit: "单位",
            sn: "SN",
            createUser: "创建人",
            createDate: "创建时间",
            reminderTime: "提醒时间",
            warehousingTime: "入库时间",
            stock: "本批次存量",
            position: "存储位置",
            note: "备注1",
            note2: "备注2",
        }
    },
    storageIn: {
        storageIn: "入库管理",
        orderNo: "入库单号",
        note: "描述",
        createUser: "创建人",
        createDate: "创建时间",
        confirmUser: "审核人",
        confirmDate: "审核时间",
        state: "状态",
        verification: "验证",
        username: "用户名",
        password: "密码",
        reason: "原因",
        confirm: "确认",
        type: "请选择类别",
        saveBtn: "保存",
        listBtn: "列表",
        submitBtn: "提交",
        stateBtn: "状态",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        submitSuccess: "提交成功",
        batchNo: "请选择出库人",
        name: "名称",
        chooseConfirmPerson: "请选择审核人",

        inventoryMasterData: {
            masterData: "库存主数据",
            batch: "批次",
            reagentNo: "试剂编号",
            batchNum: "批次号",
            supplier: "供应商",
            batchNo: "批号",
            expirationPeriod: "失效期",
            reminderTime: "提醒时间",
            warehousingTime: "入库时间",
            stock: "本批次存量",
            position: "存储位置",
            note: "备注1",
            note2: "备注2",
        },
        storageInItem: {
            name: "名称",
            supplier: "供应商",
            spec: "规格",
            inNum: "主单位数量",
            unit: "主单位",
            viceNum: "副单位数量",
            viceUnit: "副单位",
            position: "保存位置",
            note: "SN",
            note2: "备注",
            batch: "批号",
            createUser: "创建人",
            createDate: "创建时间",
            expireDate: "过期时间",
        }
    },
    // 生物样本库相关国际化
    BioBank: {
        SampleStorage: "样本入库",
        PendingSample: "待入库样本",
        ListOfRefrigeratedCabinets: "冷藏柜列表",
        RefrigeratedCabinetDisplay: "冷藏柜展示",
        SampleDelivery: "样本出库",
        SampleCode: "原始样本编号",
        Code: "样本编号",
        SampleType: "样本类型",
        SamplePosition: "样本位置",
        SampleStatus: "样本状态",
        Concentration: "浓度",
        Volume: "体积",
        SumTotal: "总量",
        Unit: "单位",
        ProductId: "产品编号",
        ProductName: "产品名称",
        CreateUser: "创建人",
        CreateDate: "创建时间",
    },
    InventoryMasterData: {
        Spec: "规格",
        Batch: "批次",
        BatchNo: "批号",
        LoseEffectivenessWarningOrNot: "是否失效提醒",
        Stock: "库存数量",
        UnitGroup: "单位组",
        WarningDays: "预警天数",
        QCOrNot: "是否质检",
        Name: "名称",
        HasQC: "已质检",
        NoQC: "未质检",
        StockUnit: "库存单位",
        MaterialPurchaseDetail: "物资采购明细",
        Manufacturer: "生产商",

    },
    StorageIn: {
        Title: "入库",
        // 入库单列表
        List: "入库单列表",
        PurchaseOrderNo: "采购订单编号",
        MaterialCode: "物料编号",
        MaterialName: "物料名称",
        // 入库总量
        Total: "入库总量",
    },
    StorageOut: {
        title: "出库",
        list: "出库单列表",
        MaterialCode: "物料编号",
        MaterialName: "物料名称",
        // 出库到实验
        ToExperiment: "出库到实验",
        // 销毁
        Destroy: "销毁",
        Type: "出库类型",
        // 批量添加
        BatchAdd: "批量添加",
        //打包出库
        PackageOut: "打包出库",
    },
    ReagentMainData: {
        Title: "试剂主数据",
        List: "试剂主数据列表",
    },
    TargetValue: {
        targetValue: "靶值",
        save: "保存",
        batchInput: "批量录入",
        selectControl: "请选择质控品",
        selectProduct: "请选择产品",
        sd: "SD",
        cv: "CV",
        upperControlLimit: "失控上限",
        lowerControlLimit: "失控下限",
        controlName: "质控品",
        productName: "产品",
        enableTime: "启用时间",
        endTime: "截止时间",
        createUserName: "创建人",
        createDate: "创建时间",
        controlId: "质控品编号",
        productId: "产品编号",
        selectControl1: "选择质控品",
        selectProduct1: "选择产品",
        selectOneData: "请选择一条数据",
        number: "靶值，SD,CV,失控上限，失控下限，应该填写数字",
        numberIsValidValue: "靶值或SD应该填写数字",
        numberIsValidSD: "SD应该填写数字",
        numberIsValidCV: "CV应该填写数字",
        numberUpperControlLimit: "失控上限应该填写数字",
        numberLowerControlLimit: "失控下限应该填写数字",
        enableTimeIsNull: "启用时间不能为空",
        endTimeIsNull: "截止时间不能为空",
        pleaseSelectData: "请选择数据！",
        saveInfo: "保存成功",
        updateInfo: "修改成功",
        enableTimeIsAfter: "启用时间应在当前时间之后",
        enableTimeIsBefore: "启用时间应在截止时间之前",
        endTimeIsAfter: "截止时间应在当前时间之后",
        endTimeIsBefore: "截止时间应在启用时间之后",
    },
    QualityMaintenance: {
        qualityMaintenancd: "质控数据维护",
        save: "保存",
        batchInput: "批量录入",
        selectControl: "请选择质控品",
        selectProduct: "请选择产品",
        controlDate: "质控日期",
        controlName: "质控品",
        controlId: "质控品编号",
        controlBatchNo: "质控品批号",
        productName: "产品",
        targetValue: "靶值",
        SD: "SD",
        CV: "CV",

        controlResult: "质控结果",
        controlState: "失控状态",
        controlReason: "失控原因",
        controlDeal: "失控处理",
        dealResult: "处理结果",
        dealUser: "处理人",
        dealTime: "处理时间",
        auditUser: "审核人",
        auditTime: "审核时间",
        auditState: "审核状态",
        createUserName: "创建人",
        createDate: "创建时间",

        controlId1: "质控品编号",
        controlName1: "质控品",
        productId: "产品编号",
        productName1: "产品",
        selectControl1: "选择质控品",
        selectProduct1: "选择产品",
        selectOneData: "请选择一条数据",
        number: "靶值，SD,CV,质控结果,应该填写数字",
        selectControlDate: "请选择质控日期",

        qualityChart: "生成质控图",
        queryDate: "查询日期",
        startTime: "开始时间",
        endTime: "结束时间",
        qualityDataInterpretation: "质控数据解读",
        lostControl: "已失控",
        notLostControl: "未失控",
        audited: "已审核",
        notAudited: "未审核",
        endTimeGreaterThanStartTime: "结束时间应大于开始时间",
        pleaseFilterTheSameControl: "请筛选出同一质控品后生产质控图",
        controlResult1: "质控结果",
        standardDeviation1Max: "标准差1最大值",
        standardDeviation1Min: "标准差1最小值",
        standardDeviation2Max: "标准差2最大值",
        standardDeviation2Min: "标准差2最小值",
        standardDeviation3Max: "标准差3最大值",
        standardDeviation3Min: "标准差3最小值",
        dateInquiry: "查询日期",
        confirm: "确定",
        saveInfo: "保存成功",
        updateInfo: "修改成功",
        //靶值，SD,CV,质控结果不能为空
        controlResultIsNull: "靶值，SD,CV,质控结果不能为空",
        controlResultIsNumber: "质控结果应该填写数字",
    },


    SampleOrder: {
        Title: "订单",
        OrderNo: "订单编号",
        List: "订单列表",
    },

    // 工作流状态
    WorkflowStatus: {
        "3": "新建",
        "1": "完成",
        "0": "作废",
        "15": "待修改",
        "20": "已提交",
    },
    // 性别
    Gender: {
        "1": "男",
        "0": "女",
        "2": "未知",
    },
    // 报告任务发送
    reportTaskDistributionList: {
        // id
        id: "编号",
        // 原始样本编号
        sampleNo: "原始样本编号",
        // 订单编号
        orderNo: "订单编号",
        // 检测项目
        productName: "产品名称",
        // 平台流入
        platformFlow: "平台流入",
        // 实验流入
        experimentFlow: "实验流入",
        // 报告撰写人
        reportWriter: "报告撰写人",
        // 创建人
        createUserName: "创建人",
        // 创建时间
        createDate: "创建时间",
        // 状态
        state: "状态",
        // 姓名
        name: "姓名",
        // 请选择撰写人
        selectWriter: "请选择撰写人",
        // 请先选择数据
        pleaseSelectData: "请先选择数据!",
        // 批量录入-撰写人
        batchEntryWriter: "撰写人",
        // 合并生成
        mergeGeneration: "合并生成",
        // 单个生成
        singleGeneration: "单个生成",
        // 未选择撰写人！
        pleaseSelectWriter: "未选择撰写人！",
        // 选择成功
        selectSuccess: "选择成功",
        // 操作失败
        operationFailed: "操作失败",
        // 生成成功
        generationSuccess: "生成成功",
        //订单编号存在不同数据，无法进行合并生成，请重新选择！
        mergeOrder: "订单编号存在不同数据，无法进行合并生成，请重新选择！",
        //报告任务分发
        reportTaskDistribution: "报告任务分发",
        isRetract: "是否撤回",
        //是
        yes: "是",
        //否
        no: "否",

    },
    ExperimentTypeConfig: {
        databaseTableSuffix: "数据库表后缀",
        platform: "平台",
    },

    ExportExperimentEdit: {
        //外送实验
        exportExperiment: "外送实验",
        //检测项目
        productName: "产品名称",
        //样本类型
        sampleType: "样本类型",
        //原始样本编号
        sampleNo: "原始样本编号",
        //下一步流向
        nextFlow: "下一步流向",
        //状态名称
        stateName: "状态名称",
        //外送单位
        exportUnit: "外送单位",
        //地址
        address: "地址",
        //是否已外送
        isExport: "是否已外送",
        //外送人
        exportUser: "外送人",
        //外送时间
        exportTime: "外送时间",
        //外送原因
        exportReason: "外送原因",
        //期望出报告时间
        expectReportTime: "期望出报告时间",
        //检测结果
        testResult: "检测结果",
        //出具报告时间
        reportTime: "出具报告时间",
        //登记报告时间
        registerReportTime: "登记报告时间",
        //创建人
        createUserName: "创建人",
        //创建时间
        createDate: "创建时间",

        //样本信息
        sampleInfo: "选择信息",
        //外送
        export: "外送",
        //提交样本
        submitSample: "提交样本",
        //请选择一条数据
        selectOneData: "请选择一条数据",

        //检测项目：
        productNameMix: "产品名称：'",
        //未选择下步流向
        notSelectNextFlow: "'未选择下步流向！",
        //未选择外送单位！
        notSelectExportUnit: "'未选择外送单位！",
        //未填写外送地址
        notWriteExportAddress: "'未填写外送地址！",
        //未填写外送原因
        notWriteExportReason: "'未填写外送原因！",
        //未填写期望出报告日期
        notWriteExpectReportTime: "'未填写期望出报告时间！",
        //外送成功
        exportSuccess: "外送成功！",
        //提交成功
        submitSuccess: "提交成功！",
        submitFail: "提交失败！",
        //上传附件
        uploadAttachment: "上传附件",
        //查看附件
        viewAttachment: "查看附件",
        //添加成功
        addSuccess: "添加成功！",

        //保存成功
        saveSuccess: "保存成功！",

        //已提交实验
        submittedExperiment: "已提交实验",
        //已外送实验
        exportedExperiment: "已外送实验",
        //待外送实验
        pendingExportExperiment: "待外送实验",

        //请选择数据
        selectData: "请选择数据！",

        //编号
        id: "编号",
        //下一步流向名称
        nextFlowName: "下一步流向名称",
        //名称
        name: "名称",

        //附件
        attachment: "附件",
        //下载
        download: "下载",
        //删除
        delete: "删除",
        //文件名
        fileName: "文件名",
        //文件上传时间
        fileUploadTime: "文件上传时间",
        //上传人
        uploadUser: "上传人",
        //是否确认删除？
        confirmDelete: "是否确认删除？",
        //删除成功
        deleteSuccess: "删除成功！",
        //您已取消
        youHaveCancelled: "您已取消！",
        //下一步流向不能为空
        nextFlowNotNull: "下一步流向不能为空！",
        //外送单位不能为空
        exportUnitNotNull: "外送单位不能为空！",
        addressNotNull: "地址不能为空！",
        exportReasonNotNull: "外送原因不能为空！",
        expectReportTimeNotNull: "期望出报告时间不能为空！",
        //该外送单位没有对应的产品信息，请在对应的供应商协议添加产品信息！
        notProductInfo: "外送单位没有对应的产品信息，请在对应的供应商协议添加产品信息！",
    },

    //区域管理
    RegionManagement: {
        //区域管理
        title: "区域管理",

        areaNo: "区域编号",
        name: "区域名称",
        state: "区域状态",
        note: "备注",
        createDate: "创建日期",
        createUserName: "创建人",

        stateYes: "可用",
        stateNo: "不可用",
        save: "保存",
        saveSuccess: "保存成功",
        saveFail: "保存失败",

        nameNotNull: "区域名称不能为空!",
        stateNotNull: "区域状态不能为空!",
    },

    //房间清洁管理
    RoomCleanManagement: {
        title: "房间清洁管理",
        title2: "清洁消毒项目",

        id: "房间清洁编号",
        note: "备注",
        cleanType: "清洁类型",
        area: "区域",
        roomId: "房间编号",
        roomName: "房间名称",
        disinfectant: "消毒剂",
        disinfectantName: "消毒剂名称",
        batch: "批号",
        disinfectStartTime: "消毒开始时间",
        disinfectValidityTime: "消毒有效期至",
        checkUserName: "复核人员",
        checkDate: "复核日期",
        userName: "用户名",
        password: "密码",
        createUser: "清洁人",
        createDate: "清洁日期",

        save: "保存",
        back: "列表",
        chooseData: "请选择数据",
        confirm: "确认",
        reCheck: "复核",
        noMatched: "用户名或密码不正确！",
        notNull: "不允许为空！",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        reCheckSuccess: "复核成功！",
        reCheckFail: "复核失败！",
        pleaseSave: "请先保存！",

        ceiling: "天花板、地面",
        ground: "地面",
        centrifuge: "离心机",
        trolley: "小推车",
        airInlet: "回风口",
        roomDoor: "房间门",
        emergencyDoor: "安全门",
        garbageBasket: "垃圾筐",
        sealingHeatExchanger: "封管热合器",
        mesa: "台面",
        biosafetyCabinet: "生物安全柜",
        incubator: "培养箱",
        workChair: "工作椅",
        transferWindow: "传递窗",
        goodsShelves: "货架",
        valvePipeline: "阀门、管路",
        storageBox: "收纳箱",
        cleaningAppliance: "清洁器具",
        doorHandle: "门把手",
        ladder: "梯子",
        stainSteelDeskTop: "不锈钢桌面",
        sterileNozzleMachine: "无菌接管机",
    },

    //环境监测模板管理
    EnMonTempManagement: {
        title: "环境监测模板管理",

        save: "保存",
        back: "列表",
        submit: "提交",
        execute: "办理",

        id: "编号",
        createUser: "创建人",
        createDate: "创建时间",
        note: "备注",
        state: "状态",
        checkType: "监测类型",
        confirmUser: "审核人",
        region: "区域",
        regionId: "区域编码",
        userName: "用户名",
        userNickName: "姓名",

        //item
        name: "名称",
        monitoringPoint: "检测点",
        type: "种类",
        testBasisName: "检测依据",

        roomDetail: "房间明细",
        insDetail: "设备明细",
        userDetail: "人员明细",
        pleaseSelect: "请选择数据",
        notNull: "不允许为空！",
        mustBePositiveInteger: "必须为正整数！",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        batchAdd: "批量添加",
        chooseType: "选择种类",
        saveFirst: "请先保存！",
        submitSuccess: "提交成功",
        submitFail: "提交失败",
        chooseTestBasis: "选择检测依据",
        fileId: "文件编码",
        fileName: "文件名称",

        //房间
        roomNo: "房间编号",
        roomName: "房间名称",
        chooseRoom: "选择房间",
        belongArea: "所属区域",
        roomState: "房间状态",
        canNotUse: "不可以使用",
        canUse: "可以使用",
        isUsed: "占用状态",
        used: "已占用",
        noUsed: "未占用",
        centiare: "房间面积m²",
        stere: "房间体积m³",
        testNo: "监测点个数",
        //设备
        insNo: "设备编号",
        insName: "设备名称",
        chooseIns: "选择设备",
        contractnumber: "序列号",
        invoicenumber: "型号",
        producerId: "生产商ID",
        producerName: "生产商名称",
        //人员
        userNo: "人员编号",
        userTitle: "人员名称",
        chooseUser: "选择人员",

        testTypeChange: "明细表中存在数据，无法修改监测类型！",
        acceptableStandard: "可接受标准",
    },

    //洁净区悬浮粒子测试记录
    SuspendedParticle: {
        title: "洁净区悬浮粒子测试记录",
        roomTestDetail: "房间检测信息",
        insTestDetail: "设备检测信息",
        room: "房间",
        ins: "设备",

        id: "编号",
        testArea: "检测区域",
        testIns: "检测设备",
        createUserNickName: "创建人",
        createDate: "创建时间",
        testDate: "检测日期",
        getUserNickName: "采样人",
        testType: "检测类型",
        cleanAreaLevel: "洁净区级别",
        stateName: "状态",
        note: "备注",
        testInsId: "检测设备编号",
        testValidDate: "检验有效期至",
        cleanAreaState: "洁净区状态",
        getAmount: "采样量",
        testBasis: "检测依据",
        confirmUser: "审核人",
        confirmDate: "审核日期",
        conclusion: "结论",
        getRoomTwoIsOk: "采样房间面积是否符合要求",
        getByPositionPic: "依据取样位置图取样",
        fileNo: "文件编号",
        upload: "上传附件",
        view: "查看附件",
        file: "附件",
        monitoringPoint: "检测点",
        monitoringPointId: "检测点编号",
        size1: "粒径≥0.5µm",
        size2: "粒径≥5.0µm",

        save: "保存",
        list: "列表",
        submit: "提交",
        execute: "办理",
        saveFirst: "请先保存数据！",
        uploadSuccess: "上传成功",
        cantNull: "不允许为空",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        submitSuccess: "提交成功",
        submitFail: "提交失败",
        pleaseSelect: "请选择数据",
        stateYes: "可用",
        stateNo: "不可用",
        noFound: "未找到该检测依据的监测点",
        testTypeChange: "检测信息表中存在数据，无法修改检测类型！",

        //检测区域
        areaNo: "区域编号",
        areaName: "区域名称",
        //设备
        insNo: "设备编号",
        insName: "设备名称",
        contractnumber: "序列号",
        invoicenumber: "型号",
        producerId: "生产商编号",
        producerName: "生产商名称",
        //采样人
        userName: "用户名",
        userNickName: "姓名",
        //检测依据
        fileId: "文件编码",
        fileName: "文件名称",
        //附件
        uploadTime: "上传时间",
        uploadUser: "上传人",

        //房间子表
        roomName: "房间名称",
        roomCode: "房间编号",
        chooseRoom: "房间模板",
        //设备子表
        chooseIns: "设备模板",
    },

    //洁净区浮游菌测试记录
    AirborneMicrobe: {
        title: "洁净区浮游菌测试记录",

        id: "编号",
        desc: "描述",
        testArea: "检测区域",
        testIns: "检测设备",
        testInsId: "检测设备编号",
        testValidDate: "校验有效期至",
        cleanAreaState: "洁净区状态",
        cultureCondition: "培养条件℃",
        cultureMediumName: "培养基名称",
        cultureMediumSpec: "培养基规格",
        cultureMediumBatch: "培养基批号",
        cultureMediumValidDate: "培养基有效期至",
        testBasis: "检测依据",
        qc: "QC",
        qcDate: "QC审核日期",
        confirmUser: "审核人",
        confirmDate: "审核日期",
        createUser: "创建人",
        createDate: "创建时间",
        testDate: "检测日期",
        getUser: "采样人",
        testType: "检测类型",
        cleanAreaLevel: "洁净区等级",
        state: "状态",
        getRoomTwoIsOk: "采样房间面积是否符合要求",
        getByPositionPic: "依据取样位置图取样",
        fileNo: "文件编号",
        fileName: "文件名称",
        note: "备注",
        pleaseSelect: "请选择数据",
        testStart: "检测开始",
        testEnd: "检测结束",
        cultureStart: "培养开始",
        cultureEnd: "培养结束",
        chooseRoom: "房间模板",
        chooseIns: "设备模板",
        printLabel: "打印标签",
        saveFirst: "请先保存数据！",
        uploadSuccess: "上传成功",
        cantNull: "不允许为空",
        saveBtn: "保存",
        listBtn: "列表",
        submitBtn: "提交",
        handle: "办理",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        submitSuccess: "提交成功",
        submitFail: "提交失败",
        noFound: "未找到该检测依据的监测点",
        testTypeChange: "检测信息表中存在数据，无法修改检测类型！",

        //检测区域弹窗
        areaId: "区域ID",
        areaName: "名称",

        //检测设备弹窗
        insNo: "设备编号",
        insName: "设备名称",
        contractnumber: "序列号",
        invoicenumber: "型号",
        producerName: "生产商名称",

        //采样人弹窗
        userName: "用户名",
        userNickName: "姓名",

        //培养基弹窗
        reagentNo: "试剂编码",
        spec: "规格",
        manufacturerName: "生产商",
        name: "名称",
        batch: "批号",
        expireDate: "过期时间",

        //检测依据
        fileId: "文件编码",

        //附件
        upload: "上传附件",
        view: "查看附件",
        file: "附件",
        uploadTime: "" +
            "上传时间",
        uploadUser: "上传人",

        //房间检测信息子表
        roomTestDetail: "房间检测信息",
        roomName: "房间名称",
        roomCode: "房间编号",
        getAmount: "采样量",
        getAmount1: "500L",
        getAmount2: "1000L",
        airborneMicrobeConcentration: "浮游菌浓度(cfu/m³)",

        //设备检测信息子表
        insTestDetail: "设备检测信息",

        //阴性对照检测信息
        negativeControlTestDetail: "阴性对照检测信息",
        negativeControl: "阴性对照",
        monitoringPoint: "检测点",
        monitoringPointId: "检测点编号",
        qrCode: "二维码",
        testStartTime: "检测开始时间",
        testEndTime: "检测结束时间",
        cultureStartTime: "培养开始时间",
        cultureEndTime: "培养结束时间",
        colonyCount: "菌落数(cfu/皿)",
        value: "数值",
        conclusion: "结论",

        //打印标签
        ip: "IP地址",
        printCode: "打印指令",
        effective: "有效",
        invalid: "无效",
    },

    //洁净区风量测试记录
    WindValue: {
        title: "洁净区风量测试记录",
        roomTestDetail: "房间检测信息",

        id: "编号",
        createUser: "创建人",
        createDate: "创建时间",
        testDate: "检测日期",
        testArea: "检测区域",
        cleanAreaLevel: "洁净区等级",
        state: "状态",
        testUser: "检测人",
        testBasis: "检测依据",

        file: "附件",
        fileName: "文件名称",
        uploadTime: "上传时间",
        uploadUser: "上传人",

        saveBtn: "保存",
        listBtn: "列表",
        submitBtn: "提交",
        handle: "办理",
        upload: "上传附件",
        view: "查看附件",

        submitSuccess: "提交成功",
        submitFail: "提交失败",
        saveFirst: "请先保存数据！",
        uploadSuccess: "上传成功",
        pleaseSelect: "请选择数据",
        noFound: "未找到该检测依据的监测点",
        cantNull: "不允许为空",
        saveSuccess: "保存成功",
        saveFail: "保存失败",

        roomName: "房间名称",
        roomCode: "房间编号",
        passFilterCode: "过滤器编号",
        windValue1: "风量1(m³/h)",
        windValue2: "风量2(m³/h)",
        windValue3: "风量3(m³/h)",
        realWindValue: "实测送风量",
        changeWindCount: "换气次数(次)",
        roomVolume: "房间体积(m³)",
        acceptableStandard: "可接受标准(≥)",
        result: "结果",
        result1: "合格",
        result0: "不合格",
        note: "备注",
        chooseRoom: "房间模板",
        userName: "用户名",
        userNickName: "姓名",
        fileId: "文件编码",
        areaId: "区域ID",
        areaName: "名称",
        insNo: "设备编号",
        insName: "设备名称",
        contractnumber: "序列号",
        invoicenumber: "型号",
        producerName: "生产商名称",
        conclusion: "结论",
        confirmUser: "审核人",
        confirmDate: "审核日期",
        testIns: "检测设备名称",
        testInsId: "检测设备编号",
    },

    //洁净区沉降菌测试记录
    SettlingMicrobe: {
        title: "洁净区沉降菌测试记录",

        id: "编号",
        desc: "描述",
        testArea: "检测区域",
        createUser: "创建人",
        createDate: "创建时间",
        testDate: "检测日期",
        getUser: "采样人",
        testType: "检测类型",
        cleanAreaLevel: "洁净区级别",
        cleanAreaState: "洁净区状态",
        state: "状态",
        cultureCondition: "培养条件℃",
        cultureMediumName: "培养基名称",
        cultureMediumSpec: "培养基规格",
        cultureMediumBatch: "培养基批号",
        testBasis: "检测依据",
        getStartDate: "采样开始时间",
        getEndDate: "采样结束时间",
        qc: "QC",
        qcDate: "QC审核日期",
        confirmUser: "审核人",
        confirmDate: "审核日期",
        conclusion: "结论",
        getRoomTwoIsOk: "采样房间面积是否符合要求",
        getByPositionPic: "依据取样位置图取样",
        fileNo: "文件编号",
        fileName: "文件名称",
        note: "备注",

        room: "房间",
        ins: "设备",

        saveBtn: "保存",
        listBtn: "列表",
        submitBtn: "提交",
        handle: "办理",
        pleaseSelect: "请选择数据",
        testTypeChange: "检测信息表中存在数据，无法修改检测类型！",
        saveFirst: "请先保存数据！",
        uploadSuccess: "上传成功",
        cantNull: "不允许为空",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        submitSuccess: "提交成功",
        submitFail: "提交失败",

        //检测区域弹窗
        areaId: "区域ID",
        areaName: "名称",
        //采样人||审核人弹窗
        userName: "用户名",
        userNickName: "姓名",
        //培养基名称弹窗
        reagentNo: "试剂编码",
        name: "名称",
        spec: "规格",
        manufacturerName: "生产商",
        batch: "批号",
        expireDate: "过期时间",
        //检测依据弹窗
        fileId: "文件编码",
        //附件
        file: "附件",
        upload: "上传附件",
        view: "查看附件",
        uploadTime: "上传时间",
        uploadUser: "上传人",

        roomTestDetail: "房间检测信息",
        insTestDetail: "设备检测信息",
        negativeControlTestDetail: "阴性对照检测信息",
        roomName: "房间名称",
        roomCode: "房间编号",
        insName: "设备名称",
        insNo: "设备编号",
        monitoringPoint: "检测点",
        monitoringPointId: "检测点编号",
        qrCode: "二维码",
        testStartTime: "检测开始时间",
        testEndTime: "检测结束时间",
        cultureStartTime: "培养开始时间",
        cultureEndTime: "培养结束时间",
        testResult: "检测结果(cfu/皿)",
        value: "数值",
        testStart: "检测开始",
        testEnd: "检测结束",
        cultureStart: "培养开始",
        cultureEnd: "培养结束",
        chooseRoom: "房间模板",
        chooseIns: "设备模板",
        printLabel: "打印标签",
        ip: "IP地址",
        printCode: "打印指令",
        effective: "有效",
        invalid: "无效",
        negativeControl: "阴性对照",
    },

    BioDialogPublic: {
        id: "编号",
        name: "名称",
        createDate: "创建时间",
        departmentName: "所属部门",
        primaryUnit: "主管单位",
        subUnit: "副单位",
        ConversionCoefficient: "转换系数",
        type: "类型",
        dutyUserName: "负责人",
        Username: "用户名",
        dic: {
            dictionaryDescription: "选择字典类型",
        },
        user: {
            selecttheuser: "选择用户",

        },
        userGroup: {
            selecttheusergroup: "选择用户组",
        },
        unitGroup: {
            selecttheunitgroup: "选择单位组",
        },
        sampleType: {
            selectthesampletype: "选择样本类型",
        },
        product: {
            selecttheproduct: "选择产品",
        },
        instrument: {
            selecttheinstrument: "选择仪器",
        },
        storage: {
            selectthestorage: "选择存储位置",
        },
        project: {
            selecttheproject: "选择项目",
        },
    },
    ProductMasterDataListRight: {
        effective: "有效",
        invalid: "无效",
        effectiveBtn: "生效",
        invalidBtn: "作废",
        code: "编号",
        name: "名称",
        inspectionCycle: "检查周期",
        earlyWarning: "预警周期",
        day: "天",
        identificationCode: "标识码",
        consumption: "用量",
        combinationOptions: "是否组合选项",
        state: "状态",
        briefName: "简称",
        experimentalProcess: "实验流程",
        productionProcessConfiguration: "生产流程配置",
        finishedProduct: "成品",
        orderContent: "订单内容",
        subproduct: "子产品",
        createUser: "创建人",
        createDate: "创建时间",
        voidTime: "作废时间",
        hideFields: "隐藏字段",
        productId: "产品ID",
        productName: "产品名称",
        price: "原价",
        discount: "折扣",
        discountPrice: "折后价格",
        experimentalTemplate: "实验模板",
        templateName: "模板名称",
        yes: "是",
        no: "否",
    },
    SampleTypeListRight: {
        id: "类型编码",
        name: "类型名称",
        state: "状态",
        first: "类型",
        picCode: "图标",
        sampleNum: "采样量",
        unit: "采样单位",
        dataVolume: "数据量",
        choose: "请选择一条记录！",
        batchUnit: "批量单位",
        upload: "上传附件",
        view: "查看附件",
        description: "说明",
        code: "样本标签",
        seqencing: "排序号",
        save: "保存",
        back: "列表",

        nail: "指甲",
        bloodCell: "血细胞",
        sperm: "精斑",
        immunohistochemical: "免疫组化片子",
        oralSwab: "口腔拭子",
        semen: "精液",
        dna: "DNA",
        heart: "心脏",
        bloodPrecipitation: "血沉淀",
        hePathological: "HE病理切片",
        urine: "尿液",
        rna: "RNA",
        paraffin: "石蜡",
        formalinSoaked: "福尔马林浸泡组织",
        boneMarrow: "骨髓",
        saliva: "唾液",
        pleuralEffusion: "胸水",
        edtaAnticoagulant: "EDTA抗凝血",
        ffpeWhite: "FFPE白片",
        ffpeRoll: "FFPE卷片",
        externalPlasma: "外部血浆",
        internalSeparation: "内部分离血浆",
        separationLeukocyte: "分离白细胞",
        ascites: "腹水",
        cerebrospinalFluid: "脑髓液",
        blood: "血液",
        freshTissue: "新鲜组织",
        valid: "有效",
        invalid: "无效",
        name1: "名称",
        saveInfo: "保存成功",
        saveInfo1: "保存失败",
        updateInfo: "更新成功",


    },


    //公用按钮
    CommonButton: {
        //保存
        save: "保存",
        //列表
        list: "列表",
        //提交
        submit: "提交",
        //状态
        state: "状态",
        //是
        yes: "是",
        //否
        no: "否",
        //未知
        unknown: "未知",
        //上传附件
        upload: "上传附件",
        //查看附件
        view: "查看附件",
        //确认
        confirm: "确认",
        //导航
        items: "导航",
        //办理
        transact:"办理",
        //记住隐藏列
        rememberHiddenColumns:"记住隐藏列",
        //删除选中
        deleteSelectedRecords:"删除选中",


    },
    //公用字段
    CommonField: {
        //创建人
        createUser: "创建人",
        //创建时间
        createDate: "创建时间",
        //状态名称
        stateName: "状态",
        //审核人
        confirmUser: "审核人",
        //审核时间
        confirmDate: "审核时间",
        //编号
        id: "编号",
        //类型
        dicType: "类型",
        //名称
        name: "名称",
        //备注
        note: "备注",
        //姓名
        userName: "姓名",
        //有效
        effective: "有效",
        //无效
        invalid: "无效",
        //联系电话
        telephoneNumber: "联系电话",
        //文件
        file: "文件",
        //验证
        validate: "验证",
        //用户名
        loginName: "用户名",
        //密码
        password: "密码",
        //原因
        reason: "原因",
        //文件名称
        fileName: "文件名称",
        //关联模块
        relationModule: "关联模块",
        //上传时间
        uploadDate: "上传时间",
        //上传人
        uploadUser: "上传人",
    },
    //公用提示
    CommonTip: {
        //请选择数据！
        chooseData: "请选择数据！",
        choose: "请选择",
        //页面内容存在改动，是否需要保存后退出？
        saveExit: "页面内容存在改动，是否需要保存后退出？",
        //状态提交失败
        submitFail: "状态提交失败",
        //状态提交成功
        submitSuccess: "状态提交成功",
        //保存成功
        saveSuccess: "保存成功",
        //保存失败
        saveFail: "保存失败",
        //删除成功
        deleteSuccess: "删除成功",
        //删除失败
        deleteFail: "删除失败",
        //添加成功
        addSuccess: "添加成功",
        //添加失败
        addFail: "添加失败",
        //格式错误
        formatError: "格式错误",
        //请选择类别
        chooseType: "请选择类别",
        //请先选择数据！
        chooseDataFirst: "请先选择数据!",
        //上传成功！
        uploadSuccess: "上传成功！",
        //上传失败！
        uploadFail: "上传失败！",
        //已取消上传！
        uploadCancel: "已取消上传！",
        //生成成功
        generateSuccess: "生成成功！",
        //生成失败
        generateFail: "生成失败！",
        //请先保存
        saveFirst: "请先保存！",
        //是否确认删除？
        deleteConfirm: "是否确认删除？",
        //没有数据
        noData: "没有数据",
        //数据加载中
        dataing: "加载数据中",
        //页面数据存在改动，需要保存后提交！
        saveSubmit: "页面数据存在改动，需要保存后提交！",
        //提交失败
        submitFails: "提交失败",
        //提交成功
        submitSuccesss: "提交成功",
        //请选择审核人
        chooseConfirmUser: "请选择审核人",
        //请选择类型为图片的文件
        chooseImage: "请选择类型为图片的文件",
        //操作成功
        operationSuccess: "操作成功",
        //操作失败
        operationFail: "操作失败",
        //验证失败
        validateFail: "验证失败",
        //验证成功
        validateSuccess: "验证成功",
        //名称不能为空
        nameNotNull: "名称不能为空",
        //状态不能为空
        stateNotNull: "状态不能为空",
    },

    //仪器调整
    instrumentAdjustment: {
        //仪器调整
        instrumentAdjustment: "仪器调整",
        //仪器编号
        instrumentId: "仪器编号",
        //仪器名称
        instrumentName: "仪器名称",
        //调整状态
        dicNewStateId: "调整状态",
        //调整原因
        note: "调整原因",

        //仪器
        instrument: "仪器",
        //型号
        model: "型号",
        //序列号
        serialNumber: "序列号",
        //生产商
        manufacturer: "生产商",
        //仪器调整信息
        instrumentAdjustmentInformation: "仪器调整信息",
        //可用
        available: "可用",
        //不可用
        unavailable: "不可用",
        //报废
        scrapped: "报废",
        //请选择调整状态
        selectDicNewStateId: "请选择调整状态!",
        //批量添加
        batchAdd: "批量添加",
        //当前需调整仪器状态与调整状态一致，请重新选择！
        selectDicNewStateIdAgain: "当前需调整仪器状态与调整状态一致，请重新选择！",
    },


    //电子病历
    CaseHistoryEdit: {
        //电子病历
        CaseHistory: "电子病历",
        //电子病历编号
        id: "电子病历编号",
        //姓名
        name: "姓名",
        //性别
        gender: "性别",
        //申请人
        createUsers: "申请人",
        //出生日期
        dateOfBirth: "出生日期",
        //年龄
        age: "年龄",
        //婚姻
        maritalStatus: "婚姻状况",
        //微信号
        weChat: "微信号",
        //患者信息
        PatientInformation: "患者信息",
        race: "民族",
        idCard: "身份证",
        Native: "籍贯",
        maritalStatuss: "婚姻状况",
        address: "街道地址",
        career: "职业",
        email: "邮箱",
        hospitals: "医院信息",
        customer: "医院",
        department: "科室/部门",
        doctor: "医生",
        history: "相关病史",
        infectiousDiseases: "传染病史",
        yes: "是",
        no: "否",
        unknown: "未知",
        enter1: "请输入传染病史",
        historyOfSmoking: "吸烟史",
        enter2: "请输入吸烟史",
        environment: "环境风险",
        enter3: "请输入环境风险",
        drink: "饮酒史",
        drinktext: "请输入饮酒史",
        otherDiseases: "其他疾病",
        otherDiseasestext: "请输入其他疾病",
        text: "沟通信息",
        delete1: "删除明细",
        Id: "Id",
        CMethods: "沟通方式",
        CTheme: "沟通主题",
        CContent: "沟通内容",
        CTime: "沟通时间",
        Payment: "收款金额",
        Subsequent: "后续安排",
        Our: "我方参加人",
        Customer: "客户方参加人",
        note: "备注",
        createUser: "创建人",
        createDate: "创建时间",

        man: "男",
        woman: "女",

        Order: "订单信息",
        information: "临床样本信息",
        HPO: "HPO",

        Charge: "确认收费",
        Payment1: "是否收费",

        Payment2: "未付款",
        Payment3: "已付款",
        Payment4: "付款款金额",
        PaymentTime: "付款时间",
        PaymentMethod: "付款方式",
        MonthlySettlement: "月结",
        FeeDescription: "收费说明",
        ReceiptNumber: "收据号",
        POSNumber: "POS号",
        RefundTime: "退款时间",
        InvoiceNumber: "发票号",
        InvoiceHeader: "发票抬头",
        InvoicingTime: "开票时间",
        AlipayAccount: "支付宝号",
        ReceivedAmount: "到账金额",
        state: "状态",
        success: "支付成功",
        error: "支付失败",
        financialStaff: "财务人员",
        TestingItems: "产品名称",
        salesman: "业务员",
        //检测项目
        productName: "产品名称",
        zipCode: "邮编",
        Sales: "销售代表",
        Number1: "电子病历编号",
        FamilyNumber: "家族编号",
        Family: "家族联系人",
        FamilyPhone: "家属联系人电话",
        FamilyAddress: "家属联系人地址",
        medicalInstitution: "医疗机构",

        SampleNumber: "样本编号",
        SampleType: "样本类型",
        Name1: "姓名/名称",
        entryName: "项目名称",
        StatusName: "状态名称",
        orderNumber: "订单编号",
        MedicalNumber: "病历号(Research)",

        name2: "名称",
        person2: "负责人",
        payment3: "付款",
        cancel: "取消",
        Paid: "已付款未提交",
        Monthly: "月付",
        Delayed: "延迟收费",
        contact: "联系方式",

        SDeleted: "删除成功",
        SSaved1: "保存成功",
        SaveFailedInfo: "保存失败",
        SSaved2: "保存HPO成功",
        Tips: "提示",
        Please: "请先保存",
        Please1: "请选择调理状态",
        Please2: "存在数据重复添加",
        Please3: "请先选择一条数据",
        Submit: "状态提交失败",
        Submit1: "状态提交成功",
        //请输入正确的身份证号!
        enterIdCard: "请输入正确的身份证号!",
        //格式错误!
        formatError: "格式错误!",
        //只能输入整数数字!
        enterInteger: "只能输入整数数字!",
        //邮箱格式不正确，请重新输入!
        enterEmail: "邮箱格式不正确，请重新输入!",
        //联系电话1
        telephoneNumber1: "联系电话1",
        //联系电话2
        telephoneNumber2: "联系电话2",
        //请填写小于或等于当前日期的出生日期
        telephoneNumber3: "请填写小于或等于当前日期的出生日期",

        //已接收
        received: "已接收",
        //未接收
        unreceived: "未接收",
        //姓名不能为空
        nameIsNotNull: "姓名不能为空",
        ageIsNotNull: "年龄不能为空",
        //年龄只能输入正整数
        ageIsInteger: "年龄只能输入正整数",
        //性别不能为空
        genderIsNotNull: "性别不能为空",

    },

    //快递公司
    expressCompanyEdit: {
        //快递公司
        expressCompany: "快递公司",
        choosExpressCompany: "请选择公司",
        id: "编号",
        address: "地址",
        name: "名称",
        phone: "联系电话",
        print_path: "打印路径",
        state: "状态",
    },

    //  HPOdatabase
    HPOdatabaseEdit: {
        hPOdatabaseId: "hPOdatabaseId",
        btId: "btId",//标题
        subheadings: "subheadings",//副标题
        phenoType1: "phenoType1",//特征1
        phenoType2: "phenoType2",//特征2
        phenoType3: "phenoType3",//特征3
        phenoType4: "phenoType4",//特征4
        phenoType5: "phenoType5",//特征5
        featureType: "featureType",//特征类型
        featurePath: "featurePath",//特征路径
        eomId: "eomId",//EOMID
        hpoId: "hpoId",//HPOID
        ichptId: "ichptId",//ICD10ID
    },

    //项目管理模块
    ProjectManagement: {
        projectManagement: "项目管理",
        id: "项目编号",
        name: "项目名称",
        type: "类型",
        dutyUserName: "项目负责人",
        planStartDate: "开始时间",
        planEndDate: "预计交付时间",
        factEndDate: "实际交付时间",
        sumScale: "汇款总比例",
        note: "项目描述",
        projectProgress: "完成进度",
        state: "状态",
        createUserName: "创建人",
        createDate: "创建时间",
        start: "开始",
        noStart: "未开始",
        sellUserName: "项目销售",
        money: "项目金额",
        pleaseSelectedData: "请选择数据！",
        dicTypeName: "名称",
        dialogUsername: "用户名",
        dialogName: "姓名",
        confirmUserBtn: "确认选择",
        uploadFile: "上传附件",
        viewFileTask: "查看附件",
        dialogFileName: "文件名",
        fuction: "所属模块",
        uploadTime: "文件上传时间",
        uploadUser: "上传人",
        uploadFileSuccess: "上传附件成功",
        uploadFileFail: "上传附件失败",
        previewPicture: "预览(图片)",
        pleaseSelectOneData: "请选择一条数据",
        image: "查看图片",
        delete: "删除",
        titleTips: "提示",
        pleaseConfirm: "请确认是否继续删除",
        deleteSuccess: "删除成功",
        deleteCancel: "取消删除",
        projectOrderTitle: "项目订单",
        projectOrderId: "编号",
        projectOrderName: "项目订单名称",
        productId: "产品编号",
        productName: "产品名称",
        sampleNum: "样本数量",
        contactUser: "联系人",
        completeNum: "完成数量",
        projectOrderChart: "项目订单数量柱状图",
        outstandingQuantity: "未完成数量",
        quantityCompleted: "已完成数量",
        projectOrderChartId: "项目订单编号",
        save: "保存",
        list: "列表",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        //项目编号不能为空
        projectNumber: "项目编号不能为空",
        //项目编号只能输入大写字母和数字
        projectNumber1: "项目编号只能输入大写字母和数字",
        //项目名称不能为空
        projectName: "项目名称不能为空",
        //汇款总比例只能输入正数数字
        sumScales: "汇款总比例只能输入正数数字",
        //项目金额只能输入正数数字
        projectMoney: "项目金额只能输入正数数字",
        //预计交付时间需要大于开始时间
        planStartDates: "预计交付时间需要大于开始时间",
        //实际交付时间需要大于开始时间
        factEndDates: "实际交付时间需要大于开始时间",
        //请选择类型为图片的文件
        pleaseSelectImage: "请选择类型为图片的文件",

        outState: "发送状态",
    },
    //项目订单模块
    ProjectOrder: {
        projectOrder: "项目订单",
        id: "订单编号",
        name: "订单名称",
        projectId: "项目编号",
        projectName: "项目名称",
        createUserName: "创建人",
        createDate: "创建时间",
        total: "项目总价",
        stateName: "状态",
        start: "开始",
        noStart: "未开始",
        contactUser: "联系人",
        contactPhone: "联系电话",
        sampleNum: "应收数量",
        receiveNum: "已收数量",
        completeNum: "完成数量",
        pleaseSelectedData: "请选择数据！",
        dialogName: "姓名",
        uploadFile: "上传附件",
        viewFileTask: "查看附件",
        dialogFileName: "文件名",
        fuction: "所属模块",
        uploadTime: "文件上传时间",
        uploadUser: "上传人",
        uploadFileSuccess: "上传附件成功",
        uploadFileFail: "上传附件失败",
        previewPicture: "预览(图片)",
        pleaseSelectOneData: "请选择一条数据",
        image: "查看图片",
        delete: "删除",
        titleTips: "提示",
        pleaseConfirm: "请确认是否继续删除",
        deleteSuccess: "删除成功",
        deleteCancel: "取消删除",
        save: "保存",
        list: "列表",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        ProjectOrderDetails: "项目订单明细表",
        sampleCode: "样本编号",
        productId: "产品编号",
        productName: "产品名称",
        sampleTypeName: "样本类型",
        receiveUserName: "接收人",
        receiveDate: "接收时间",
        sampleState: "样本状态",
        //订单编号不能为空
        sampleOrderIdisnull: "订单编号不能为空",
        //订单编号只能输入大写字母和数字
        sampleOrderIdisError: "订单编号只能输入大写字母和数字",
        //应收数量或完成数量不能为空
        sampleNumisnull: "应收数量不能为空",
        sampleNumisnull2: "完成数量不能为空",
        //应收数量和完成数量只能输入正数数字
        sampleNumisError: "应收数量只能输入正数数字",
        sampleNumisError22: "完成数量只能输入正数数字",
        //应收数量应大于等于完成数量
        sampleNumisError2: "应收数量应大于等于完成数量",
        //请输入有效的联系电话！
        contactPhoneisError: "请输入有效的联系电话！",
    },
    //项目绑定模块
    ClaimSample: {
        claimSample: "项目绑定",
        log1: ":用户:*1在编号为",
        log2: "的数据中上传了附件,附件名为:",
        id: "项目绑定编号",
        name: "描述",
        note: "备注",
        createUserName: "创建人",
        createDate: "创建时间",
        stateName: "状态",
        confirmUserName: "审核人",
        confirmDate: "审核时间",
        pleaseSelectedData: "请选择数据！",
        uploadFile: "上传附件",
        viewFileTask: "查看附件",
        dialogFileName: "文件名",
        fuction: "所属模块",
        uploadTime: "文件上传时间",
        uploadUser: "上传人",
        uploadFileSuccess: "上传附件成功",
        uploadFileFail: "上传附件失败",
        previewPicture: "预览(图片)",
        pleaseSelectOneData: "请选择一条数据",
        image: "查看图片",
        delete: "删除",
        titleTips: "提示",
        pleaseConfirm: "请确认是否继续删除",
        deleteSuccess: "删除成功",
        deleteCancel: "取消删除",
        totalSamples: "在库总样本",
        addItems: "添加明细",
        unboundSamples: "未绑定样本",
        boundSample: "已绑定样本",
        code: "样本编号",
        sampleCode: "原始样本编号",
        barCode: "条形码",
        productId: "产品编号",
        productName: "产品名称",
        sampleType: "样本类型",
        projectId: "项目编号",
        projectName: "项目名称",
        projectOrderId: "项目订单编号",
        projectOrderName: "项目订单名称",
        pleaseSaveTask: "请先保存主表信息",
        addSuccess: "添加成功",
        addFail: "添加失败",
        boundSampleItem: "绑定样本明细",
        batchProject: "批量项目",
        batchProjectOrder: "批量订单",
        save: "保存",
        list: "列表",
        submit: "提交",
        changeState: "状态",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        passwordError: "密码错误",
        selectData: "请选择数据后点击按钮操作",
        selectSameProject: "请勾选项目编号相同的数据后点击按钮操作",
        selectProjectBefor: "请先选择项目后进行操作",
        verification: "验证",
        username: "用户名",
        password: "密码",
        reason: "原因",
        confirmBtn: "确定",
        bl: "办理",
        //请选择类型为图片的文件
        pleaseSelectImage: "请选择类型为图片的文件",
    },

    //任务单模块
    Ticket: {
        ticket: "任务单",
        id: "编号",
        name: "描述",
        note: "备注",
        orderType: "任务单类型",
        createUserName: "创建人",
        createDate: "创建时间",
        confirmUserName: "审核人",
        confirmDate: "审核时间",
        stateName: "状态",
        userGroup: "实验组",
        testUser: "实验员",
        uploadFile: "上传附件",
        viewFileTask: "查看附件",
        dialogFileName: "文件名",
        fuction: "所属模块",
        uploadTime: "文件上传时间",
        uploadUser: "上传人",
        uploadFileSuccess: "上传附件成功",
        uploadFileFail: "上传附件失败",
        previewPicture: "预览(图片)",
        pleaseSelectOneData: "请选择一条数据",
        image: "查看图片",
        delete: "删除",
        titleTips: "提示",
        pleaseConfirm: "请确认是否继续删除",
        deleteSuccess: "删除成功",
        deleteCancel: "取消删除",
        sampleInfoIn: "在库总样本",
        code: "样本编号",
        sampleCode: "原始样本编号",
        barCode: "条形码",
        productId: "产品编号",
        productName: "产品名称",
        sampleType: "样本类型",
        projectId: "项目编号",
        projectName: "项目名称",
        addItems: "添加明细",
        pleaseSaveTask: "请先保存主表信息",
        addSuccess: "添加成功",
        addFail: "添加失败",
        ticketItem: "任务明细",
        nextFlowId: "下一步流向编号",
        nextFlowName: "下一步流向名称",
        selectItem: "请先选择任务明细数据",
        pleaseSelectedData: "请选择数据！",
        dicTypeName: "类型名称",
        userGroupName: "实验组",
        testUserName: "实验员",
        verification: "验证",
        username: "用户名",
        password: "密码",
        reason: "原因",
        confirmBtn: "确定",
        save: "保存",
        list: "列表",
        submit: "提交",
        changeState: "状态",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        passwordError: "密码错误",
        pleaseChooseTestGroup: "请先选择实验组",
        batchInput: "批量录入",
        //请选择类型为图片的文件
        pleaseSelectImage: "请选择类型为图片的文件",
    },

    //研发项目
    RdProjectEdit: {
        title: "研发项目",

        id: "项目编号",
        name: "项目名称",
        projectLeader: "项目负责人",
        projectGroupUser: "项目组成员",
        startDate: "开始日期",
        predictDeliveryDate: "预计交付日期",
        actualDeliveryDate: "实际交付日期",
        finishPercent: "完成进度",
        stateName: "状态",
        createUserName: "创建人",
        createDate: "创建时间",
        note: "备注",

        save: "保存",
        list: "列表",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        updateSuccess: "修改成功",
        updateFail: "修改失败",

        projectNameIsNull: "项目名称不能为空",
        projectLeaderIsNull: "项目负责人不能为空",
        projectGroupUserIsNull: "项目组成员不能为空",
        startDateIsNull: "开始日期不能为空",
        predictDeliveryDateIsNull: "预计交付日期不能为空",
        actualDeliveryDateIsNull: "实际交付日期不能为空",
        stateIsNull: "状态不能为空",
        projectIdIsError: "项目编号只允许字母或数字",
        rdProjectIdRepeat: "项目编号已存在，请重新输入",

        batchAdd: "批量添加",
        start: "开始",
        complete: "完成",
        pause: "暂停",
        cancel: "作废",

        processConfig: "流程配置",
        processConfigDetail: "流程配置明细",
        processNodeDetail: "流程节点明细",
        viewExperimentDetail: "查看实验明细",
        sampleList: "样本列表",
        process: "流程节点",
        experimentNo: "实验编号",
        experimentDetail: "实验明细",
        experimentPaperNo: "实验单编号",
        experimentPaperName: "实验单名称",
        experimentType: "实验类型",
        finish: "是否完成",

        externalSampleCode: "外部样本编号",
        sampleCode: "样本编号",
        username: "姓名",
        gender: "性别",
        gender0: "女",
        gender1: "男",
        gender2: "未知",
        sampleType: "样本类型",
        samplingDate: "采样时间",
        validityDate: "有效期（天）",
        expireDate: "到期时间",
        site: "采样部位",
        sampleNum: "采样量",
        unit: "单位",
        result: "结果",
        result1: "合格",
        result2: "不合格",
        nextFlowId: "下一步流向",
        plateNo: "板号",
        position: "位置",
        note1: "备注",
        serialNo: "序号",
    },

    //培训计划
    TrainingPlan: {
        trainingPlan: "培训计划",
        id: "培训计划编号",
        trainingName: "描述",
        trainingTypeName: "培训类型",
        trainingEffectiveness: "培训时效",
        trainingRemind: "提醒天数",
        trainingDuration: "培训时长(小时)",
        trainingModusName: "培训方式",
        trainingTeacher: "培训讲师",
        note: "备注",
        createUserName: "申请人",
        createDate: "创建时间",
        confirmUserName: "批准人",
        confirmDate: "批准时间",
        stateName: "状态",
        uploadFile: "上传附件",
        viewFileTask: "查看附件",
        dialogFileName: "文件名",
        fuction: "所属模块",
        uploadTime: "文件上传时间",
        uploadUser: "上传人",
        uploadFileSuccess: "上传附件成功",
        uploadFileFail: "上传附件失败",
        previewPicture: "预览(图片)",
        pleaseSelectOneData: "请选择一条数据",
        image: "查看图片",
        delete: "删除",
        titleTips: "提示",
        pleaseConfirm: "请确认是否继续删除",
        deleteSuccess: "删除成功",
        deleteCancel: "取消删除",
        pleaseSelectedData: "请选择数据！",
        fileId: "资料编号",
        fileName: "资料名称",
        editQuestions: "编辑考题",
        questionType: "类型",
        questionContent: "题目内容",
        answerOptions: "答案选项",
        addOption: "添加选项",
        verification: "验证",
        username: "用户名",
        password: "密码",
        reason: "原因",
        confirmBtn: "确定",
        save: "保存",
        list: "列表",
        submit: "提交",
        changeState: "状态",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        passwordError: "密码错误",
        dicTypeName: "名称",
        dialogName: "姓名",
        participantUserId: "用户名",
        participantUserName: "姓名",
        trainingUserGroupBtn: "培训组",
        trainingUserBtn: "培训人",
        fileid: "资料编号",
        documentName: "资料明细",
        fileNames: "资料名称",
        batchInput: "批量录入",
        knowledgeBtn: "知识中心",
        documentBtn: "文档主数据",
        viewFileBtn: "查看资料",
        questionCode: "考题编号",
        options: "选项",
        standardAnswer: "标准答案",
        bindingFile: "资料绑定",
        userGroupName: "名称",
        userGroupNote: "备注",
        trainingItem: "被培训人",
        trainingDataItem: "培训资料",
        trainingQuestionsItem: "考题",
        fileItem: "资料明细",
        singleChoice: "单选题",
        multipleChoice: "多选题",
        judgment: "判断题",
        right: "对",
        wrong: "错",
        qualified: "合格",
        disqualification: "不合格",
        na: "N/A",
        //提醒天数不能为空
        trainingRemindNotNull: "提醒天数不能为空",
        //培训时长不能为空
        trainingDurationNotNull: "培训时长不能为空",
        //提醒天数需要填写正整数
        trainingRemindTips: "提醒天数需要填写正整数",
        //培训时长需要填写正整数
        trainingDurationTips: "培训时长需要填写正数",

        confirmUserNameNotNull: "批准人不能为空",
        complete: "完成",
        new: "新建",
        assessing: "审核中",
        trainingEffectivenessNotNull: "培训时效需要填写正数",
        changeSuccess: "状态修改成功",
        changeFail: "状态修改失败",
        //请先保存
        saveFirst: "请先保存！",
        //账号错误
        accountError: "账号错误",
        //验证失败
        validateFail: "验证失败",
        fileExist: "资料已录入",
    },
    //培训记录
    TrainingRecord: {
        trainingRecord: "培训记录",
        log1: "培训记录:用户:*1在编号为",
        log2: "的数据中上传了附件,附件名为:",
        id: "培训记录编号",
        trainingPlanId: "培训计划编号",
        trainingPlanName: "培训计划名称",
        submitSuccess: "提交成功",
        submitFail: "提交失败",
        confirmUserNameNotNull: "批准人不能为空",
        trainingPlanNotNull: "培训计划编号不能为空",
        trainingDurationNotNull: "培训记录培训时长不能为空",
        trainingDurationTips: "培训记录培训时长需要填写正数",
        trainingName: "描述",
        trainingModus: "培训方式",
        trainingEffectiveness: "培训时效",
        trainingRemind: "提醒天数",
        trainingDuration: "培训时长(小时)",
        //培训记录时长(小时)
        trainingRecordDuration: "培训记录培训时长(小时)",
        trainingTeacher: "培训讲师",
        createUserName: "申请人",
        createDate: "创建时间",
        confirmUserName: "批准人",
        confirmDate: "批准时间",
        stateName: "状态",
        uploadFile: "上传附件",
        viewFileTask: "查看附件",
        dialogFileName: "文件名",
        fuction: "所属模块",
        uploadTime: "文件上传时间",
        uploadUser: "上传人",
        uploadFileSuccess: "上传附件成功",
        uploadFileFail: "上传附件失败",
        previewPicture: "预览(图片)",
        pleaseSelectOneData: "请选择一条数据",
        image: "查看图片",
        delete: "删除",
        titleTips: "提示",
        pleaseConfirm: "请确认是否继续删除",
        deleteSuccess: "删除成功",
        deleteCancel: "取消删除",
        pleaseSelectedData: "请选择数据！",
        name: "姓名",
        participantUserId: "用户名",
        participantUserName: "姓名",
        fileid: "资料编号",
        assessResult: "考核结果",
        qualified: "合格",
        disqualification: "不合格",
        na: "N/A",
        trainingRecordQuestionsItem: "考题",
        startTest: "开始考试",
        viewQuestions: "查看题目",
        questionCode: "考题编号",
        fileId: "考题归属资料",
        questionType: "类型",
        questionContent: "题目内容",
        options: "选项",
        standardAnswer: "标准答案",
        batchInput: "批量录入",
        assessmentAnswer: "考核答案",
        achievement: "成绩",
        trainingRecordAnswerItem: "考核",
        submitAnswer: "提交答案",
        writeAnswer: "答题",
        verification: "验证",
        username: "用户名",
        password: "密码",
        reason: "原因",
        confirmBtn: "确定",
        save: "保存",
        list: "列表",
        submit: "提交",
        changeState: "状态",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        passwordError: "密码错误",
        singleChoice: "单选题",
        multipleChoice: "多选题",
        judgment: "判断题",
        right: "对",
        wrong: "错",
        startTestSuccess: "开始考试成功",
        startTestFail: "开始考试失败",
        pass: "通过",
        fail: "不合格,请再次答题后重新提交答案",
        firstQuestion: "已经是当前页第一题",
        lastQuestion: "已经是当前页最后一题",
        viewItemFile: "查看资料",
        trainingRecordItem: "培训明细",
        complete: "完成",
        new: "新建",
        assessing: "考核中",
        // 选择培训计划编号失败
        selectTrainingPlanIdFail: "选择培训计划编号失败",
        changeSuccess: "状态修改成功",
        changeFail: "状态修改失败",
        //请先保存
        saveFirst: "请先保存！",
        //账号错误
        accountError: "账号错误",
        //验证失败
        validateFail: "验证失败",
        //该培训计划已经完成培训不能再次进行培训
        trainingPlanComplete: "该培训计划已经完成培训不能再次进行培训",
        noUser: "该培训记录没有您的培训信息",
        assessed: "考核完成",
    },
    //报告生成
    Report: {
        //报告生成
        report: "报告生成",
        //报告生成
        report2: "报告生成-明细",
        //描述
        name: "描述",
        //报告时间
        reportDate: "报告时间",
        //报告模板
        reportTemplate: "报告模板",
        //报告人
        reportUser: "报告人",
        //订单不存在无法完成！
        orderNotExist: "订单不存在无法完成！",
        //明细
        reportItem: "明细",
        //样本编号
        sampleCode: "样本编号",
        //生成报告
        generateReport: "生成报告",
        //订单号
        projectOrderId: "订单号",
        //预览报告
        previewReport: "预览报告",
        //检测项目
        productName: "产品名称",
        //下载报告
        downloadReport: "下载报告",
        //上传报告
        uploadReport: "上传报告",
        //请先选择报告模板！
        selectReportTemplate: "请先选择报告模板！",
        //继续上传会覆盖当前报告，请确认！
        confirmUpload: "继续上传会覆盖当前报告，请确认！",
        //请先填写报告时间后在保存
        reportDateNotNull: "请先填写报告时间后保存！",
    },
    //知识中心
    KnowledgeCenter: {
        knowledgeCenter: "知识中心",
        log1: "知识中心:用户:*1在编号为",
        log2: "的资料中上传了附件,附件名为:",
        save: "保存",
        operationBtns: "操作",
        viewfile: "查看附件",
        delete: "删除选中",
        pleaseSelectedData: "请选择数据！",
        confirmBtn: "确认选择",
        bingFile: "绑定资料",
        fileId: "资料编号",
        fileName: "资料名称",
        fileItem: "资料明细",
        note: "备注",
        createUserName: "创建人",
        createDate: "创建时间",
        state: "状态",
        valid: "有效",
        invalid: "无效",
        dialogFileName: "文件名",
        fuction: "所属模块",
        uploadTime: "文件上传时间",
        uploadUser: "上传人",
        pleaseSelectOneData: "请选择一条数据",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        uploadFileSuccess: "上传附件成功",
        uploadFileFail: "上传附件失败",
        titleTips: "提示",
        pleaseConfirm: "请确认是否继续删除",
        deleteSuccess: "删除成功",
        deleteCancel: "取消删除",
        pleaseSave: "请先保存",

    },


    //报告发送
    ReportSend: {
        //报告发送
        reportSend: "报告发送",
        //病历号
        medicalRecordCode: "病历号",
        //报告筛选
        reportFilter: "报告筛选",
        //待发送
        waitSend: "待发送",
        //订单号
        projectOrderId: "订单编号",
        //已发送
        hasSend: "已发送",
        //已撤销
        hasRecall: "已撤销",
        noRecall: "待发送报告无法撤回",
        hasRecall2: "已撤回报告无法再次撤回",
        pleaseInputCorrectEmail: "请输入正确的邮箱",
        //全部
        all: "全部",
        //名称
        name: "名称",
        //条形码
        barcode: "条形码",
        sendState: "发送方式",
        sendUser: "发送人",
        sendDate: "发送时间",
        //检测项目
        productName: "产品名称",
        //查看报告
        viewReport: "查看报告",
        //该数据还没有生成报告文件，无法进行预览！
        noReport: "该数据还没有生成报告文件，无法进行预览！",
		//发送方式
        sendType: "发送类型",
        //线上发送
        onlineSend: "线上发送",
        //批量发送
        batchSend: "发送至邮箱",
        //推送至小程序
        pushSend: "推送至小程序",
        //撤销
        recall: "撤销",
        //修改邮箱
        editEmail: "填写邮箱",
        //订单编号
        projectOrderIds: "订单编号",
        //线下发送
        offlineSend: "线下发送",
        //未选择发送方式，请选择后再次进行发送！
        noSendType: "未选择发送类型，请选择后再次进行发送！",
		//是否发送
        isSend: "是否发送",
        //未填写邮箱，无法进行线上发送！
        noEmail: "未填写邮箱，无法进行线上发送！",
		//邮箱
        email: "邮箱",
        //已发送报告无法再次进行发送！
        hasSendReport: "已发送报告无法再次进行发送！",
		//报告完成时间
        reportCompleteDate: "报告完成时间",
        //发送成功！
        sendSuccess: "发送成功！",
		//发送报告时间
        reportSendDate: "发送报告时间",
        //发送失败！
        sendFail: "发送失败！",
		//快递公司
        expressCompany: "快递公司",
        //发送
        send: "发送",
        //快递单号
        expressCompanyId: "快递单号",
        //备注
        note: "备注",
        //撤回原因
        recallReason: "撤回原因",
        refundUser: "撤回人",
        refundDate: "撤回时间",
        //处理人
        dealUser: "处理人",
        //处理时间
        dealDate: "处理时间",
        viewAttachments: "查看附件",
        //在线查看
        onlineView: "在线查看",
        //请选择一条数据
        pleaseSelectOneData: "请选择一条数据",
        pleaseInputRecallReason: "请输入撤回原因",
        //撤销成功
        recallSuccess: "撤销成功",
        //撤销失败
        recallFail: "撤销失败",
        //该订单未在待对账明细内，无法进行撤销！
        noRecall2: "该报告在对账或已对账，无法进行撤销！",
        noRecall3: "该报告在供应商结算，无法进行撤销！",
        //发送类型不能为空
        sendTypeNotNull: "发送类型不能为空",
        sampleCode:"样本编号",
    },
    COITraceability: {
        title: "Coi追溯列表",
        orderNumber: "订单编号",
        batch:"批指令编号",
        operatingRoom:"操作房间",
        operator:"操作人",
        estimatedTime:"预计用时",
        startTime:"开始时间",
        endTime:"结束时间",
        wendutiaojian:"运输温度条件",
        quyangren:"取样人",
        shoujihao:"手机号码",
        quyangdizhi:"取样地址",
        phone:"物流联系方式",
        logisticsCompanies:"物流公司",
        logisticsPerson:"快递员",
        logisticsOrderId:"快递单号",
        transportCondition:"运输方式",
        wendujiguanbi:"温度计关闭时间",
        jieshouren:"接收人",
        jieshoushjiian:"接收时间",
        codeScanningRecord:"扫码记录",
        value:"值：",
        codeScanningTime:"扫码时间：",
        returnReason: "退回原因",
        codeScanningframe: "扫码框",
        ID: "编号：",
        orderForGoods: "订单",
        processExecution: "流程执行",
        document: "文件",
        close: "关闭",
        selectMaterials: "选择物料",
        executionTable: "当前流程执行表",
        Strombestellung: "当前订单",
        list: "列表",
        returnSuccessful: "退回成功",
        sendBack: "退回",
        reasonForReturn: "请输入退回原因",
        applicationNumber: "申请单编号",
        productName: "产品名称",
        estimatedAcquisitionTime: "预计采集时间",
        samplingFrequency: "取样次数",
        founder: "创建人",
        creationTime: "创建时间",
        state: "状态",
        sampleState: "样本状态",
        frozenBoxLabel: "冻存盒标签",
        bagLabel: "产品袋标签",
        //提示
        tips: "提示",
        //请完成所有步骤
        completeAllSteps: "请完成所有步骤",
        //完成
        complete: "完成",
        //'确认成功'
        confirmSuccess: "确认成功",
        //'作废成功'
        invalidSuccess: "作废成功",
        //入库成功！
        storageSuccess: "入库成功！",
        //入库失败！
        storageFail: "入库失败！",
        //请填写批次
        pleaseBatch: "请填写批次",
        //出库成功!
        outSuccess: "出库成功!",
        //出库失败!
        outFail: "出库失败!",
        //没有批次，无法出库！
        noBatch: "没有批次，无法出库！",
        // "已完成"
        completed: "已完成",
        //"服务器繁忙，请稍后尝试"
        serverBusy: "服务器繁忙，请稍后尝试",
        //"网络连接失败，请重试"
        networkFail: "网络连接失败，请重试",
        //'请先保存',
        pleaseSave: "请先保存",
        //扫码成功
        scanSuccess: "扫码成功",
        //该批次已扫码
        batchScaned: "该批次已扫码",
        //扫码失败
        scanFail: "扫码失败",
        //请选择类别
        pleaseSelectCategory: "请选择类别",
        //确认
        confirm: "确认",
        //验证
        validate: "验证",
        //用户名
        userName: "用户名",
        //密码
        password: "密码",
        //原因
        reason: "原因",
        //查看附件
        viewAttachment: "查看附件",
        //文件名称
        fileName: "文件名称",
        //请输入用户名与密码
        pleaseEnterUserNameAndPassword: "请输入用户名与密码",
        //用户名或密码错误
        userNameOrPasswordError: "用户名或密码错误",
        //'新建'
        create: "新建",
        //''已退回''
        returned: "已退回",
        //审核中
        auditing: "审核中",
        //已作废
        invalid: "已作废",
        //'作废'
        repeal: "作废",
        //已发运
        shipped: "已发运",
        //已运输
        transported: "已运输",
        //录入完成
        inputCompleted: "录入完成",
        //成品已接收
        finishedProductReceived: "成品已接收",
        //成品收获
        finishedProductHarvest: "成品收获",
        //样本已接收
        sampleReceived: "样本已接收",
    },
    ProcessExecuyion: {
        //产物编码
        productCode: "产物编码",
        //数量
        quantity: "数量",
        //位置
        position: "位置",
        //请输入
        pleaseEnter: "请输入",
        //已生成入库单
        hasGenerated: "已生成入库单",
        //请选择
        pleaseSelect: "请选择",
        //查看附件
        viewAttachment: "查看附件",
        //选择物料
        selectMaterials: "选择物料",
        //出库数量
        outQuantity: "出库数量",
        //出库单位
        outUnit: "出库单位",
        //'状态'
        state: "状态",
        //"该批次物料不存在"
        batchNotExist: "该批次物料不存在",
        //物料类型错误
        materialTypeError: "物料类型错误",
        //扫码成功
        scanSuccess: "扫码成功",
        //该设备不存在
        deviceNotExist: "该设备不存在",
        //设备类型错误
        deviceTypeError: "设备类型错误",
        //用户名或密码错误
        userNameOrPasswordError: "用户名或密码错误",
        //批次号重复
        batchRepeat: "批次号重复",
        //已生成出库单
        hasGeneratedOut: "已生成出库单",
        //出库失败
        outFail: "出库失败",
        //样本接受
        sampleReceive: "样本接受",
        //成品收货
        finishedProductReceive: "成品收货",
        //成品收获
        finishedProductHarvest: "成品收获",
        //成品未入库
        finishedProductNotStorage: "成品未入库",
        //成品未出库
        finishedProductNotOut: "成品未出库",
        //删除成功
        deleteSuccess: "删除成功",
        //删除失败
        deleteFail: "删除失败",
    },
    intermediateProduct: {
        //中间产物
        intermediateProduct: "中间产物",
        //追溯码
        traceCode: "追溯码",
        //产物编码：
        productCode: "产物编码：",
        //数量：
        quantity: "数量：",
        //位置：
        position: "位置：",
        //请输入
        pleaseEnter: "请输入",
    },
    dataTable: {
        //请输入查询信息
        pleaseEnterSearchInfo: "请输入查询信息",

    },
    matetialinEdit: {
        //用户名或密码错误
        userNameOrPasswordError: "用户名或密码错误",
    },
    //检测中心异常
    experimentCenterAbnormal: {
        experimentCenterAbnormal : "检测中心异常",
    },
    SupplierAgreement:{
        supplierAgreement: "供应商协议",
        //产品信息
        productInfo: "产品信息",

        id: "供应商编号",
        name : "供应商名称",
        address : "地址",
        linkMan : "联系人",
        phone : "联系电话",
        email : "邮箱",
        bank : "开户行",
        account : "帐号",
        bankAddr : "开户行地址",
        validityStartDate : "协议有效期起",
        validityEndDate : "协议有效期止",
        supplierState : "状态",
        confirmUserName : "审核人",
        reviewerName: "复核人",
        confirmDate : "完成时间",
        stateName: "审核状态",
        state: "审核状态编码",
        createUserName : "创建人",
        createDate : "创建时间",

        valid: "有效",
        invalid: "无效",

        productId: "产品编号",
        productName: "产品名称",
        price: "合同单价（元）",
        note: "备注",

        saveSuccess: "保存成功",
        saveFail: "保存失败",
        //产品信息保存失败
        productSaveFail: "产品信息保存失败",
        selectProduct: "选择产品",
        pleaseSelectedData: "请选择数据！",
        pleaseSelectOneData: "请选择一条数据",
        priceMustBeNumber: "合同单价必须为正数",
        saveFirst: "请先保存！",
        success: "上传成功",

        fileName: "文件名称",
        uploadTime: "上传时间",
        uploadUser: "上传人",


        nameCanNotBeEmpty: "供应商名称不能为空",
        validityStartDateCanNotBeEmpty: "协议有效期起不能为空",
        validityEndDateCanNotBeEmpty: "协议有效期止不能为空",
        validityStartDateCanNotBeLaterThanValidityEndDate: "协议有效期起不能晚于协议有效期止",
        supplierStateCanNotBeEmpty: "状态不能为空",
        confirmUserCanNotBeEmpty: "审核人不能为空",
        reviewerCanNotBeEmpty: "复核人不能为空",
        productIdCanNotBeEmpty: "产品编号不能为空",
        productNameCanNotBeEmpty: "产品名称不能为空",
        priceCanNotBeEmpty: "合同单价不能为空",

        save: "保存",
        list: "列表",
        submit: "提交",
        changeState: "状态",
        handle: "办理",

        //状态完成
        stateComplete: "状态完成",

        file: "查看附件",
        upload: "上传附件",
        view: "查看附件",
        verification: "验证",
        username: "用户名",
        password: "密码",
        reason: "原因",
        confirm: "确定",
        type: "请选择类别",
        submitSuccess: "提交成功",
        submitFail: "提交失败",
        phoneFormatError: "请输入有效的联系电话！",
        emailFormatError: "请输入有效的邮箱！",
    },
    AgreementManager:{
        agreementManager: "协议管理",
        productInfo: "产品信息",

        id: "编号",
        name: "代理商名称",
        principal: "法人",
        phone: "公司电话",
        address: "公司地址",
        bank: "开户银行",
        bankAccount: "银行账户",
        bankAccountNo: "银行账号",
        linkMan: "联系人",
        linkManPhone: "联系人电话",
        validityStartDate: "签约有效期起",
        validityEndDate: "签约有效期止",
        hospitalName: "送检医院",
        createUserName: "创建人",
        createDate: "创建日期",
        agreementState: "状态",
        confirmUserName: "审核人",
        reviewerName: "复核人",
        confirmDate: "完成时间",
        stateName: "审核状态",
        paymentTerms: "付款条件",
        note: "备注",

        save: "保存",
        list: "列表",
        submit: "提交",
        changeState: "状态",
        handle: "办理",
        valid: "有效",
        invalid: "无效",

        saveSuccess: "保存成功",
        saveFail: "保存失败",
        //产品信息保存失败
        productSaveFail: "产品信息保存失败",
        selectProduct: "选择产品",
        pleaseSelectedData: "请选择数据！",
        pleaseSelectOneData: "请选择一条数据",
        priceMustBeNumber: "合同单价必须为正数",
        saveFirst: "请先保存！",
        success: "上传成功",

        fileName: "文件名称",
        uploadTime: "上传时间",
        uploadUser: "上传人",
        productId: "产品编号",
        productName: "产品名称",
        price: "合同单价（元）",

        nameCanNotBeEmpty: "代理商名称不能为空",
        validityStartDateCanNotBeEmpty: "协议有效期起不能为空",
        validityEndDateCanNotBeEmpty: "协议有效期止不能为空",
        validityStartDateCanNotBeLaterThanValidityEndDate: "协议有效期起不能晚于协议有效期止",
        hospitalNameCanNotBeEmpty: "送检医院不能为空",
        agreementStateCanNotBeEmpty: "状态不能为空",
        confirmUserCanNotBeEmpty: "审核人不能为空",
        reviewerCanNotBeEmpty: "复核人不能为空",
        productIdCanNotBeEmpty: "产品编号不能为空",
        productNameCanNotBeEmpty: "产品名称不能为空",
        priceCanNotBeEmpty: "合同单价不能为空",
        stateComplete: "状态完成",

        file: "查看附件",
        upload: "上传附件",
        view: "查看附件",
        verification: "验证",
        username: "用户名",
        password: "密码",
        reason: "原因",
        confirm: "确定",
        type: "请选择类别",
        submitSuccess: "提交成功",
        submitFail: "提交失败",
        phoneFormatError: "请输入有效的公司电话！",
        //请输入有效的联系人电话
        linkManPhoneFormatError: "请输入有效的联系人电话！",
        //医院编号
        hospitalId: "医院编号",
        //添加医院
        addHospital: "添加医院",
        nameNotBeEmpty: "医院名称不能为空",

        hospitalname: "名称",
        street: "地址",
        postcode: "邮编",
        email: "邮箱",
        researchField: "研究领域",
        hospitalPhone: "电话",
        postCodeError: "请输入正确的邮编",
        emailError: "请输入正确的邮箱",
        phoneError: "请输入正确的电话",

    },
    //自定义模块
    CustomModule:{
        //自定义模块
        customModule: "自定义模块",
    },
    //供应商结算
    SupplierSettlement:{
        supplierSettlement: "供应商结算",
        //待结算明细
        waitSettlement: "待结算明细",
        //结算单列表
        settlementList: "结算单列表",
        //结算单明细
        settlementDetail: "结算单明细",
        //条形码
        barcode: "条形码",
        //订单编号
        orderNumber: "订单编号",
        hospital:"送检医院",
        //送检日期
        sendDate: "送检日期",
        //产品名称
        productName: "产品名称",
        //供应商编号
        supplierId: "供应商编号",
        //供应商名称
        supplierName: "供应商名称",
        //结算金额
        amount: "结算金额",
        //报告日期
        reportDate: "报告日期",
        //创建人
        createUserName: "创建人",
        //创建人用户名
        createUserId: "创建人用户名",
        //创建时间
        createDate: "创建时间",

        //结算单号
        settlementNumber: "结算单号",
        //例数
        exampleNumber: "例数",
        //结算金额
        settlementAmount: "结算金额",
        //结算日期
        settlementDate: "结算日期",
        //是否付款
        isPay: "是否付款",
        //付款确认人
        payConfirmUser: "付款确认人",
        //确认日期
        confirmDate: "确认日期",
        //备注
        note:"备注",

        //生成结算单
        generateSettlement: "生成结算单",

        //请至少选择一条数据
        pleaseSelectOneData: "请至少选择一条数据",
        //是否生成新的结算单
        isGenerateNewSettlement: "是否生成新的结算单",
        pleaseSelectSameSupplier: "请选择相同的供应商",
        save: "保存",
        yes: "是",
        no: "否",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        //添加订单
        addOrder: "添加订单",
        //付款确认
        payConfirm: "付款确认",
        //结算单号为：
        settlementNumberIs: "结算单号为：",
        isPaySuccess: "的结算单已付款，请选择其他结算单",
        payConfirmSuccess: "付款确认成功",
        payConfirmFail: "付款确认失败",
        //已付款的结算单无法修改
        payedSettlementCanNotEdit: "已付款的结算单无法修改",
        leadDateIsNull: "的结算日期不能为空",
        generateSuccess: "生成结算单成功",
        generateFail: "生成结算单失败",
        //请选择一条结算单
        pleaseSelectOneSettlement: "请选择一条结算单",
        //请选择一条待结算明细
        pleaseSelectOneWaitSettlement: "请选择一条待结算明细",
        //已付款的结算单无法添加订单
        payedSettlementCanNotAddOrder: "已付款的结算单无法添加订单",
        addOrderSuccess: "添加订单成功",
        addOrderFail: "添加订单失败",
        //是否确认付款
        isPayConfirm: "是否确认付款",

    },
    Invoicing:{
        invoicing: "开票管理",
        //开票明细
        invoicingDetail: "开票明细",

        id:"单据编号",
        //描述
        name: "描述",
        //开票状态
        state: "开票状态",
        //开票成功
        invoicingSuccess: "开票成功",
        //未开票
        notInvoiced: "未开票",
        //发票类型
        channelInvoiceType: "发票类型",
        //开票人
        drawer: "开票人",
        //复核人
        reviewer: "复核人",
        //收款人
        payee: "收款人",
        //联系方式
        phone: "联系方式",
        //发票抬头
        invoiceTitle: "发票抬头",
        //纳税人识别号
        registrationNum: "纳税人识别号",
        //总金额
        amount: "总金额",
        //发票内容
        invoiceContent: "发票内容",
        //地址
        addr: "地址",
        //开户行及账号
        depositBankNum: "开户行及账号",
        //开票备注
        note: "开票备注",
        //发送邮箱
        email: "发送邮箱",
        //发票流水号
        serialNum: "发票流水号",
        //创建时间
        createDate: "创建时间",
        upload: "上传附件",
        view: "查看附件",
        save: "保存",
        list: "列表",
        //全电专票
        fullElectricInvoice2: "全电专票",
        //全电普票
        fullElectricInvoice1: "全电普票",

        //订单编号
        orderNumber: "订单编号",
        //姓名
        orderName: "姓名",
        //区域
        area: "区域",
        //城市
        city: "城市",
        //销售
        sales: "销售",
        //客户姓名
        customerName: "客户姓名",
        //检测项目
        productName: "检测项目",
        //总收款金额
        totalAmount: "总收款金额",
        //选择订单
        selectOrder: "选择订单",
        //技术服务费
        technicalServiceFee: "技术服务费",
        //发票类型不能为空
        invoiceTypeCanNotBeEmpty: "发票类型不能为空",
        //开票人不能为空
        drawerCanNotBeEmpty: "开票人不能为空",
        //复核人不能为空
        reviewerCanNotBeEmpty: "复核人不能为空",
        //收款人不能为空
        payeeCanNotBeEmpty: "收款人不能为空",
        //发票抬头不能为空
        invoiceTitleCanNotBeEmpty: "发票抬头不能为空",
        //纳税人识别号不能为空
        registrationNumCanNotBeEmpty: "纳税人识别号不能为空",
        //总金额不能为空
        amountCanNotBeEmpty: "总金额不能为空",
        //发票内容不能为空
        invoiceContentCanNotBeEmpty: "发票内容不能为空",
        //地址不能为空
        addrCanNotBeEmpty: "地址不能为空",
        //保存成功
        saveSuccess: "保存成功",
        //保存失败
        saveFail: "保存失败",
        //开票明细保存失败
        invoicingDetailSaveFail: "开票明细保存失败",
        pleaseSelectedData: "请选择一条数据！",
        //添加成功
        addSuccess: "添加成功",
        //添加失败
        addFail: "添加失败",
        //查看订单
        viewOrder: "查看订单",
        pleaseSaveInvoicing: "请先保存",
        // 开票
        invoice: "开票",
        //定制功能，暂未开放
        customFunction: "定制功能，暂未开放",
        saveFirst: "请先保存！",
        success: "上传成功",
        fileName: "文件名称",
        uploadTime: "上传时间",
        uploadUser: "上传人",
        file: "查看附件",

        //发票红冲
        invoiceRed: "发票红冲",

    },
    AgencySettlement:{
        agencySettlement: "代理商结算",

        waitSettlement: "待结算明细",
        //结算单列表
        settlementList: "结算单列表",
        //结算单明细
        settlementDetail: "结算单明细",
        //编码
        id: "编码",
        barcode: "条形码",
        orderNumber: "订单编号",
        name:"姓名",
        hospital:"送检医院",
        sendDate:"送检日期",
        productName:"产品名称",
        agreementId:"代理商协议编号",
        agreementName:"代理商协议名称",
        price:"合同单价",
        amount:"结算金额",
        createUserName:"创建人",
        createDate:"创建时间",
        state:"状态",


        //结算单号
        settlementNumber: "结算单号",
        //代理商
        primary: "代理商",
        //例数
        num: "例数",
        leadDate: "结算日期",
        pay: "是否付款",
        confirmUserName: "付款确认人",
        confirmDate: "确认日期",
        note: "备注",
        //业务员
        salesman: "业务员",
        generateSettlement: "生成结算单",
        addOrder: "添加订单",
        save: "保存",
        payConfirm: "付款确认",
        pleaseSelectOneData: "请至少选择一条数据",
        isGenerateNewSettlement: "是否生成新的结算单",
        pleaseSelectOneWaitSettlement: "请选择一条待结算明细",
        payedSettlementCanNotAddOrder: "已付款的结算单无法添加订单",
        pleaseSelectSameAgency: "请选择相同的代理商",
        pleaseSelectOneSettlement: "请选择一条结算单",
        pleaseSelectSameSupplier: "请选择相同的供应商",
        yes: "是",
        no: "否",
        saveSuccess: "保存成功",
        saveFail: "保存失败",
        //结算单号为：
        settlementNumberIs: "结算单号为：",
        isPaySuccess: "的结算单已付款，请选择其他结算单",
        payConfirmSuccess: "付款确认成功",
        payConfirmFail: "付款确认失败",
        //已付款的结算单无法修改
        payedSettlementCanNotEdit: "已付款的结算单无法修改",
        leadDateIsNull: "的结算日期不能为空",
        generateSuccess: "生成结算单成功",
        generateFail: "生成结算单失败",
        addOrderSuccess: "添加订单成功",
        addOrderFail: "添加订单失败",
        //是否确认付款
        isPayConfirm: "是否确认付款",
    },
    Finance:{
        finance: "销售对账",
        waitSettlement: "待对账明细",
        settlementList: "对账单列表",
        settlementDetail: "对账单明细",

        code: "订单编号",
        barcode: "条形码",
        name: "姓名",
        productId: "产品编号",
        productName: "产品名称",
        standardPrice: "合同单价",
        discountPrice: "折后单价",
        receivables: "应收金额",
        customerName: "结算客户",
        customerId: "结算客户编号",
        projectId: "合同编号",
        doctor: "医生",
        department: "科室",
        hospital: "送检医院",
        sendDate: "送检日期",
        reportDate: "报告日期",
        saleName: "销售",
        saleId: "销售用户名",

        id: "对账单编号",
        num: "列数",
        orderAmount:"金额",
        money: "回款金额",
        discountPrice1: "现金折扣",
        leadDate:"回款日期",
        financeType:"是否对账",
        financeDate:"对账日期",
        financeUser:"对账人",
        note:"备注",

        id1:"编码",
        orderNumber: "订单编号",


        generateSettlement: "生成对账单",
        addOrder: "添加订单",
        financeConfirm: "对账确认",
        save: "保存",

        pleaseSelectOneWaitSettlement: "请选择一条待对账明细",
        isGenerateNewSettlement: "是否生成新的结算单？",
        pleaseSelectSameAgency: "请选择相同的结算客户",
        generateSuccess: "生成成功！",
        generateFail: "生成失败！",
        yes: "是",
        no: "否",
        discountPriceMustBeNumber: "现金折扣必须为正数",
        financeDetailNotEmpty: "对账明细不为空无法删除",

        saveSuccess: "保存成功",
        saveFail: "保存失败",
        pleaseSelectOneData: "请至少选择一条数据",
        settlementNumberIs: "对账单号为：",
        isPaySuccess: "的对账单已对账，请选择其他对账单",
        payConfirmSuccess: "对账确认成功",
        payConfirmFail: "对账确认失败",
        payedSettlementCanNotAddOrder: "已对账的对账单无法添加订单",
        addOrderSuccess: "添加订单成功",
        addOrderFail: "添加订单失败",
        pleaseSelectOneSettlement: "请选择一条对账单",
        batchExport: "批量导出",
        //请选择对账单
        pleaseSelectSettlement: "请选择需要导出的对账单",
        //是否确认对账
        isConfirmSettlement: "是否确认对账",
    },
    // 运输管理
    TransportManager:{

        // 运输计划
        transportPlan: "运输计划",
        //运输计划编号
        transportPlanId: "编号",
        //运输公司
        transportCompany: "运输公司",
        //运输方式
        transportType: "运输方式",
        //创建人
        createUserName: "创建人",
        //创建时间
        createDate: "创建时间",
        // 运输类型
        transportOrderType: "运输类型",
        // 运输日期
        transportDate: "运输日期",
        // 状态
        state: "状态",
        //描述
        note: "描述",
        // 物流人员
        logisticsPerson: "物流人员",
        //是否作废
        isInvalid: "是否作废",
        // 上传附件
        upload: "上传附件",
        //查看附件
        view: "查看附件",
        // 上传文件成功
        uploadsuccess: "上传成功",
        // 文件名称
        fileName: "文件名称",
        // 上传时间
        uploadTime: "上传时间",
        // 上传用户
        uploadUser: "上传用户",
        // 查看附件
        viewAttachment: "查看附件",
        // 编号不能为空，请先保存！
        transportPlanIdCanNotBeEmpty: "编号不能为空，请先保存！",
        // 请选择数据
        pleaseSelectData: "请选择数据",
        // 名称
        name: "名称",
        // 来源样本运输
        sampleTransport: "来源样本运输",
        // 订单编号
        orderNumber: "订单编号",
        // 医院
        hospital: "医院",
        // 科室
        department: "科室",
        //送达楼层
        floor: "送达楼层",
        //预计到达时间
        estimatedArrivalTime: "预计到达时间",
        //温度要求（℃）
        temperatureRequirement: "温度要求（℃）",
        // 联系人
        linkMan: "联系人",
        //联系电话
        linkmanPhone: "联系电话",
        // 是否通知
        isNotice: "是否通知",
        //是否确认
        isConfirm: "是否确认",
        //筛选号
        filterNumber: "筛选号",
        // 产品批号
        productBatchNumber: "产品批号",
        //批号
        Batch:"批号",
        //采血物品
        bloodCollectionItems: "采血物品",
        //输血器
        transfusionDevice: "输血器",
        // 轮次
        round: "轮次",
        //氯化钠注射液
        sodiumChlorideInjection: "氯化钠注射液",
        //运输单号
        transportNumber: "运输单号",
        //取血人
        bloodCollectionPerson: "取血人",
        //预计采血时间
        estimatedBloodCollectionTime: "预计采血时间",
        //运输费
        transportFee: "运输费",
        //跟车人员
        followPerson: "跟车人员",
        //待运输样本
        waitTransportSample: "待运输样本",
        //运输明细
        transportDetail: "运输明细",
        //产品
        product: "产品",
        productId: "成品编号",
        //名字
        productName: "成品名称",
        //医生
        doctor: "医生",
        //医生电话
        doctorPhone: "医生电话",
        //细胞编号
        cellNumber: "细胞编号",
        //预计回输日期
        estimatedReturnDate: "预计回输日期",
        //最低温度
        minimumTemperature: "最低温度",
        //最高温度
        maximumTemperature: "最高温度",
        //平均温度
        averageTemperature: "平均温度",
        //温度要求
        temperatureRequirements: "温度要求",
        //保温箱编号
        incubatorNumber: "保温箱编号",
        //温度计型号
        thermometerModel: "温度计型号",
        ///袋数
        bagNumber: "袋数",
        //实际签收人
        actualSignatory: "实际签收人",
        //选择订单
        selectOrder: "选择订单",
        // 请填写必填字段
        pleaseEnterRequiredFields: "请填写必填字段",
        //保存成功
        saveSuccess: "保存成功",
        // 明细表存在数据，无法进行操作
        itemInData:"明细表存在数据，无法进行操作",
        // 规格
        specification:"规格",
        //生产日期
        Datemanufacture:"生产日期",
        //入库日期
        ShippingDate:"入库日期",
        //库存量
        Inventorylevels:"库存量",
        //单位
        unit:"单位",
        //添加明细
        addDetail:"添加明细",
        //查看质检结果
        viewQualityInspectionResults:"查看质检结果",
        //当前功能正在开发
        currentFunctionIsDeveloping:"当前功能正在开发",
        //运输扫码
        transportScanCode:"运输扫码",
        //提交生产安排
        submitProductionArrangement:"提交生产安排",
        //添加成功
        addSuccess:"添加成功",
        //请填写条形码
        pleaseEnterBarcode:"请填写条形码",
        //条形码不存在
        barcodeDoesNotExist:"条形码不存在",
        //确认成功
        confirmSuccess:"确认成功",
        //是
        yes:"是",
        //否
        no:"否",

    },
    //成品交接
    FinishedProductHandover:{
        finishedProductHandover: "成品交接",
    },
    Payment:{
        payment: "到款确认",
        //对账单核销
        settlementVerification: "对账单核销",

        leadDate: "到款时间",
        customerName: "结算客户",
        customerId: "结算客户编号",
        hospital: "送检医院",
        orderAmount: "到款金额",
        money: "确认金额",
        noMoney: "未确认金额",
        createUser: "业务员",
        financeType: "财务复核",
        financeTypeUser: "财务复核人",
        financeTypeDate: "复核日期",
        note: "备注",

        //对账单编号
        financeId: "对账单编号",
        productId: "产品编号",
        productName: "产品名称",
        num: "列数",
        orderAmount1: "应收金额",
        money1: "回款金额",
        discountPrice: "现金折扣",
        //未核销金额
        noMoney1: "未核销金额",
        financeType1: "是否对账",
        financeDate: "对账日期",

        savePayment: "保存",
        //选择对账单
        selectSettlement: "选择对账单",
        //批量录入
        batchInput: "批量录入",
        //结算客户
        customer: "结算客户",
        //同步收款单
        syncPayment: "同步收款单",

        //请选择一条数据
        pleaseSelectOneData: "请选择一条数据",
        hospitalId: "医院编号",
        hospitalName: "医院名称",
        pleaseEnterANumber: "请输入正数",
        yes: "是",
        no: "否",
        //请选择到款时间
        pleaseEnterLeadDate: "请选择到款时间",
        //请选择结算客户
        pleaseSelectCustomer: "请选择结算客户",
        //保存成功
        saveSuccess: "保存成功",
        //保存失败
        saveFail: "保存失败",
        //定制功能，暂未开放
        customFunction: "定制功能，暂未开放",
        //请选择一条到款确认单
        pleaseSelectOnePayment: "请选择一条到款确认单",
        pleaseEnterCorderAmount: "请输入到款金额",
        //请先保存
        pleaseSaveFirst: "请先保存",
        //该到款确认单已核销完成无法继续添加对账单
        paymentCompleteCanNotAddSettlement: "该到款确认单已核销完成无法继续添加对账单",
        paymentCompleteCanNotEdit: "已选择对账单无法修改到款金额",
        //已选择对账单无法修改送检医院
        paymentCompleteCanNotEditHospital: "已选择对账单无法修改送检医院",
        //已选择对账单无法修改结算客户
        paymentCompleteCanNotEditCustomer: "已选择对账单无法修改结算客户",
        // 金额
        amount: "金额",
        surplusAmount: "未核销金额",
        //该订单已复核
        orderHasFinanceType: "该订单已复核",

        //选择对账单成功
        selectSettlementSuccess: "选择对账单成功",
        //选择对账单失败
        selectSettlementFail: "选择对账单失败",
        pleaseSelectNo: "请选择未复核的到款确认单",
        financeTypeSuccess: "到款确认单复核成功",
        financeTypeFail: "到款确认单复核失败",
        pleaseSelectNoMoney: "请选择已核销完成的对账单",
        //新增现金折扣超过未核销金额
        discountPriceCanNotMoreThanNoMoney: "新增现金折扣超过未核销金额",
        //是否确认复核
        isConfirmFinanceType: "是否确认复核",
    },
    plate:{
        confirmTitle: "提示",
        confirmContent: "是否复制当前步骤？",
        confirmDeleteContent: "是否删除当前步骤？",
    },
    reportFormsConfig:{
        id: '编号',
        name: '名称',
        note: '描述',
        stats: '状态',
        sqlContent: 'SQL内容',
        createTime: '创建时间',
        createBy: '创建人',
        testSql: '测试SQL',
        reportFormsConfigItem: '报表配置明細',
        fieldContent: '字段内容',
        typeContent: '类型内容',

    },
    ReportForms:{
        ReportFormsItem: '报表明细',
    }
    
}